{
  "level": "mt06",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt06",
    "objects": "AREAS.E3:mt06.e3",
    "mesh": "TREES.E3:mt06.e3"
  },
  "spawn_point": {
    "position": [
      -403.4357129697923,
      -2162.468089763605,
      615.1973876953125
    ],
    "facing_rad": 0.0,
    "look_point": [
      -403.4357129697923,
      -2062.468089763605,
      615.1973876953125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -955.4878540039062,
      -2801.961181640625,
      591.1973876953125
    ],
    "bbox_max": [
      -2.6478233337402344,
      -1907.083251953125,
      1479.6412353515625
    ],
    "vertex_count": 1779,
    "vertices": [
      [
        -194.8513946533203,
        -1920.0,
        765.0
      ],
      [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      [
        -194.8513946533203,
        -1920.0,
        754.0
      ],
      [
        -184.0,
        -1924.322509765625,
        754.0
      ],
      [
        -2.6478233337402344,
        -2001.0638427734375,
        787.21142578125
      ],
      [
        -2.6478271484375,
        -2001.0638427734375,
        1080.0
      ],
      [
        -437.40081787109375,
        -1932.2159423828125,
        892.0023193359375
      ],
      [
        -442.0,
        -1928.0,
        904.8359375
      ],
      [
        -437.40081787109375,
        -1932.2159423828125,
        892.0023193359375
      ],
      [
        -430.0,
        -1939.0,
        871.3511962890625
      ],
      [
        -430.0,
        -1939.0,
        871.3511962890625
      ],
      [
        -422.5,
        -1939.0,
        862.870361328125
      ],
      [
        -360.0,
        -1939.0,
        789.0541381835938
      ],
      [
        -369.0,
        -1939.0,
        800.2041015625
      ],
      [
        -360.0,
        -1939.0,
        789.0541381835938
      ],
      [
        -348.0,
        -1928.0,
        796.7986450195312
      ],
      [
        -417.9999694824219,
        -1950.0,
        766.0
      ],
      [
        -417.9999694824219,
        -1950.0,
        837.8663330078125
      ],
      [
        -414.0,
        -1950.0,
        833.3432006835938
      ],
      [
        -369.0,
        -1950.0,
        777.5933227539062
      ],
      [
        -369.0,
        -1939.0,
        800.2041015625
      ],
      [
        -398.94903564453125,
        -1967.46337890625,
        778.7999267578125
      ],
      [
        -369.9740295410156,
        -1950.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1953.6666259765625,
        778.7999267578125
      ],
      [
        -422.5,
        -1950.0,
        842.9549560546875
      ],
      [
        -406.8780212402344,
        -1972.0,
        778.7999267578125
      ],
      [
        -401.2017517089844,
        -1968.8211669921875,
        778.7999267578125
      ],
      [
        -406.8780212402344,
        -1972.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1972.0,
        788.1215209960938
      ],
      [
        -437.50244140625,
        -1938.574951171875,
        885.9445190429688
      ],
      [
        -435.19549560546875,
        -1934.2374267578125,
        892.0023193359375
      ],
      [
        -441.5986022949219,
        -1928.367919921875,
        912.0
      ],
      [
        -435.19549560546875,
        -1934.2374267578125,
        892.0023193359375
      ],
      [
        -433.46563720703125,
        -1935.8231201171875,
        886.5997314453125
      ],
      [
        -433.4741516113281,
        -1935.8154296875,
        881.04541015625
      ],
      [
        -435.970703125,
        -1937.517578125,
        886.2202758789062
      ],
      [
        -437.50244140625,
        -1938.574951171875,
        885.9445190429688
      ],
      [
        -435.970703125,
        -1937.517578125,
        886.2202758789062
      ],
      [
        -435.8409729003906,
        -1937.4423828125,
        886.2141723632812
      ],
      [
        -396.4644775390625,
        -1935.34716796875,
        841.7379760742188
      ],
      [
        -414.0011291503906,
        -1944.9122314453125,
        843.802490234375
      ],
      [
        -379.359375,
        -1926.01708984375,
        839.7250366210938
      ],
      [
        -382.8941955566406,
        -1927.9453125,
        840.1409301757812
      ],
      [
        -414.0011291503906,
        -1944.9122314453125,
        843.802490234375
      ],
      [
        -430.0,
        -1939.0,
        871.6710815429688
      ],
      [
        -422.5,
        -1939.0,
        863.5264282226562
      ],
      [
        -430.0,
        -1939.0,
        871.6710815429688
      ],
      [
        -433.47406005859375,
        -1935.8155517578125,
        881.0968017578125
      ],
      [
        -422.5,
        -1950.0,
        843.8737182617188
      ],
      [
        -379.359375,
        -1926.01708984375,
        839.7250366210938
      ],
      [
        -384.9010314941406,
        -1911.1502685546875,
        877.1497802734375
      ],
      [
        -430.0,
        -1939.0,
        875.7761840820312
      ],
      [
        -430.0,
        -1939.0,
        875.7761840820312
      ],
      [
        -422.5,
        -1939.0,
        866.4844970703125
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        886.0942993164062
      ],
      [
        -440.5136413574219,
        -1940.653564453125,
        896.0842895507812
      ],
      [
        -433.4573669433594,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -437.4791259765625,
        -1932.1441650390625,
        912.0
      ],
      [
        -433.4481201171875,
        -1935.8392333984375,
        898.0882568359375
      ],
      [
        -433.4573669433594,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -433.46563720703125,
        -1935.8231201171875,
        886.5997314453125
      ],
      [
        -435.970703125,
        -1937.517578125,
        897.4674682617188
      ],
      [
        -440.5136413574219,
        -1940.653564453125,
        896.0842895507812
      ],
      [
        -435.8409729003906,
        -1937.4423828125,
        886.2141723632812
      ],
      [
        -435.970703125,
        -1937.517578125,
        897.4674072265625
      ],
      [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      [
        -366.150390625,
        -1939.506103515625,
        801.436279296875
      ],
      [
        -365.45465087890625,
        -1907.9791259765625,
        874.2081909179688
      ],
      [
        -369.0,
        -1950.0,
        778.600341796875
      ],
      [
        -369.0,
        -1939.0,
        804.119384765625
      ],
      [
        -369.3772277832031,
        -1950.0,
        778.7999267578125
      ],
      [
        -370.3378601074219,
        -1950.21923828125,
        778.7999267578125
      ],
      [
        -360.0,
        -1939.0,
        794.5689697265625
      ],
      [
        -348.0,
        -1928.0,
        804.571044921875
      ],
      [
        -360.0,
        -1939.0,
        794.5689697265625
      ],
      [
        -369.0,
        -1939.0,
        804.119384765625
      ],
      [
        -366.1393737792969,
        -1939.0,
        802.6044921875
      ],
      [
        -366.150390625,
        -1939.506103515625,
        801.436279296875
      ],
      [
        -373.7200012207031,
        -1942.5078125,
        804.3280639648438
      ],
      [
        -369.0,
        -1950.787353515625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        780.6401977539062
      ],
      [
        -369.0,
        -1940.63623046875,
        802.5244750976562
      ],
      [
        -369.0,
        -1939.0,
        805.4290161132812
      ],
      [
        -369.0,
        -1949.9139404296875,
        778.7999267578125
      ],
      [
        -369.0,
        -1939.0,
        805.4290161132812
      ],
      [
        -366.64593505859375,
        -1939.0,
        802.8727416992188
      ],
      [
        -422.5,
        -1950.0,
        844.0005493164062
      ],
      [
        -414.0,
        -1950.0,
        834.7700805664062
      ],
      [
        -430.0,
        -1939.0,
        886.18798828125
      ],
      [
        -422.5,
        -1939.0,
        876.3716430664062
      ],
      [
        -369.0,
        -1939.0,
        806.3486328125
      ],
      [
        -431.6846923828125,
        -1937.4556884765625,
        892.0023193359375
      ],
      [
        -431.6846923828125,
        -1937.4556884765625,
        892.0023193359375
      ],
      [
        -430.0,
        -1939.0,
        886.18798828125
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        897.590087890625
      ],
      [
        -422.5,
        -1950.0,
        850.6632080078125
      ],
      [
        -414.0,
        -1950.0,
        839.5382080078125
      ],
      [
        -369.0,
        -1939.0,
        806.3486328125
      ],
      [
        -441.18359375,
        -1941.115966796875,
        898.3402709960938
      ],
      [
        -433.4481201171875,
        -1935.8392333984375,
        898.0882568359375
      ],
      [
        -436.69482421875,
        -1932.863037109375,
        912.0
      ],
      [
        -433.4441223144531,
        -1935.8428955078125,
        900.7531127929688
      ],
      [
        -435.970703125,
        -1937.517578125,
        900.0757446289062
      ],
      [
        -441.18359375,
        -1941.115966796875,
        898.3402709960938
      ],
      [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      [
        -435.970703125,
        -1937.517578125,
        900.07568359375
      ],
      [
        -435.51080322265625,
        -1937.2509765625,
        900.1087646484375
      ],
      [
        -407.14849853515625,
        -1972.0,
        781.3280029296875
      ],
      [
        -361.8931884765625,
        -1943.853515625,
        789.0960083007812
      ],
      [
        -365.6656188964844,
        -1917.5384521484375,
        852.1429443359375
      ],
      [
        -360.9439392089844,
        -1925.78759765625,
        830.5048217773438
      ],
      [
        -360.0,
        -1939.0,
        798.0972900390625
      ],
      [
        -348.0,
        -1928.0,
        808.5042724609375
      ],
      [
        -360.0,
        -1939.0,
        798.0972900390625
      ],
      [
        -366.1393737792969,
        -1939.0,
        802.6044921875
      ],
      [
        -361.6380920410156,
        -1939.0,
        800.220703125
      ],
      [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      [
        -300.0,
        -1920.0,
        765.1644287109375
      ],
      [
        -299.8731384277344,
        -1920.0,
        765.0
      ],
      [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      [
        -405.1982727050781,
        -1972.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1952.1192626953125,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        783.8016967773438
      ],
      [
        -369.0,
        -1939.0,
        809.7638549804688
      ],
      [
        -369.0,
        -1946.408935546875,
        792.2774658203125
      ],
      [
        -370.84454345703125,
        -1947.0721435546875,
        793.1032104492188
      ],
      [
        -369.0,
        -1940.6361083984375,
        802.52490234375
      ],
      [
        -405.1982727050781,
        -1972.0,
        778.7999267578125
      ],
      [
        -407.148681640625,
        -1972.0,
        781.3281860351562
      ],
      [
        -361.8931884765625,
        -1943.853515625,
        789.0960083007812
      ],
      [
        -369.0,
        -1939.0,
        809.7638549804688
      ],
      [
        -359.96112060546875,
        -1907.083251953125,
        873.377197265625
      ],
      [
        -422.5,
        -1950.0,
        853.15283203125
      ],
      [
        -414.0,
        -1950.0,
        842.13427734375
      ],
      [
        -430.0,
        -1939.0,
        888.8370971679688
      ],
      [
        -422.5,
        -1939.0,
        879.114990234375
      ],
      [
        -430.91485595703125,
        -1938.161376953125,
        892.0023193359375
      ],
      [
        -430.91485595703125,
        -1938.161376953125,
        892.0023193359375
      ],
      [
        -430.0,
        -1939.0,
        888.8370971679688
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        900.267578125
      ],
      [
        -414.0,
        -1972.0,
        790.2094116210938
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      [
        -433.48724365234375,
        -1935.8033447265625,
        900.9022827148438
      ],
      [
        -433.4872741699219,
        -1935.80322265625,
        912.0
      ],
      [
        -431.22930908203125,
        -1934.768798828125,
        1080.0
      ],
      [
        -434.07379150390625,
        -1936.41796875,
        960.5042114257812
      ],
      [
        -434.07379150390625,
        -1936.41796875,
        960.5042114257812
      ],
      [
        -435.51080322265625,
        -1937.2509765625,
        900.1087646484375
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      [
        -421.8410339355469,
        -1928.0,
        930.0
      ],
      [
        -433.4441223144531,
        -1935.8428955078125,
        900.7531127929688
      ],
      [
        -433.427001953125,
        -1935.8585205078125,
        912.0
      ],
      [
        -470.63055419921875,
        -2038.730712890625,
        712.0
      ],
      [
        -611.5364379882812,
        -2130.387939453125,
        712.0
      ],
      [
        -465.15191650390625,
        -2034.785888671875,
        712.0
      ],
      [
        -470.63055419921875,
        -2038.730712890625,
        712.0
      ],
      [
        -465.15191650390625,
        -2034.785888671875,
        712.0
      ],
      [
        -462.7181701660156,
        -2033.583984375,
        712.0
      ],
      [
        -99.88211059570312,
        -1968.8143310546875,
        712.0
      ],
      [
        -99.46600341796875,
        -1968.9686279296875,
        712.0
      ],
      [
        -215.28782653808594,
        -1920.0,
        765.0
      ],
      [
        -170.0,
        -1936.7972412109375,
        765.0
      ],
      [
        -198.0,
        -1927.6595458984375,
        754.0
      ],
      [
        -184.0,
        -1932.85205078125,
        754.0
      ],
      [
        -334.1983642578125,
        -1970.763427734375,
        712.0
      ],
      [
        -223.32188415527344,
        -1978.3963623046875,
        712.0
      ],
      [
        -220.34803771972656,
        -1978.3231201171875,
        712.0
      ],
      [
        -99.88211059570312,
        -1968.8143310546875,
        712.0
      ],
      [
        -223.32188415527344,
        -1978.3963623046875,
        712.0
      ],
      [
        -220.34803771972656,
        -1978.3231201171875,
        712.0
      ],
      [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      [
        -245.4150848388672,
        -1948.9671630859375,
        765.0
      ],
      [
        -224.35812377929688,
        -1948.4483642578125,
        765.0
      ],
      [
        -170.0,
        -1944.15771484375,
        765.0
      ],
      [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      [
        -300.0,
        -1942.576416015625,
        770.0
      ],
      [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      [
        -272.0,
        -1952.92919921875,
        754.0
      ],
      [
        -198.0,
        -1952.6341552734375,
        754.0
      ],
      [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      [
        -286.0,
        -1946.173095703125,
        765.0
      ],
      [
        -237.6776885986328,
        -1949.499755859375,
        765.0
      ],
      [
        -170.0,
        -1954.1588134765625,
        765.0
      ],
      [
        -198.0,
        -1958.0234375,
        754.0
      ],
      [
        -184.0,
        -1958.9871826171875,
        754.0
      ],
      [
        -335.2963562011719,
        -1971.01416015625,
        712.0
      ],
      [
        -334.1983642578125,
        -1970.763427734375,
        712.0
      ],
      [
        -360.0,
        -1939.0,
        799.3532104492188
      ],
      [
        -348.0,
        -1928.0,
        818.51708984375
      ],
      [
        -360.0,
        -1939.0,
        799.3532104492188
      ],
      [
        -361.6380920410156,
        -1939.0,
        800.220703125
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      [
        -419.5531921386719,
        -1928.0,
        930.0
      ],
      [
        -433.3037109375,
        -1935.9715576171875,
        900.267333984375
      ],
      [
        -433.30377197265625,
        -1935.971435546875,
        912.0
      ],
      [
        -369.0,
        -1939.0,
        912.0
      ],
      [
        -369.0,
        -1928.0,
        930.0
      ],
      [
        -369.0,
        -1939.0,
        909.7214965820312
      ],
      [
        -369.0,
        -1939.0,
        912.0
      ],
      [
        -369.0,
        -1939.0,
        909.7214965820312
      ],
      [
        -422.5,
        -1950.0,
        893.999755859375
      ],
      [
        -414.0,
        -1950.0,
        893.999755859375
      ],
      [
        -369.0,
        -1946.408935546875,
        792.2774658203125
      ],
      [
        -369.0,
        -1960.0589599609375,
        768.0467529296875
      ],
      [
        -369.0,
        -1961.5411376953125,
        765.0
      ],
      [
        -390.511962890625,
        -1971.918212890625,
        765.0
      ],
      [
        -390.511962890625,
        -1971.918212890625,
        765.0
      ],
      [
        -390.6815185546875,
        -1972.0,
        765.0
      ],
      [
        -369.0,
        -1960.0589599609375,
        768.0467529296875
      ],
      [
        -300.0,
        -1972.0,
        765.0
      ],
      [
        -300.0,
        -1972.0,
        770.0
      ],
      [
        -367.1901550292969,
        -1960.6680908203125,
        765.0
      ],
      [
        -362.0903015136719,
        -1957.5482177734375,
        765.0
      ],
      [
        -362.0903015136719,
        -1957.5482177734375,
        765.0
      ],
      [
        -359.517822265625,
        -1955.974609375,
        765.0
      ],
      [
        -353.5804748535156,
        -1952.3424072265625,
        765.0
      ],
      [
        -359.517822265625,
        -1955.974609375,
        765.0
      ],
      [
        -367.1901550292969,
        -1960.6680908203125,
        765.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -409.52386474609375,
        -1974.375732421875,
        778.7998046875
      ],
      [
        -422.14593505859375,
        -1987.0,
        765.3656616210938
      ],
      [
        -418.6541442871094,
        -1985.4935302734375,
        765.0
      ],
      [
        -421.7771301269531,
        -1987.0,
        765.0
      ],
      [
        -418.6541442871094,
        -1985.4935302734375,
        765.0
      ],
      [
        -300.0,
        -1987.0,
        768.5
      ],
      [
        -422.489501953125,
        -1987.3436279296875,
        765.0
      ],
      [
        -335.7066345214844,
        -1971.26513671875,
        712.0
      ],
      [
        -336.4096984863281,
        -1971.604248046875,
        712.0
      ],
      [
        -336.4096984863281,
        -1971.604248046875,
        712.0
      ],
      [
        -370.9345703125,
        -1988.2584228515625,
        712.0
      ],
      [
        -335.7066345214844,
        -1971.26513671875,
        712.0
      ],
      [
        -335.5528869628906,
        -1971.1710205078125,
        712.0
      ],
      [
        -335.5528869628906,
        -1971.1710205078125,
        712.0
      ],
      [
        -335.475341796875,
        -1971.1236572265625,
        712.0
      ],
      [
        -335.2963562011719,
        -1971.01416015625,
        712.0
      ],
      [
        -335.475341796875,
        -1971.1236572265625,
        712.0
      ],
      [
        -370.9345703125,
        -1988.2584228515625,
        712.0
      ],
      [
        -644.8826904296875,
        -2154.383544921875,
        712.0
      ],
      [
        -611.5364379882812,
        -2130.387939453125,
        712.0
      ],
      [
        -283.0,
        -1987.0,
        712.0
      ],
      [
        -275.0,
        -1987.0,
        712.0
      ],
      [
        -283.0,
        -1979.0,
        712.0
      ],
      [
        -283.0,
        -1987.0,
        712.0
      ],
      [
        -283.0,
        -1987.0,
        754.0
      ],
      [
        -272.0,
        -1987.0,
        754.0
      ],
      [
        -283.0,
        -1952.1719970703125,
        754.0
      ],
      [
        -198.0,
        -1987.0,
        754.0
      ],
      [
        -184.0,
        -1987.0,
        754.0
      ],
      [
        -286.0,
        -1987.0,
        754.0
      ],
      [
        -244.5365753173828,
        -2289.39990234375,
        749.9978637695312
      ],
      [
        -244.54034423828125,
        -2289.39990234375,
        750.012939453125
      ],
      [
        -239.53695678710938,
        -2289.39990234375,
        729.9993286132812
      ],
      [
        -244.5365753173828,
        -2289.39990234375,
        749.9978637695312
      ],
      [
        -244.5365753173828,
        -2302.39990234375,
        749.9978637695312
      ],
      [
        -244.54034423828125,
        -2302.39990234375,
        750.012939453125
      ],
      [
        -239.53695678710938,
        -2302.39990234375,
        729.9993286132812
      ],
      [
        -244.5365753173828,
        -2302.39990234375,
        749.9978637695312
      ],
      [
        -378.0864562988281,
        -2347.723876953125,
        729.9866943359375
      ],
      [
        -378.0864562988281,
        -2347.723876953125,
        712.0
      ],
      [
        -378.0864562988281,
        -2347.723876953125,
        730.43212890625
      ],
      [
        -378.0864562988281,
        -2347.723876953125,
        729.9866943359375
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        729.9866943359375
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        712.0
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        730.431640625
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        729.9866943359375
      ],
      [
        -365.31292724609375,
        -2353.335205078125,
        750.2590942382812
      ],
      [
        -365.3663330078125,
        -2353.388427734375,
        749.95703125
      ],
      [
        -365.3663330078125,
        -2353.388427734375,
        749.95703125
      ],
      [
        -374.5050048828125,
        -2344.142578125,
        750.2597045898438
      ],
      [
        -374.55853271484375,
        -2344.196044921875,
        749.9569091796875
      ],
      [
        -374.55853271484375,
        -2344.196044921875,
        749.9569091796875
      ],
      [
        -294.697998046875,
        -2287.057861328125,
        712.0
      ],
      [
        -308.451171875,
        -2273.305419921875,
        712.0
      ],
      [
        -271.21551513671875,
        -2310.5390625,
        775.0
      ],
      [
        -275.2632141113281,
        -2306.49169921875,
        768.4002075195312
      ],
      [
        -327.6992492675781,
        -2254.058349609375,
        768.3970336914062
      ],
      [
        -331.69427490234375,
        -2250.063720703125,
        775.0
      ],
      [
        -275.2632141113281,
        -2306.49169921875,
        768.4002075195312
      ],
      [
        -327.6992492675781,
        -2254.058349609375,
        768.3970336914062
      ],
      [
        -366.3922119140625,
        -2302.39990234375,
        774.9169311523438
      ],
      [
        -366.4575500488281,
        -2302.39990234375,
        774.9933471679688
      ],
      [
        -278.453369140625,
        -2325.798583984375,
        774.96826171875
      ],
      [
        -278.66265869140625,
        -2325.58935546875,
        774.6270751953125
      ],
      [
        -366.3933410644531,
        -2289.39990234375,
        774.9186401367188
      ],
      [
        -366.45733642578125,
        -2289.39990234375,
        774.9934692382812
      ],
      [
        -308.451171875,
        -2273.305419921875,
        736.583740234375
      ],
      [
        -308.451171875,
        -2273.305419921875,
        729.9274291992188
      ],
      [
        -331.69427490234375,
        -2250.063720703125,
        775.0
      ],
      [
        -334.33319091796875,
        -2247.4248046875,
        772.7014770507812
      ],
      [
        -271.21551513671875,
        -2310.5390625,
        775.0
      ],
      [
        -268.58868408203125,
        -2313.165771484375,
        772.7119750976562
      ],
      [
        -365.0546569824219,
        -2277.3564453125,
        773.354248046875
      ],
      [
        -365.056396484375,
        -2316.330078125,
        773.3551025390625
      ],
      [
        -371.65789794921875,
        -2307.5205078125,
        771.5366821289062
      ],
      [
        -371.665283203125,
        -2286.17236328125,
        771.53173828125
      ],
      [
        -377.5646667480469,
        -2296.831298828125,
        767.5988159179688
      ],
      [
        -371.665283203125,
        -2286.17236328125,
        771.53173828125
      ],
      [
        -371.65789794921875,
        -2307.5205078125,
        771.5366821289062
      ],
      [
        -372.0876770019531,
        -2302.39990234375,
        767.6744995117188
      ],
      [
        -374.4842224121094,
        -2302.39990234375,
        769.6476440429688
      ],
      [
        -370.8673400878906,
        -2304.60009765625,
        768.4813842773438
      ],
      [
        -372.0876770019531,
        -2302.39990234375,
        767.6744995117188
      ],
      [
        -372.275146484375,
        -2291.60009765625,
        767.5505981445312
      ],
      [
        -371.0528869628906,
        -2289.39990234375,
        768.3587036132812
      ],
      [
        -371.0528869628906,
        -2289.39990234375,
        768.3587036132812
      ],
      [
        -373.4478454589844,
        -2289.39990234375,
        770.337890625
      ],
      [
        -327.900634765625,
        -2273.304931640625,
        712.0
      ],
      [
        -341.653076171875,
        -2287.05810546875,
        729.9859008789062
      ],
      [
        -330.73065185546875,
        -2276.135009765625,
        712.0
      ],
      [
        -308.451171875,
        -2273.305419921875,
        712.0
      ],
      [
        -327.900634765625,
        -2273.304931640625,
        712.0
      ],
      [
        -366.7880554199219,
        -2255.848388671875,
        764.9608764648438
      ],
      [
        -373.8512268066406,
        -2248.78515625,
        749.977783203125
      ],
      [
        -366.73284912109375,
        -2255.903564453125,
        765.0780029296875
      ],
      [
        -366.7880554199219,
        -2255.848388671875,
        764.9608764648438
      ],
      [
        -373.8512268066406,
        -2248.78515625,
        749.977783203125
      ],
      [
        -373.914306640625,
        -2248.72216796875,
        749.843994140625
      ],
      [
        -357.5956726074219,
        -2246.656005859375,
        764.9608764648438
      ],
      [
        -364.6588439941406,
        -2239.5927734375,
        749.977783203125
      ],
      [
        -357.54046630859375,
        -2246.711181640625,
        765.0780029296875
      ],
      [
        -357.5956726074219,
        -2246.656005859375,
        764.9608764648438
      ],
      [
        -383.5801086425781,
        -2283.802490234375,
        761.8241577148438
      ],
      [
        -385.4071044921875,
        -2267.61474609375,
        750.0
      ],
      [
        -356.1874694824219,
        -2266.44921875,
        774.9771118164062
      ],
      [
        -366.7695617675781,
        -2255.866943359375,
        765.0001220703125
      ],
      [
        -346.9950866699219,
        -2257.2568359375,
        774.9771118164062
      ],
      [
        -357.5771789550781,
        -2246.674560546875,
        765.0001220703125
      ],
      [
        -343.1751708984375,
        -2238.583251953125,
        765.0
      ],
      [
        -350.8291320800781,
        -2230.929931640625,
        750.0
      ],
      [
        -343.1751708984375,
        -2238.583251953125,
        765.0
      ],
      [
        -381.462890625,
        -2289.77685546875,
        765.0
      ],
      [
        -378.07769775390625,
        -2291.60009765625,
        763.714111328125
      ],
      [
        -379.2980651855469,
        -2289.39990234375,
        762.9072265625
      ],
      [
        -379.7106628417969,
        -2289.39990234375,
        763.2470092773438
      ],
      [
        -381.5964660644531,
        -2289.39990234375,
        764.7996215820312
      ],
      [
        -379.2980651855469,
        -2289.39990234375,
        762.9072265625
      ],
      [
        -379.7106628417969,
        -2289.39990234375,
        763.2470092773438
      ],
      [
        -381.462890625,
        -2289.77685546875,
        765.0
      ],
      [
        -381.462890625,
        -2289.39990234375,
        765.0
      ],
      [
        -381.5964660644531,
        -2289.39990234375,
        764.7996215820312
      ],
      [
        -383.5801086425781,
        -2283.802490234375,
        761.8241577148438
      ],
      [
        -358.0503234863281,
        -2253.675048828125,
        716.0
      ],
      [
        -354.3133544921875,
        -2249.93798828125,
        716.0
      ],
      [
        -354.3133544921875,
        -2249.93798828125,
        712.0
      ],
      [
        -355.62115478515625,
        -2251.245849609375,
        712.0
      ],
      [
        -339.642333984375,
        -2242.115966796875,
        716.0
      ],
      [
        -339.642333984375,
        -2242.115966796875,
        712.0
      ],
      [
        -367.5105285644531,
        -2337.14794921875,
        764.9351196289062
      ],
      [
        -374.5508728027344,
        -2344.1884765625,
        750.000244140625
      ],
      [
        -367.41888427734375,
        -2337.056396484375,
        765.1295166015625
      ],
      [
        -367.5105285644531,
        -2337.14794921875,
        764.9351196289062
      ],
      [
        -358.3182067871094,
        -2346.34033203125,
        764.9351806640625
      ],
      [
        -365.3587341308594,
        -2353.380859375,
        750.0
      ],
      [
        -356.9188232421875,
        -2326.555908203125,
        774.9572143554688
      ],
      [
        -367.4799499511719,
        -2337.117431640625,
        765.0
      ],
      [
        -331.0267639160156,
        -2362.367919921875,
        761.9214477539062
      ],
      [
        -347.4492492675781,
        -2364.166015625,
        750.0
      ],
      [
        -341.653076171875,
        -2287.05810546875,
        712.0
      ],
      [
        -366.2558898925781,
        -2354.278076171875,
        726.6089477539062
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        726.6087646484375
      ],
      [
        -365.2110290527344,
        -2356.3447265625,
        729.1454467773438
      ],
      [
        -366.2558898925781,
        -2354.278076171875,
        726.6089477539062
      ],
      [
        -371.38494873046875,
        -2344.134033203125,
        714.1585693359375
      ],
      [
        -372.2742919921875,
        -2342.375244140625,
        712.0
      ],
      [
        -361.53094482421875,
        -2336.53857421875,
        716.0
      ],
      [
        -364.21600341796875,
        -2333.853515625,
        716.0
      ],
      [
        -364.2159729003906,
        -2333.853515625,
        712.0
      ],
      [
        -363.984375,
        -2334.085205078125,
        712.0
      ],
      [
        -372.8341369628906,
        -2318.24072265625,
        716.0
      ],
      [
        -372.8341369628906,
        -2318.24072265625,
        712.0
      ],
      [
        -376.84716796875,
        -2302.39990234375,
        764.5277099609375
      ],
      [
        -376.84716796875,
        -2302.39990234375,
        768.073974609375
      ],
      [
        -376.84716796875,
        -2304.60009765625,
        764.5277099609375
      ],
      [
        -376.84716796875,
        -2302.39990234375,
        764.5277099609375
      ],
      [
        -259.73486328125,
        -2322.019287109375,
        765.0
      ],
      [
        -252.0811309814453,
        -2329.672607421875,
        750.0
      ],
      [
        -259.73486328125,
        -2322.019287109375,
        765.0
      ],
      [
        -271.0911560058594,
        -2333.160888671875,
        764.48828125
      ],
      [
        -271.0910949707031,
        -2333.16064453125,
        768.0343017578125
      ],
      [
        -271.0911560058594,
        -2333.160888671875,
        764.48828125
      ],
      [
        -272.6468200683594,
        -2334.716552734375,
        764.48828125
      ],
      [
        -263.2676696777344,
        -2318.486572265625,
        716.0
      ],
      [
        -263.2676696777344,
        -2318.486572265625,
        712.0
      ],
      [
        -288.3669128417969,
        -2258.00439453125,
        774.9500732421875
      ],
      [
        -288.7003479003906,
        -2258.337890625,
        774.4044189453125
      ],
      [
        -269.54083251953125,
        -2289.39990234375,
        774.9957885742188
      ],
      [
        -269.5799560546875,
        -2289.39990234375,
        774.95068359375
      ],
      [
        -269.54083251953125,
        -2302.39990234375,
        774.9957885742188
      ],
      [
        -269.5799560546875,
        -2302.39990234375,
        774.95068359375
      ],
      [
        -279.17462158203125,
        -2267.19677734375,
        774.9501342773438
      ],
      [
        -279.5075988769531,
        -2267.52978515625,
        774.4052734375
      ],
      [
        -323.39990234375,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -323.39990234375,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -325.60009765625,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -325.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -310.39990234375,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -310.39990234375,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -312.60009765625,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -312.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -332.6547546386719,
        -2249.103271484375,
        774.1633911132812
      ],
      [
        -270.25958251953125,
        -2311.494873046875,
        774.1673583984375
      ],
      [
        -298.52166748046875,
        -2249.794677734375,
        773.3587036132812
      ],
      [
        -307.3294677734375,
        -2243.202880859375,
        771.5457153320312
      ],
      [
        -325.1485290527344,
        -2233.38427734375,
        765.0
      ],
      [
        -331.0368957519531,
        -2231.30615234375,
        761.8826904296875
      ],
      [
        -347.3697814941406,
        -2229.4970703125,
        750.0
      ],
      [
        -325.60009765625,
        -2235.516845703125,
        762.8859252929688
      ],
      [
        -323.39990234375,
        -2236.733642578125,
        763.6904296875
      ],
      [
        -312.60009765625,
        -2242.70654296875,
        767.6395874023438
      ],
      [
        -310.39990234375,
        -2243.923583984375,
        768.4441528320312
      ],
      [
        -323.39990234375,
        -2234.348388671875,
        765.6420288085938
      ],
      [
        -323.39990234375,
        -2236.733642578125,
        763.6904296875
      ],
      [
        -325.60009765625,
        -2233.224853515625,
        764.7609252929688
      ],
      [
        -325.60009765625,
        -2235.409912109375,
        762.973388671875
      ],
      [
        -325.60009765625,
        -2235.409912109375,
        762.973388671875
      ],
      [
        -325.60009765625,
        -2235.516845703125,
        762.8859252929688
      ],
      [
        -325.60009765625,
        -2233.38427734375,
        765.0
      ],
      [
        -325.1485290527344,
        -2233.38427734375,
        765.0
      ],
      [
        -325.60009765625,
        -2233.224853515625,
        764.7609252929688
      ],
      [
        -331.0368957519531,
        -2231.30615234375,
        761.8826904296875
      ],
      [
        -307.3294677734375,
        -2243.202880859375,
        771.5457153320312
      ],
      [
        -312.60009765625,
        -2240.3017578125,
        769.60693359375
      ],
      [
        -312.60009765625,
        -2242.70654296875,
        767.6395874023438
      ],
      [
        -310.39990234375,
        -2241.5146484375,
        770.4147338867188
      ],
      [
        -310.39990234375,
        -2243.923583984375,
        768.4441528320312
      ],
      [
        -270.9585266113281,
        -2277.354248046875,
        773.3617553710938
      ],
      [
        -272.5294189453125,
        -2266.46484375,
        771.5512084960938
      ],
      [
        -278.21331787109375,
        -2246.8837890625,
        765.0
      ],
      [
        -278.028564453125,
        -2247.666015625,
        765.2129516601562
      ],
      [
        -279.7173156738281,
        -2249.354736328125,
        763.2664794921875
      ],
      [
        -279.7173156738281,
        -2249.354736328125,
        763.2664794921875
      ],
      [
        -279.0205383300781,
        -2251.76953125,
        764.069580078125
      ],
      [
        -275.60009765625,
        -2263.622314453125,
        768.0119018554688
      ],
      [
        -274.9033508300781,
        -2266.036865234375,
        768.8150024414062
      ],
      [
        -272.5294189453125,
        -2266.46484375,
        771.5512084960938
      ],
      [
        -273.8948669433594,
        -2261.9169921875,
        769.9774169921875
      ],
      [
        -275.60009765625,
        -2263.622314453125,
        768.0119018554688
      ],
      [
        -325.60009765625,
        -2235.512451171875,
        762.889404296875
      ],
      [
        -323.6819152832031,
        -2235.505126953125,
        762.878173828125
      ],
      [
        -324.7909240722656,
        -2235.96435546875,
        763.1818237304688
      ],
      [
        -323.39990234375,
        -2238.0,
        716.0
      ],
      [
        -323.39990234375,
        -2238.0,
        712.918701171875
      ],
      [
        -324.19696044921875,
        -2238.0,
        712.0
      ],
      [
        -320.7265319824219,
        -2238.0,
        716.0
      ],
      [
        -271.80126953125,
        -2259.823486328125,
        768.005615234375
      ],
      [
        -271.80126953125,
        -2259.823486328125,
        764.4598999023438
      ],
      [
        -242.22479248046875,
        -2289.39990234375,
        729.66845703125
      ],
      [
        -242.224853515625,
        -2289.39990234375,
        740.7509155273438
      ],
      [
        -271.80126953125,
        -2259.823486328125,
        764.4598999023438
      ],
      [
        -270.24554443359375,
        -2261.379150390625,
        764.4598388671875
      ],
      [
        -259.15283203125,
        -2302.39990234375,
        716.0
      ],
      [
        -259.15283203125,
        -2302.39990234375,
        712.0
      ],
      [
        -249.391357421875,
        -2289.39990234375,
        757.2894287109375
      ],
      [
        -256.652587890625,
        -2291.177978515625,
        762.878173828125
      ],
      [
        -256.477783203125,
        -2291.60009765625,
        762.615478515625
      ],
      [
        -257.3890075683594,
        -2289.39990234375,
        766.9028930664062
      ],
      [
        -257.3890686035156,
        -2289.39990234375,
        763.9849243164062
      ],
      [
        -256.652587890625,
        -2291.177978515625,
        762.878173828125
      ],
      [
        -257.3890686035156,
        -2289.39990234375,
        763.3651123046875
      ],
      [
        -257.3890686035156,
        -2289.39990234375,
        763.3651123046875
      ],
      [
        -485.73870849609375,
        -2801.961181640625,
        712.0
      ],
      [
        -507.4796447753906,
        -2743.38037109375,
        712.0
      ],
      [
        -582.9874877929688,
        -2544.48486328125,
        712.0
      ],
      [
        -507.4796447753906,
        -2743.38037109375,
        712.0
      ],
      [
        -582.9874877929688,
        -2544.48486328125,
        712.0
      ],
      [
        -658.1302490234375,
        -2432.034423828125,
        712.0
      ],
      [
        -676.2326049804688,
        -2405.016357421875,
        712.0
      ],
      [
        -658.1302490234375,
        -2432.034423828125,
        712.0
      ],
      [
        -724.343505859375,
        -2346.3134765625,
        712.0
      ],
      [
        -711.299560546875,
        -2357.11669921875,
        712.0
      ],
      [
        -676.2326049804688,
        -2405.016357421875,
        712.0
      ],
      [
        -711.299560546875,
        -2357.11669921875,
        712.0
      ],
      [
        -901.8233032226562,
        -2549.875,
        712.0
      ],
      [
        -908.08447265625,
        -2556.32177734375,
        712.0
      ],
      [
        -914.2557983398438,
        -2565.431396484375,
        712.0
      ],
      [
        -908.08447265625,
        -2556.32177734375,
        712.0
      ],
      [
        -698.2745361328125,
        -2408.3671875,
        1479.6412353515625
      ],
      [
        -732.7146606445312,
        -2333.082275390625,
        1138.884033203125
      ],
      [
        -726.5072021484375,
        -2342.9248046875,
        712.0
      ],
      [
        -724.343505859375,
        -2346.3134765625,
        712.0
      ],
      [
        -955.4878540039062,
        -2133.624755859375,
        712.0
      ],
      [
        -883.0211181640625,
        -2158.24560546875,
        712.0
      ],
      [
        -726.5072021484375,
        -2342.9248046875,
        712.0
      ],
      [
        -732.7146606445312,
        -2333.082275390625,
        1138.8839111328125
      ],
      [
        -733.7015380859375,
        -2332.1337890625,
        1156.9876708984375
      ],
      [
        -728.6041870117188,
        -2341.385986328125,
        712.0
      ],
      [
        -774.505126953125,
        -2299.141845703125,
        1403.453125
      ],
      [
        -733.7510375976562,
        -2332.29296875,
        1165.0404052734375
      ],
      [
        -733.7015380859375,
        -2332.1337890625,
        1156.9876708984375
      ],
      [
        -733.4498291015625,
        -2333.14013671875,
        1178.760986328125
      ],
      [
        -733.7510375976562,
        -2332.29296875,
        1165.040283203125
      ],
      [
        -733.4498291015625,
        -2333.14013671875,
        1178.760986328125
      ],
      [
        -783.6495361328125,
        -2253.353515625,
        974.869384765625
      ],
      [
        -787.0260620117188,
        -2248.078125,
        929.3052978515625
      ],
      [
        -728.6041870117188,
        -2341.385986328125,
        712.0
      ],
      [
        -752.8074951171875,
        -2316.442138671875,
        712.0
      ],
      [
        -783.6495361328125,
        -2253.353515625,
        974.8693237304688
      ],
      [
        -781.6626586914062,
        -2256.458740234375,
        999.04052734375
      ],
      [
        -771.3399047851562,
        -2276.37548828125,
        861.0977783203125
      ],
      [
        -763.491943359375,
        -2299.924560546875,
        712.0
      ],
      [
        -755.806396484375,
        -2309.72265625,
        712.0
      ],
      [
        -761.0213012695312,
        -2295.636962890625,
        712.0
      ],
      [
        -763.491943359375,
        -2299.924560546875,
        712.0
      ],
      [
        -771.3399047851562,
        -2276.37548828125,
        861.0977783203125
      ],
      [
        -779.03271484375,
        -2261.742919921875,
        1062.635009765625
      ],
      [
        -779.9501342773438,
        -2259.135009765625,
        1019.874267578125
      ],
      [
        -779.03271484375,
        -2261.742919921875,
        1062.635009765625
      ],
      [
        -777.7199096679688,
        -2262.626220703125,
        1025.4935302734375
      ],
      [
        -774.6851196289062,
        -2267.39453125,
        972.22314453125
      ],
      [
        -752.8074951171875,
        -2316.442138671875,
        712.0
      ],
      [
        -774.6851196289062,
        -2267.39453125,
        972.22314453125
      ],
      [
        -771.3638305664062,
        -2272.615966796875,
        902.1463623046875
      ],
      [
        -754.3880615234375,
        -2311.53076171875,
        712.0
      ],
      [
        -754.3880615234375,
        -2311.53076171875,
        712.0
      ],
      [
        -771.3638305664062,
        -2272.615966796875,
        902.1463623046875
      ],
      [
        -773.9360961914062,
        -2268.585205078125,
        910.4207153320312
      ],
      [
        -760.0469360351562,
        -2293.9462890625,
        712.0
      ],
      [
        -773.9360961914062,
        -2268.585205078125,
        910.4207153320312
      ],
      [
        -768.06884765625,
        -2277.79638671875,
        832.6275024414062
      ],
      [
        -767.9937133789062,
        -2277.914306640625,
        831.6309814453125
      ],
      [
        -760.0298461914062,
        -2293.91650390625,
        712.0
      ],
      [
        -761.7081909179688,
        -2287.79248046875,
        712.0
      ],
      [
        -760.0298461914062,
        -2293.91650390625,
        712.0
      ],
      [
        -767.9937133789062,
        -2277.914306640625,
        831.6309814453125
      ],
      [
        -787.0260620117188,
        -2248.078125,
        929.3052978515625
      ],
      [
        -841.748291015625,
        -2180.046142578125,
        712.0
      ],
      [
        -804.64306640625,
        -2220.54736328125,
        712.0
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2813720703125
      ],
      [
        -786.7236328125,
        -2240.106689453125,
        712.0
      ],
      [
        -766.508056640625,
        -2270.27880859375,
        712.0
      ],
      [
        -774.7032470703125,
        -2264.432373046875,
        932.41943359375
      ],
      [
        -774.7032470703125,
        -2264.432373046875,
        932.41943359375
      ],
      [
        -775.7066650390625,
        -2263.272216796875,
        944.0587768554688
      ],
      [
        -775.0943603515625,
        -2264.15380859375,
        942.9470825195312
      ],
      [
        -775.7066650390625,
        -2263.272216796875,
        944.0587768554688
      ],
      [
        -771.7666625976562,
        -2271.98486328125,
        903.442138671875
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3348388671875
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564697265625
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3348388671875
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564697265625
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.5385131835938
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.53857421875
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2813720703125
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.908203125
      ],
      [
        -785.4612426757812,
        -2241.484619140625,
        712.0
      ],
      [
        -766.708251953125,
        -2269.54833984375,
        712.0
      ],
      [
        -775.2893676757812,
        -2263.254638671875,
        941.2240600585938
      ],
      [
        -775.2893676757812,
        -2263.254638671875,
        941.2240600585938
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.2651977539062
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4864501953125
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.2651977539062
      ],
      [
        -775.0943603515625,
        -2264.15380859375,
        942.9470825195312
      ],
      [
        -718.0658569335938,
        -2356.0107421875,
        1190.5318603515625
      ],
      [
        -732.9428100585938,
        -2332.720458984375,
        1154.5731201171875
      ],
      [
        -733.1166381835938,
        -2332.73046875,
        1164.033935546875
      ],
      [
        -718.0658569335938,
        -2356.0107421875,
        1190.5318603515625
      ],
      [
        -777.7197875976562,
        -2262.62646484375,
        1025.489501953125
      ],
      [
        -778.8007202148438,
        -2261.899169921875,
        1056.07080078125
      ],
      [
        -778.3422241210938,
        -2261.648681640625,
        1036.4188232421875
      ],
      [
        -732.9428100585938,
        -2332.720458984375,
        1154.5731201171875
      ],
      [
        -733.1773681640625,
        -2332.494140625,
        1158.9423828125
      ],
      [
        -733.1166381835938,
        -2332.73046875,
        1164.033935546875
      ],
      [
        -733.188232421875,
        -2332.5322265625,
        1160.8394775390625
      ],
      [
        -733.188232421875,
        -2332.5322265625,
        1160.839599609375
      ],
      [
        -733.1773681640625,
        -2332.494140625,
        1158.9423828125
      ],
      [
        -778.0450439453125,
        -2261.486328125,
        1023.680419921875
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524780273438
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524780273438
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.908203125
      ],
      [
        -769.677978515625,
        -2258.71240234375,
        712.0
      ],
      [
        -769.677978515625,
        -2258.71240234375,
        712.0
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4864501953125
      ],
      [
        -778.0450439453125,
        -2261.486328125,
        1023.680419921875
      ],
      [
        -412.7320861816406,
        -2068.68115234375,
        639.28125
      ],
      [
        -417.841796875,
        -2072.005126953125,
        639.28125
      ],
      [
        -417.841796875,
        -2072.005126953125,
        639.28125
      ],
      [
        -283.0,
        -1979.0,
        639.28125
      ],
      [
        -283.0,
        -1984.2923583984375,
        639.28125
      ],
      [
        -283.0,
        -1987.0,
        636.369140625
      ],
      [
        -281.0429382324219,
        -1987.0,
        635.0
      ],
      [
        -283.0,
        -1987.0,
        636.369140625
      ],
      [
        -462.7181701660156,
        -2033.583984375,
        712.0
      ],
      [
        -395.6517639160156,
        -2040.9208984375,
        657.1885986328125
      ],
      [
        -283.0,
        -1979.0,
        644.97314453125
      ],
      [
        -388.1926574707031,
        -2051.13671875,
        640.9827270507812
      ],
      [
        -395.6517639160156,
        -2040.9208984375,
        657.1885986328125
      ],
      [
        -388.1926574707031,
        -2051.13671875,
        640.9827270507812
      ],
      [
        -409.1650085449219,
        -2066.103271484375,
        639.5584106445312
      ],
      [
        -412.7320861816406,
        -2068.681396484375,
        639.28125
      ],
      [
        -409.1650085449219,
        -2066.103271484375,
        639.5584106445312
      ],
      [
        -714.0125122070312,
        -2278.32275390625,
        639.28125
      ],
      [
        -680.1526489257812,
        -2323.25634765625,
        639.28125
      ],
      [
        -283.0,
        -1987.0,
        639.2814331054688
      ],
      [
        -275.0,
        -1987.0,
        639.2814331054688
      ],
      [
        -283.0,
        -1987.0,
        639.2814331054688
      ],
      [
        -283.0,
        -1984.2921142578125,
        639.2814331054688
      ],
      [
        -680.1527099609375,
        -2323.25634765625,
        641.6248779296875
      ],
      [
        -676.7446899414062,
        -2327.779052734375,
        641.6248779296875
      ],
      [
        -716.9764404296875,
        -2274.389404296875,
        641.6248779296875
      ],
      [
        -714.0125122070312,
        -2278.32275390625,
        641.6248779296875
      ],
      [
        -680.1526489257812,
        -2323.25634765625,
        641.6248779296875
      ],
      [
        -680.1527099609375,
        -2323.25634765625,
        639.28125
      ],
      [
        -374.8147888183594,
        -2149.998291015625,
        641.6248779296875
      ],
      [
        -346.10888671875,
        -2199.361083984375,
        641.0
      ],
      [
        -346.2635192871094,
        -2199.450439453125,
        641.6248779296875
      ],
      [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      [
        -520.8974609375,
        -2206.27783203125,
        641.6248779296875
      ],
      [
        -420.93878173828125,
        -2132.854736328125,
        639.28125
      ],
      [
        -393.30682373046875,
        -2116.6298828125,
        639.28125
      ],
      [
        -392.58709716796875,
        -2118.0791015625,
        639.6358032226562
      ],
      [
        -426.4540100097656,
        -2136.906005859375,
        639.4351806640625
      ],
      [
        -399.05316162109375,
        -2124.385986328125,
        639.9999389648438
      ],
      [
        -391.2320556640625,
        -2120.63427734375,
        639.9999389648438
      ],
      [
        -383.5627746582031,
        -2133.917724609375,
        639.9999389648438
      ],
      [
        -560.1396484375,
        -2241.306640625,
        639.9999389648438
      ],
      [
        -562.7290649414062,
        -2237.78125,
        639.9999389648438
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        641.6248779296875
      ],
      [
        -383.56280517578125,
        -2133.917724609375,
        640.0
      ],
      [
        -383.9648742675781,
        -2134.14990234375,
        641.6248779296875
      ],
      [
        -561.891357421875,
        -2238.921875,
        641.6248779296875
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        641.6248779296875
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        641.6248779296875
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        640.0223999023438
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        640.3711547851562
      ],
      [
        -406.736328125,
        -2129.89404296875,
        640.20703125
      ],
      [
        -404.5227355957031,
        -2127.009521484375,
        639.9999389648438
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        640.3711547851562
      ],
      [
        -404.0048828125,
        -2136.482421875,
        641.1044311523438
      ],
      [
        -404.0048828125,
        -2136.482421875,
        641.1044311523438
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        641.6248779296875
      ],
      [
        -400.3309631347656,
        -2139.301513671875,
        641.6248779296875
      ],
      [
        -399.0545349121094,
        -2124.38671875,
        639.9999389648438
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        640.0223999023438
      ],
      [
        -424.541748046875,
        -2135.501220703125,
        639.7391967773438
      ],
      [
        -422.3927001953125,
        -2134.384033203125,
        639.8639526367188
      ],
      [
        -425.91278076171875,
        -2136.50830078125,
        639.9134521484375
      ],
      [
        -422.3837890625,
        -2133.916259765625,
        639.4649047851562
      ],
      [
        -410.0513916015625,
        -2126.936279296875,
        639.6903686523438
      ],
      [
        -422.3927307128906,
        -2134.384033203125,
        639.8639526367188
      ],
      [
        -424.5417785644531,
        -2135.501220703125,
        639.7391967773438
      ],
      [
        -393.262939453125,
        -2116.8046875,
        639.4542236328125
      ],
      [
        -410.0513916015625,
        -2126.936279296875,
        639.6903686523438
      ],
      [
        -422.3837890625,
        -2133.916259765625,
        639.4649047851562
      ],
      [
        -420.93878173828125,
        -2132.854736328125,
        639.28125
      ],
      [
        -393.30682373046875,
        -2116.6298828125,
        639.28125
      ],
      [
        -346.10888671875,
        -2199.361083984375,
        641.0
      ],
      [
        -330.5204772949219,
        -2190.361328125,
        641.0
      ],
      [
        -359.5050048828125,
        -2105.415283203125,
        639.9999389648438
      ],
      [
        -378.614013671875,
        -2131.060546875,
        641.0
      ],
      [
        -383.81024169921875,
        -2134.060546875,
        641.0
      ],
      [
        -373.41796875,
        -2128.060546875,
        641.0
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        641.0
      ],
      [
        -379.841552734375,
        -2136.734619140625,
        641.0
      ],
      [
        -374.341552734375,
        -2146.2607421875,
        641.0
      ],
      [
        -362.217041015625,
        -2139.2607421875,
        641.0
      ],
      [
        -367.717041015625,
        -2129.734619140625,
        641.0
      ],
      [
        -371.609375,
        -2146.992919921875,
        641.0
      ],
      [
        -369.87750244140625,
        -2145.992919921875,
        641.0
      ],
      [
        -362.94921875,
        -2141.992919921875,
        641.0
      ],
      [
        -364.8468017578125,
        -2143.08837890625,
        641.0
      ],
      [
        -378.614013671875,
        -2131.060546875,
        641.0
      ],
      [
        -377.464111328125,
        -2133.052490234375,
        641.0
      ],
      [
        -371.609375,
        -2146.992919921875,
        641.0
      ],
      [
        -374.341552734375,
        -2146.2607421875,
        641.0
      ],
      [
        -379.841552734375,
        -2136.734619140625,
        641.0
      ],
      [
        -379.109375,
        -2134.00244140625,
        641.0
      ],
      [
        -379.109375,
        -2134.00244140625,
        641.0
      ],
      [
        -377.464111328125,
        -2133.052490234375,
        641.0
      ],
      [
        -362.217041015625,
        -2139.2607421875,
        641.0
      ],
      [
        -362.94921875,
        -2141.992919921875,
        641.0
      ],
      [
        -372.26806640625,
        -2130.052490234375,
        641.0
      ],
      [
        -370.44921875,
        -2129.00244140625,
        641.0
      ],
      [
        -373.41796875,
        -2128.060546875,
        641.0
      ],
      [
        -372.26806640625,
        -2130.052490234375,
        641.0
      ],
      [
        -367.717041015625,
        -2129.734619140625,
        641.0
      ],
      [
        -370.44921875,
        -2129.00244140625,
        641.0
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        641.0
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        641.0
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        641.0
      ],
      [
        -355.507568359375,
        -2108.482421875,
        640.5662231445312
      ],
      [
        -355.0348815917969,
        -2112.073486328125,
        641.0
      ],
      [
        -355.507568359375,
        -2108.482421875,
        640.5662231445312
      ],
      [
        -359.5050048828125,
        -2105.415283203125,
        639.9999389648438
      ],
      [
        -330.3504333496094,
        -2190.26318359375,
        641.6248779296875
      ],
      [
        -330.5205078125,
        -2190.361328125,
        641.0
      ],
      [
        -334.9017028808594,
        -2182.380126953125,
        641.6248779296875
      ],
      [
        -339.9017028808594,
        -2173.7197265625,
        641.6248779296875
      ],
      [
        -358.9017028808594,
        -2140.810791015625,
        641.6248779296875
      ],
      [
        -368.2217712402344,
        -2125.060546875,
        641.0
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        641.6248779296875
      ],
      [
        -368.0517272949219,
        -2124.96240234375,
        641.6248779296875
      ],
      [
        -332.7718811035156,
        -2181.150390625,
        641.6248779296875
      ],
      [
        -337.7718811035156,
        -2172.489990234375,
        641.6248779296875
      ],
      [
        -337.7718811035156,
        -2172.489990234375,
        641.6248779296875
      ],
      [
        -339.9017028808594,
        -2173.7197265625,
        641.6248779296875
      ],
      [
        -334.9017028808594,
        -2182.380126953125,
        641.6248779296875
      ],
      [
        -332.7718811035156,
        -2181.150390625,
        641.6248779296875
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        641.6248779296875
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        641.2994995117188
      ],
      [
        -358.1859436035156,
        -2119.0849609375,
        641.6248779296875
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        641.2994995117188
      ],
      [
        -374.8147888183594,
        -2149.998291015625,
        641.6248779296875
      ],
      [
        -369.4045715332031,
        -2146.87451171875,
        641.6248779296875
      ],
      [
        -364.3221740722656,
        -2143.940185546875,
        641.6248779296875
      ],
      [
        -358.9017028808594,
        -2140.810791015625,
        641.6248779296875
      ],
      [
        -379.841552734375,
        -2136.734619140625,
        641.6248779296875
      ],
      [
        -374.341552734375,
        -2146.2607421875,
        641.6248779296875
      ],
      [
        -381.9916687011719,
        -2133.0107421875,
        641.6248779296875
      ],
      [
        -381.99169921875,
        -2133.0107421875,
        641.0
      ],
      [
        -362.217041015625,
        -2139.2607421875,
        641.6248779296875
      ],
      [
        -367.717041015625,
        -2129.734619140625,
        641.6248779296875
      ],
      [
        -369.86724853515625,
        -2126.010498046875,
        641.0
      ],
      [
        -369.8672180175781,
        -2126.010498046875,
        641.6248779296875
      ],
      [
        -378.614013671875,
        -2131.060546875,
        641.6248779296875
      ],
      [
        -373.41796875,
        -2128.060546875,
        641.6248779296875
      ],
      [
        -371.609375,
        -2146.992919921875,
        641.6248779296875
      ],
      [
        -374.341552734375,
        -2146.2607421875,
        641.6248779296875
      ],
      [
        -362.217041015625,
        -2139.2607421875,
        641.6248779296875
      ],
      [
        -362.94921875,
        -2141.992919921875,
        641.6248779296875
      ],
      [
        -371.609375,
        -2146.992919921875,
        641.6248779296875
      ],
      [
        -369.8233947753906,
        -2145.961669921875,
        641.6248779296875
      ],
      [
        -362.94921875,
        -2141.992919921875,
        641.6248779296875
      ],
      [
        -364.89599609375,
        -2143.116943359375,
        641.6248779296875
      ],
      [
        -369.9045715332031,
        -2146.008544921875,
        641.6248779296875
      ],
      [
        -369.4045715332031,
        -2146.87451171875,
        641.6248779296875
      ],
      [
        -364.3221740722656,
        -2143.940185546875,
        641.6248779296875
      ],
      [
        -364.8221740722656,
        -2143.07421875,
        641.6248779296875
      ],
      [
        -379.109375,
        -2134.00244140625,
        641.6248779296875
      ],
      [
        -377.464111328125,
        -2133.052490234375,
        641.6248779296875
      ],
      [
        -372.26806640625,
        -2130.052490234375,
        641.6248779296875
      ],
      [
        -370.44921875,
        -2129.00244140625,
        641.6248779296875
      ],
      [
        -378.614013671875,
        -2131.060546875,
        641.6248779296875
      ],
      [
        -377.464111328125,
        -2133.052490234375,
        641.6248779296875
      ],
      [
        -373.41796875,
        -2128.060546875,
        641.6248779296875
      ],
      [
        -372.26806640625,
        -2130.052490234375,
        641.6248779296875
      ],
      [
        -367.717041015625,
        -2129.734619140625,
        641.6248779296875
      ],
      [
        -370.44921875,
        -2129.00244140625,
        641.6248779296875
      ],
      [
        -379.841552734375,
        -2136.734619140625,
        641.6248779296875
      ],
      [
        -379.109375,
        -2134.00244140625,
        641.6248779296875
      ],
      [
        -420.0500793457031,
        -2133.166259765625,
        639.9999389648438
      ],
      [
        -426.59326171875,
        -2137.008056640625,
        639.9999389648438
      ],
      [
        -420.05010986328125,
        -2133.166259765625,
        639.9999389648438
      ],
      [
        -394.2156677246094,
        -2118.44580078125,
        639.9999389648438
      ],
      [
        -375.7421569824219,
        -2107.23681640625,
        639.9999389648438
      ],
      [
        -375.7421569824219,
        -2107.23681640625,
        639.9999389648438
      ],
      [
        -375.3222351074219,
        -2106.9033203125,
        639.9999389648438
      ],
      [
        -379.28436279296875,
        -2109.229736328125,
        639.9999389648438
      ],
      [
        -383.8895263671875,
        -2105.640869140625,
        639.28125
      ],
      [
        -374.6941223144531,
        -2098.886474609375,
        639.9999389648438
      ],
      [
        -371.0722961425781,
        -2103.527587890625,
        639.9999389648438
      ],
      [
        -371.07244873046875,
        -2103.527587890625,
        639.9999389648438
      ],
      [
        -371.0722961425781,
        -2103.527587890625,
        639.9999389648438
      ],
      [
        -376.2414855957031,
        -2108.90625,
        640.96044921875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.1424560546875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        640.4264526367188
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.62548828125
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.1424560546875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        641.6248779296875
      ],
      [
        -365.99072265625,
        -2103.6318359375,
        641.6248779296875
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        641.6248779296875
      ],
      [
        -375.3421936035156,
        -2110.6962890625,
        641.6248779296875
      ],
      [
        -391.2690734863281,
        -2119.8916015625,
        641.6248779296875
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        641.6248779296875
      ],
      [
        -405.2593078613281,
        -2127.96923828125,
        640.06884765625
      ],
      [
        -402.07666015625,
        -2123.822265625,
        640.4264526367188
      ],
      [
        -404.525634765625,
        -2127.013427734375,
        641.6248779296875
      ],
      [
        -405.25909423828125,
        -2127.96923828125,
        641.6248779296875
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.62548828125
      ],
      [
        -391.2690734863281,
        -2119.8916015625,
        641.6248779296875
      ],
      [
        -391.6632080078125,
        -2119.208984375,
        641.6248779296875
      ],
      [
        -375.3421936035156,
        -2110.6962890625,
        641.6248779296875
      ],
      [
        -376.2414855957031,
        -2108.90625,
        640.96044921875
      ],
      [
        -375.9366455078125,
        -2109.666748046875,
        641.6248779296875
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        641.6248779296875
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        641.6248779296875
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      [
        -360.365234375,
        -2104.755126953125,
        641.6248779296875
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        641.6248779296875
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        641.6248779296875
      ],
      [
        -404.0048828125,
        -2136.482421875,
        641.6248779296875
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        641.6248779296875
      ],
      [
        -355.507568359375,
        -2108.482421875,
        641.6248779296875
      ],
      [
        -355.507568359375,
        -2108.482421875,
        641.6248779296875
      ],
      [
        -360.365234375,
        -2104.755126953125,
        641.6248779296875
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        641.6248779296875
      ],
      [
        -404.0048828125,
        -2136.482421875,
        641.6248779296875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        641.6248779296875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.4857177734375
      ],
      [
        -358.75,
        -2099.238525390625,
        641.6248779296875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.4857177734375
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        639.9999389648438
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.3223266601562
      ],
      [
        -359.09588623046875,
        -2097.13623046875,
        639.9999389648438
      ],
      [
        -376.6820983886719,
        -2107.806884765625,
        639.9999389648438
      ],
      [
        -376.241455078125,
        -2108.90625,
        640.96044921875
      ],
      [
        -392.9296875,
        -2117.66552734375,
        640.0
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.6255493164062
      ],
      [
        -353.90350341796875,
        -2083.614990234375,
        641.6248779296875
      ],
      [
        -348.6988830566406,
        -2090.284423828125,
        641.6248779296875
      ],
      [
        -360.30859375,
        -2091.77294921875,
        640.9903564453125
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      [
        -358.86541748046875,
        -2098.155517578125,
        640.8145751953125
      ],
      [
        -360.30859375,
        -2091.77294921875,
        640.9903564453125
      ],
      [
        -348.6988830566406,
        -2090.284423828125,
        641.6248779296875
      ],
      [
        -355.91314697265625,
        -2096.0146484375,
        641.6248779296875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.6248779296875
      ],
      [
        -359.2350769042969,
        -2096.520751953125,
        640.859619140625
      ],
      [
        -358.8263244628906,
        -2098.328369140625,
        641.6248779296875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.6248779296875
      ],
      [
        -427.6833801269531,
        -2137.808837890625,
        640.1384887695312
      ],
      [
        -419.4507141113281,
        -2134.6982421875,
        641.6248779296875
      ],
      [
        -427.0796813964844,
        -2139.177734375,
        641.6248779296875
      ],
      [
        -429.8461608886719,
        -2139.3974609375,
        640.413330078125
      ],
      [
        -403.0185852050781,
        -2125.049560546875,
        641.6248779296875
      ],
      [
        -419.4507141113281,
        -2134.6982421875,
        641.6248779296875
      ],
      [
        -427.6833801269531,
        -2137.808837890625,
        640.1384887695312
      ],
      [
        -429.8461608886719,
        -2139.3974609375,
        640.413330078125
      ],
      [
        -427.0796813964844,
        -2139.177734375,
        641.6248779296875
      ],
      [
        -431.2630920410156,
        -2141.634033203125,
        641.6248779296875
      ],
      [
        -431.74652099609375,
        -2140.79345703125,
        640.6549072265625
      ],
      [
        -431.74652099609375,
        -2140.79345703125,
        640.6549072265625
      ],
      [
        -431.2630920410156,
        -2141.634033203125,
        641.6248779296875
      ],
      [
        -449.04290771484375,
        -2153.498046875,
        641.6248779296875
      ],
      [
        -376.28717041015625,
        -2108.9326171875,
        641.2617797851562
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.3368530273438
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.0433349609375
      ],
      [
        -392.35552978515625,
        -2118.209716796875,
        641.125732421875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.0433349609375
      ],
      [
        -403.0185241699219,
        -2125.049560546875,
        641.6248779296875
      ],
      [
        -392.35552978515625,
        -2118.209716796875,
        641.125732421875
      ],
      [
        -392.0198669433594,
        -2118.59130859375,
        641.6248779296875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.3368530273438
      ],
      [
        -366.7024841308594,
        -2103.7255859375,
        641.6248779296875
      ],
      [
        -376.28717041015625,
        -2108.9326171875,
        641.2617797851562
      ],
      [
        -376.1604309082031,
        -2109.279052734375,
        641.6248779296875
      ],
      [
        -376.7275695800781,
        -2107.72802734375,
        639.9999389648438
      ],
      [
        -371.9428405761719,
        -2106.424560546875,
        641.6248779296875
      ],
      [
        -369.19476318359375,
        -2104.516357421875,
        641.6248779296875
      ],
      [
        -359.0240783691406,
        -2097.4541015625,
        641.6248779296875
      ],
      [
        -364.7442626953125,
        -2101.426025390625,
        641.6248779296875
      ],
      [
        -364.7442626953125,
        -2101.426025390625,
        641.6248779296875
      ],
      [
        -369.19476318359375,
        -2104.516357421875,
        641.6248779296875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.6248779296875
      ],
      [
        -371.94342041015625,
        -2106.4248046875,
        641.6248779296875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.6248779296875
      ],
      [
        -359.0240783691406,
        -2097.453857421875,
        641.6248779296875
      ],
      [
        -376.3421936035156,
        -2108.96435546875,
        641.6248779296875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.6248779296875
      ],
      [
        -392.2690734863281,
        -2118.15966796875,
        641.6248779296875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.6248779296875
      ],
      [
        -392.2690734863281,
        -2118.15966796875,
        641.6248779296875
      ],
      [
        -376.3421936035156,
        -2108.96435546875,
        641.6248779296875
      ],
      [
        -360.30859375,
        -2091.77294921875,
        641.6248779296875
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.6248779296875
      ],
      [
        -360.30859375,
        -2091.77294921875,
        641.6248779296875
      ],
      [
        -714.0125122070312,
        -2278.32275390625,
        641.6248779296875
      ],
      [
        -714.0125122070312,
        -2278.32275390625,
        639.28125
      ],
      [
        -599.7044677734375,
        -2193.9814453125,
        641.6248779296875
      ],
      [
        -514.9536743164062,
        -2132.99560546875,
        641.6248779296875
      ],
      [
        -598.208740234375,
        -2195.306396484375,
        639.2813110351562
      ],
      [
        -599.257568359375,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -481.7292785644531,
        -2175.087646484375,
        641.6248779296875
      ],
      [
        -478.2337646484375,
        -2172.9765625,
        641.6248779296875
      ],
      [
        -389.2179870605469,
        -2098.81298828125,
        639.28125
      ],
      [
        -360.9189147949219,
        -2078.708984375,
        641.466552734375
      ],
      [
        -356.9159240722656,
        -2079.7548828125,
        641.6248779296875
      ],
      [
        -358.5946350097656,
        -2077.0341796875,
        641.6248779296875
      ],
      [
        -356.9159240722656,
        -2079.7548828125,
        641.6248779296875
      ],
      [
        -360.9189147949219,
        -2078.708984375,
        641.466552734375
      ],
      [
        -481.7292785644531,
        -2175.087646484375,
        641.6248779296875
      ],
      [
        -478.2337646484375,
        -2172.9765625,
        641.6248779296875
      ],
      [
        -377.63287353515625,
        -2046.1793212890625,
        641.6248779296875
      ],
      [
        -283.0,
        -1987.0,
        641.6248779296875
      ],
      [
        -275.0,
        -1987.0,
        641.6248779296875
      ],
      [
        -283.0,
        -1987.0,
        641.6248779296875
      ],
      [
        -283.0,
        -1982.1131591796875,
        641.6248779296875
      ],
      [
        -377.6329040527344,
        -2046.1793212890625,
        641.6248779296875
      ],
      [
        -388.2838439941406,
        -2051.011962890625,
        641.1808471679688
      ],
      [
        -381.7648620605469,
        -2047.9122314453125,
        641.6248779296875
      ],
      [
        -388.48822021484375,
        -2050.73193359375,
        641.6248779296875
      ],
      [
        -283.0,
        -1979.0,
        690.058837890625
      ],
      [
        -283.0,
        -1987.0,
        678.6296997070312
      ],
      [
        -283.0,
        -1987.0,
        678.6296997070312
      ],
      [
        -275.0,
        -1987.0,
        681.0655517578125
      ],
      [
        -283.0,
        -1979.0,
        703.77734375
      ],
      [
        -283.0,
        -1987.0,
        691.2603759765625
      ],
      [
        -283.0,
        -1987.0,
        691.2603759765625
      ],
      [
        -275.0,
        -1987.0,
        692.03515625
      ],
      [
        -309.56158447265625,
        -1972.45947265625,
        712.0
      ],
      [
        -341.9967956542969,
        -1974.93994140625,
        710.683349609375
      ],
      [
        -406.5951232910156,
        -2039.7237548828125,
        666.1322631835938
      ],
      [
        -243.34596252441406,
        -2065.764892578125,
        645.7661743164062
      ],
      [
        -251.72581481933594,
        -2065.959716796875,
        645.7384643554688
      ],
      [
        -333.49468994140625,
        -2071.4248046875,
        642.9716186523438
      ],
      [
        -360.5601806640625,
        -2073.8486328125,
        641.6248779296875
      ],
      [
        -299.30364990234375,
        -2066.0234375,
        645.5848999023438
      ],
      [
        -302.4421081542969,
        -2067.486572265625,
        645.3274536132812
      ],
      [
        -333.49468994140625,
        -2071.4248046875,
        642.9716186523438
      ],
      [
        -284.4295654296875,
        -2066.56591796875,
        645.7384643554688
      ],
      [
        -251.72581481933594,
        -2065.959716796875,
        645.7384643554688
      ],
      [
        -283.0,
        -1979.0,
        707.072265625
      ],
      [
        -283.0,
        -1987.0,
        701.46728515625
      ],
      [
        -283.0,
        -1987.0,
        701.46728515625
      ],
      [
        -275.0,
        -1987.0,
        701.36328125
      ],
      [
        -341.9967956542969,
        -1974.93994140625,
        710.683349609375
      ],
      [
        -339.32635498046875,
        -1973.01123046875,
        712.0
      ],
      [
        -375.6366271972656,
        -1990.5804443359375,
        712.0
      ],
      [
        -367.860107421875,
        -2000.8775634765625,
        692.8463745117188
      ],
      [
        -283.0,
        -1983.2685546875,
        712.0
      ],
      [
        -283.0,
        -1987.0,
        705.44970703125
      ],
      [
        -283.0,
        -1987.0,
        705.44970703125
      ],
      [
        -275.0,
        -1987.0,
        704.3409423828125
      ],
      [
        -340.3930358886719,
        -2196.061279296875,
        665.0
      ],
      [
        -347.84100341796875,
        -2200.361328125,
        648.0
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        657.8483276367188
      ],
      [
        -388.33538818359375,
        -2136.67333984375,
        641.6248779296875
      ],
      [
        -381.10101318359375,
        -2132.496337890625,
        658.137451171875
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        655.2444458007812
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        657.8483276367188
      ],
      [
        -404.0048828125,
        -2136.482421875,
        649.1953735351562
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        655.2444458007812
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        643.2442016601562
      ],
      [
        -404.0048828125,
        -2136.482421875,
        649.1953735351562
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.7142333984375
      ],
      [
        -406.5956115722656,
        -2129.710693359375,
        641.6248779296875
      ],
      [
        -402.25396728515625,
        -2127.088623046875,
        641.6248779296875
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        643.2442016601562
      ],
      [
        -336.1496276855469,
        -2193.611328125,
        665.0
      ],
      [
        -340.3930358886719,
        -2196.061279296875,
        665.0
      ],
      [
        -344.0039978027344,
        -2125.356689453125,
        671.9999389648438
      ],
      [
        -345.8387451171875,
        -2122.06005859375,
        667.9999389648438
      ],
      [
        -347.84100341796875,
        -2200.361328125,
        648.0
      ],
      [
        -383.96490478515625,
        -2134.14990234375,
        641.6248779296875
      ],
      [
        -385.54241943359375,
        -2135.060791015625,
        647.9998779296875
      ],
      [
        -336.1496276855469,
        -2193.611328125,
        665.0
      ],
      [
        -328.615234375,
        -2189.26123046875,
        648.0
      ],
      [
        -303.4555969238281,
        -2161.239013671875,
        643.0
      ],
      [
        -305.87005615234375,
        -2157.05712890625,
        643.0
      ],
      [
        -303.4555969238281,
        -2161.239013671875,
        645.7384643554688
      ],
      [
        -303.4555969238281,
        -2161.239013671875,
        643.0
      ],
      [
        -303.796875,
        -2158.64794921875,
        645.7384643554688
      ],
      [
        -303.796875,
        -2158.64794921875,
        645.7384643554688
      ],
      [
        -305.87005615234375,
        -2157.05712890625,
        643.0
      ],
      [
        -305.87005615234375,
        -2157.05712890625,
        645.7384643554688
      ],
      [
        -303.4555969238281,
        -2161.239013671875,
        659.9000244140625
      ],
      [
        -305.87005615234375,
        -2157.05712890625,
        659.9000244140625
      ],
      [
        -305.87005615234375,
        -2157.05712890625,
        659.9000244140625
      ],
      [
        -303.4555969238281,
        -2161.239013671875,
        659.9000244140625
      ],
      [
        -310.5193786621094,
        -2156.8037109375,
        659.8999633789062
      ],
      [
        -305.5608215332031,
        -2165.39208984375,
        659.8999633789062
      ],
      [
        -310.5193786621094,
        -2156.8037109375,
        659.8999633789062
      ],
      [
        -306.832763671875,
        -2156.318359375,
        656.4644775390625
      ],
      [
        -337.551025390625,
        -2107.583984375,
        658.7000732421875
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.3994140625
      ],
      [
        -338.1441650390625,
        -2107.926513671875,
        659.3850708007812
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.3994140625
      ],
      [
        -337.551025390625,
        -2107.583984375,
        658.7000732421875
      ],
      [
        -337.88067626953125,
        -2107.012939453125,
        658.7000732421875
      ],
      [
        -305.5608215332031,
        -2165.39208984375,
        659.8999633789062
      ],
      [
        -303.297119140625,
        -2162.442138671875,
        656.46435546875
      ],
      [
        -303.297119140625,
        -2162.442138671875,
        656.46435546875
      ],
      [
        -303.4555969238281,
        -2161.239013671875,
        656.0001220703125
      ],
      [
        -305.87005615234375,
        -2157.05712890625,
        656.0001220703125
      ],
      [
        -306.832763671875,
        -2156.318359375,
        656.4644775390625
      ],
      [
        -363.49114990234375,
        -2122.329345703125,
        641.6248779296875
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        658.6851196289062
      ],
      [
        -370.9185485839844,
        -2126.617431640625,
        658.3834838867188
      ],
      [
        -323.0265197753906,
        -2165.341552734375,
        659.83642578125
      ],
      [
        -323.4356384277344,
        -2164.6328125,
        655.1998291015625
      ],
      [
        -323.4356384277344,
        -2164.6328125,
        655.1998291015625
      ],
      [
        -323.4356384277344,
        -2164.6328125,
        650.0630493164062
      ],
      [
        -323.0265197753906,
        -2165.341552734375,
        659.83642578125
      ],
      [
        -322.5734558105469,
        -2166.126220703125,
        659.83642578125
      ],
      [
        -318.79925537109375,
        -2172.663330078125,
        655.1998901367188
      ],
      [
        -319.2083740234375,
        -2171.954833984375,
        659.83642578125
      ],
      [
        -318.79925537109375,
        -2172.663330078125,
        650.0601806640625
      ],
      [
        -318.79925537109375,
        -2172.663330078125,
        655.1998901367188
      ],
      [
        -319.2083740234375,
        -2171.954833984375,
        659.83642578125
      ],
      [
        -319.66192626953125,
        -2171.169189453125,
        659.83642578125
      ],
      [
        -323.4356384277344,
        -2164.6328125,
        643.0
      ],
      [
        -318.79925537109375,
        -2172.663330078125,
        643.0
      ],
      [
        -335.6023864746094,
        -2171.2373046875,
        642.21435546875
      ],
      [
        -323.4356384277344,
        -2164.6328125,
        643.0
      ],
      [
        -318.79925537109375,
        -2172.663330078125,
        643.0
      ],
      [
        -330.60235595703125,
        -2179.897705078125,
        642.21435546875
      ],
      [
        -335.6023864746094,
        -2171.2373046875,
        642.21435546875
      ],
      [
        -330.9505615234375,
        -2180.0986328125,
        643.0
      ],
      [
        -330.60235595703125,
        -2179.897705078125,
        642.21435546875
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        658.6851196289062
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        656.31787109375
      ],
      [
        -352.1414794921875,
        -2114.912841796875,
        646.9999389648438
      ],
      [
        -352.1414794921875,
        -2114.912841796875,
        658.0526123046875
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        657.847900390625
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        656.31787109375
      ],
      [
        -353.5945129394531,
        -2114.8515625,
        657.1998901367188
      ],
      [
        -352.9905700683594,
        -2113.442138671875,
        649.5999145507812
      ],
      [
        -352.9905700683594,
        -2113.442138671875,
        646.9999389648438
      ],
      [
        -352.8631591796875,
        -2114.409912109375,
        657.1998901367188
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        657.8478393554688
      ],
      [
        -353.3621826171875,
        -2112.798583984375,
        649.5999145507812
      ],
      [
        -352.9905700683594,
        -2113.442138671875,
        649.5999145507812
      ],
      [
        -353.5945129394531,
        -2114.8515625,
        657.1998901367188
      ],
      [
        -352.8631591796875,
        -2114.409912109375,
        657.1998901367188
      ],
      [
        -352.1414794921875,
        -2114.912841796875,
        646.9999389648438
      ],
      [
        -352.9905700683594,
        -2113.442138671875,
        646.9999389648438
      ],
      [
        -355.40521240234375,
        -2109.260009765625,
        649.5999145507812
      ],
      [
        -355.40521240234375,
        -2109.260009765625,
        641.6248779296875
      ],
      [
        -355.40521240234375,
        -2109.260009765625,
        649.5999145507812
      ],
      [
        -360.365234375,
        -2104.755126953125,
        644.3176879882812
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        641.7137451171875
      ],
      [
        -362.6966247558594,
        -2103.197998046875,
        641.6248779296875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        642.8467407226562
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        642.8467407226562
      ],
      [
        -359.5959167480469,
        -2102.00146484375,
        641.6248779296875
      ],
      [
        -359.5959167480469,
        -2102.00146484375,
        642.23876953125
      ],
      [
        -356.1233215332031,
        -2108.010009765625,
        649.5999145507812
      ],
      [
        -356.12982177734375,
        -2108.0048828125,
        641.6248779296875
      ],
      [
        -360.365234375,
        -2104.755126953125,
        644.3176879882812
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        641.7137451171875
      ],
      [
        -370.115478515625,
        -2107.6787109375,
        641.6248779296875
      ],
      [
        -321.2721862792969,
        -2163.716796875,
        658.3314208984375
      ],
      [
        -316.92413330078125,
        -2171.247802734375,
        658.3314208984375
      ],
      [
        -349.0675964355469,
        -2114.148193359375,
        659.0441284179688
      ],
      [
        -350.2869873046875,
        -2114.451416015625,
        658.6508178710938
      ],
      [
        -349.787353515625,
        -2114.3271484375,
        658.3313598632812
      ],
      [
        -321.2721862792969,
        -2163.716796875,
        658.3314208984375
      ],
      [
        -323.36505126953125,
        -2164.755126953125,
        655.9998168945312
      ],
      [
        -352.1414794921875,
        -2114.912841796875,
        656.0000610351562
      ],
      [
        -316.92413330078125,
        -2171.247802734375,
        658.3314208984375
      ],
      [
        -318.8698425292969,
        -2172.541015625,
        655.9998779296875
      ],
      [
        -315.1533203125,
        -2170.978271484375,
        658.0
      ],
      [
        -305.626953125,
        -2165.478271484375,
        658.0
      ],
      [
        -319.76287841796875,
        -2162.086669921875,
        658.0
      ],
      [
        -311.74249267578125,
        -2157.456298828125,
        658.0
      ],
      [
        -310.626953125,
        -2156.81787109375,
        658.0
      ],
      [
        -311.74249267578125,
        -2157.456298828125,
        658.0
      ],
      [
        -339.6944274902344,
        -2108.821533203125,
        658.0
      ],
      [
        -339.20880126953125,
        -2108.541259765625,
        659.359375
      ],
      [
        -346.8762512207031,
        -2112.968017578125,
        659.1741333007812
      ],
      [
        -346.4059143066406,
        -2112.696533203125,
        658.0
      ],
      [
        -337.551025390625,
        -2107.583984375,
        658.0
      ],
      [
        -339.20880126953125,
        -2108.541259765625,
        659.359375
      ],
      [
        -339.6944274902344,
        -2108.821533203125,
        658.0
      ],
      [
        -346.4059143066406,
        -2112.696533203125,
        658.0
      ],
      [
        -346.8762512207031,
        -2112.968017578125,
        659.1741333007812
      ],
      [
        -348.809326171875,
        -2114.083984375,
        659.12744140625
      ],
      [
        -348.809326171875,
        -2114.083984375,
        658.0
      ],
      [
        -348.809326171875,
        -2114.083984375,
        658.0
      ],
      [
        -348.809326171875,
        -2114.083984375,
        659.12744140625
      ],
      [
        -350.1219482421875,
        -2114.410400390625,
        658.0
      ],
      [
        -337.551025390625,
        -2107.583984375,
        658.0
      ],
      [
        -338.210693359375,
        -2106.44140625,
        658.0
      ],
      [
        -315.39080810546875,
        -2170.56689453125,
        658.0
      ],
      [
        -319.91583251953125,
        -2162.729248046875,
        658.0
      ],
      [
        -315.1533203125,
        -2170.978271484375,
        658.0
      ],
      [
        -315.39080810546875,
        -2170.56689453125,
        658.0
      ],
      [
        -319.91583251953125,
        -2162.729248046875,
        658.0
      ],
      [
        -320.1533203125,
        -2162.31787109375,
        658.0
      ],
      [
        -320.8858947753906,
        -2163.35888671875,
        658.0
      ],
      [
        -316.4211120605469,
        -2171.092041015625,
        658.0
      ],
      [
        -320.8858947753906,
        -2163.35888671875,
        658.0
      ],
      [
        -321.5696716308594,
        -2163.864501953125,
        658.0
      ],
      [
        -316.4211120605469,
        -2171.092041015625,
        658.0
      ],
      [
        -317.2007141113281,
        -2171.431640625,
        658.0
      ],
      [
        -308.48052978515625,
        -2156.535400390625,
        658.0
      ],
      [
        -310.626953125,
        -2156.81787109375,
        658.0
      ],
      [
        -305.626953125,
        -2165.478271484375,
        658.0
      ],
      [
        -304.3089599609375,
        -2163.7607421875,
        658.0
      ],
      [
        -320.1533203125,
        -2162.31787109375,
        658.0
      ],
      [
        -319.76287841796875,
        -2162.086669921875,
        658.0
      ],
      [
        -319.626953125,
        -2141.2294921875,
        644.5
      ],
      [
        -311.126953125,
        -2155.951904296875,
        644.5
      ],
      [
        -306.832763671875,
        -2156.318359375,
        647.1517944335938
      ],
      [
        -310.626953125,
        -2156.81787109375,
        644.4998168945312
      ],
      [
        -320.0495910644531,
        -2139.163818359375,
        645.0
      ],
      [
        -319.0495910644531,
        -2140.89599609375,
        645.0
      ],
      [
        -319.760986328125,
        -2138.997314453125,
        645.2499389648438
      ],
      [
        -318.760986328125,
        -2140.7294921875,
        645.2499389648438
      ],
      [
        -318.760986328125,
        -2140.7294921875,
        645.2499389648438
      ],
      [
        -319.0495910644531,
        -2140.896240234375,
        645.0
      ],
      [
        -319.760986328125,
        -2138.997314453125,
        645.2499389648438
      ],
      [
        -320.0495910644531,
        -2139.163818359375,
        645.0
      ],
      [
        -305.626953125,
        -2165.478271484375,
        644.4998168945312
      ],
      [
        -303.297119140625,
        -2162.442138671875,
        647.1517944335938
      ],
      [
        -303.297119140625,
        -2162.442138671875,
        647.1517944335938
      ],
      [
        -303.4555969238281,
        -2161.239013671875,
        647.5000610351562
      ],
      [
        -305.87005615234375,
        -2157.05712890625,
        647.5000610351562
      ],
      [
        -306.832763671875,
        -2156.318359375,
        647.1517944335938
      ],
      [
        -320.2043151855469,
        -2141.562744140625,
        643.9999389648438
      ],
      [
        -311.7043151855469,
        -2156.28515625,
        643.9999389648438
      ],
      [
        -312.3587341308594,
        -2157.817626953125,
        643.0
      ],
      [
        -307.35870361328125,
        -2166.47802734375,
        643.0
      ],
      [
        -311.92803955078125,
        -2157.562255859375,
        643.3755493164062
      ],
      [
        -312.3587341308594,
        -2157.817626953125,
        643.0
      ],
      [
        -310.626953125,
        -2156.81787109375,
        643.9999389648438
      ],
      [
        -311.92803955078125,
        -2157.562255859375,
        643.3755493164062
      ],
      [
        -311.2054443359375,
        -2157.14892578125,
        643.9999389648438
      ],
      [
        -311.7043151855469,
        -2156.28515625,
        643.9999389648438
      ],
      [
        -311.260009765625,
        -2156.030517578125,
        644.384033203125
      ],
      [
        -311.126953125,
        -2155.951904296875,
        644.5
      ],
      [
        -311.260009765625,
        -2156.030517578125,
        644.384033203125
      ],
      [
        -310.626953125,
        -2156.81787109375,
        644.4998168945312
      ],
      [
        -319.626953125,
        -2141.2294921875,
        644.4999389648438
      ],
      [
        -320.2043151855469,
        -2141.562744140625,
        643.9999389648438
      ],
      [
        -323.3673400878906,
        -2164.751220703125,
        643.0
      ],
      [
        -318.867431640625,
        -2172.545166015625,
        643.0
      ],
      [
        -320.0430908203125,
        -2162.252685546875,
        643.9999389648438
      ],
      [
        -320.1533203125,
        -2162.31787109375,
        643.9999389648438
      ],
      [
        -320.0430908203125,
        -2162.252685546875,
        643.9999389648438
      ],
      [
        -311.2054443359375,
        -2157.14892578125,
        643.9999389648438
      ],
      [
        -318.9489440917969,
        -2161.604736328125,
        643.9999389648438
      ],
      [
        -318.9353332519531,
        -2161.60888671875,
        658.0
      ],
      [
        -318.9524230957031,
        -2161.58154296875,
        653.9998779296875
      ],
      [
        -353.3381652832031,
        -2102.363525390625,
        645.9999389648438
      ],
      [
        -343.8673400878906,
        -2096.643798828125,
        645.9999389648438
      ],
      [
        -355.507568359375,
        -2108.482421875,
        646.0
      ],
      [
        -356.1262512207031,
        -2108.0078125,
        646.0
      ],
      [
        -359.34197998046875,
        -2101.172119140625,
        641.6248779296875
      ],
      [
        -355.40521240234375,
        -2109.260009765625,
        646.0
      ],
      [
        -355.507568359375,
        -2108.482421875,
        646.0
      ],
      [
        -330.019287109375,
        -2147.2294921875,
        646.0
      ],
      [
        -331.019287109375,
        -2145.497314453125,
        646.0
      ],
      [
        -319.760986328125,
        -2138.997314453125,
        646.0
      ],
      [
        -318.760986328125,
        -2140.7294921875,
        646.0
      ],
      [
        -353.21807861328125,
        -2111.714599609375,
        646.9999389648438
      ],
      [
        -352.9905700683594,
        -2113.442138671875,
        647.5
      ],
      [
        -355.40521240234375,
        -2109.260009765625,
        647.5000610351562
      ],
      [
        -355.507568359375,
        -2108.482421875,
        647.27490234375
      ],
      [
        -355.507568359375,
        -2108.482421875,
        647.27490234375
      ],
      [
        -356.1250305175781,
        -2108.0087890625,
        647.498291015625
      ],
      [
        -351.4681701660156,
        -2114.745361328125,
        646.9999389648438
      ],
      [
        -353.21807861328125,
        -2111.714599609375,
        646.9999389648438
      ],
      [
        -351.4681701660156,
        -2114.745361328125,
        646.9999389648438
      ],
      [
        -352.1414794921875,
        -2114.912841796875,
        647.5000610351562
      ],
      [
        -343.8673400878906,
        -2096.643798828125,
        645.9999389648438
      ],
      [
        -356.51251220703125,
        -2105.3818359375,
        646.9999389648438
      ],
      [
        -352.588623046875,
        -2103.011962890625,
        646.9999389648438
      ],
      [
        -352.588623046875,
        -2103.011962890625,
        646.9999389648438
      ],
      [
        -353.3381652832031,
        -2102.363525390625,
        645.9999389648438
      ],
      [
        -354.4248046875,
        -2106.984130859375,
        649.5999145507812
      ],
      [
        -356.1233215332031,
        -2108.010009765625,
        649.5999145507812
      ],
      [
        -354.4248046875,
        -2106.984130859375,
        649.5999145507812
      ],
      [
        -356.51251220703125,
        -2105.3818359375,
        646.9999389648438
      ],
      [
        -328.615234375,
        -2189.26123046875,
        648.0
      ],
      [
        -368.05169677734375,
        -2124.96240234375,
        641.6248779296875
      ],
      [
        -366.31658935546875,
        -2123.96044921875,
        647.9999389648438
      ],
      [
        -373.41796875,
        -2128.060546875,
        658.3230590820312
      ],
      [
        -378.614013671875,
        -2131.060546875,
        658.197509765625
      ],
      [
        -378.614013671875,
        -2131.060546875,
        658.197509765625
      ],
      [
        -373.41796875,
        -2128.060546875,
        658.3230590820312
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.7164306640625
      ],
      [
        -344.4078063964844,
        -2095.707763671875,
        645.9999389648438
      ],
      [
        -373.41796875,
        -2128.060546875,
        659.2132568359375
      ],
      [
        -378.614013671875,
        -2131.060546875,
        659.169189453125
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        659.0468139648438
      ],
      [
        -378.614013671875,
        -2131.060546875,
        659.169189453125
      ],
      [
        -373.41796875,
        -2128.060546875,
        659.2132568359375
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        659.3401489257812
      ],
      [
        -339.08587646484375,
        -2108.47021484375,
        659.7034912109375
      ],
      [
        -347.06121826171875,
        -2113.07470703125,
        659.6358642578125
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.7164306640625
      ],
      [
        -339.08587646484375,
        -2108.47021484375,
        659.7034912109375
      ],
      [
        -347.06121826171875,
        -2113.07470703125,
        659.6358642578125
      ],
      [
        -348.809326171875,
        -2114.083984375,
        659.6209716796875
      ],
      [
        -348.809326171875,
        -2114.083984375,
        659.6209716796875
      ],
      [
        -349.5128479003906,
        -2114.259033203125,
        659.4156494140625
      ],
      [
        -349.5128479003906,
        -2114.259033203125,
        658.9005126953125
      ],
      [
        -404.0048828125,
        -2136.482421875,
        650.9864501953125
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        656.66162109375
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        659.3401489257812
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        657.0379028320312
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        658.463134765625
      ],
      [
        -354.4888610839844,
        -2114.61181640625,
        657.1998901367188
      ],
      [
        -352.95513916015625,
        -2113.71142578125,
        657.1998901367188
      ],
      [
        -352.95513916015625,
        -2113.71142578125,
        657.1998901367188
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        658.4631958007812
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        657.037841796875
      ],
      [
        -354.4888610839844,
        -2114.61181640625,
        657.1998901367188
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        656.66162109375
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        659.0468139648438
      ],
      [
        -406.736328125,
        -2129.89404296875,
        643.92041015625
      ],
      [
        -403.0187072753906,
        -2125.0498046875,
        641.6248779296875
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        645.345703125
      ],
      [
        -404.0048828125,
        -2136.482421875,
        650.9864501953125
      ],
      [
        -354.310546875,
        -2101.522216796875,
        645.9999389648438
      ],
      [
        -344.4078063964844,
        -2095.707763671875,
        645.9999389648438
      ],
      [
        -360.365234375,
        -2104.755126953125,
        645.7219848632812
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        643.3367919921875
      ],
      [
        -366.7017822265625,
        -2103.7255859375,
        641.6248779296875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        644.3175659179688
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        644.3175659179688
      ],
      [
        -358.68206787109375,
        -2099.0166015625,
        641.6248779296875
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        643.3367919921875
      ],
      [
        -375.58990478515625,
        -2110.83935546875,
        643.25927734375
      ],
      [
        -391.0085754394531,
        -2119.7412109375,
        643.128662109375
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        643.0435791015625
      ],
      [
        -375.58990478515625,
        -2110.83935546875,
        643.25927734375
      ],
      [
        -376.16033935546875,
        -2109.279296875,
        641.6248779296875
      ],
      [
        -392.01971435546875,
        -2118.591552734375,
        641.6248779296875
      ],
      [
        -391.0085754394531,
        -2119.7412109375,
        643.128662109375
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        643.0435791015625
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        645.345703125
      ],
      [
        -359.0142822265625,
        -2105.791748046875,
        645.9999389648438
      ],
      [
        -360.365234375,
        -2104.755126953125,
        645.7219848632812
      ],
      [
        -360.1273193359375,
        -2104.937744140625,
        645.9999389648438
      ],
      [
        -357.0459289550781,
        -2107.302001953125,
        649.5999145507812
      ],
      [
        -357.5514831542969,
        -2104.58447265625,
        646.9999389648438
      ],
      [
        -353.51226806640625,
        -2102.212890625,
        646.9999389648438
      ],
      [
        -353.51226806640625,
        -2102.212890625,
        646.9999389648438
      ],
      [
        -354.310546875,
        -2101.522216796875,
        645.9999389648438
      ],
      [
        -355.3262939453125,
        -2106.292236328125,
        649.5999145507812
      ],
      [
        -357.5514831542969,
        -2104.58447265625,
        646.9999389648438
      ],
      [
        -355.3262939453125,
        -2106.292236328125,
        649.5999145507812
      ],
      [
        -357.0459289550781,
        -2107.302001953125,
        649.5999145507812
      ],
      [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -318.8418884277344,
        -2069.56640625,
        644.083251953125
      ],
      [
        -338.2374572753906,
        -2106.39501953125,
        663.9999389648438
      ],
      [
        -346.551025390625,
        -2091.995361328125,
        647.3677978515625
      ],
      [
        -347.8341979980469,
        -2089.772705078125,
        641.6876831054688
      ],
      [
        -347.51568603515625,
        -2090.324462890625,
        641.9765625
      ],
      [
        -342.9916687011719,
        -2083.39306640625,
        642.1755981445312
      ],
      [
        -347.8341979980469,
        -2089.772705078125,
        641.6876831054688
      ],
      [
        -349.3767395019531,
        -2087.100830078125,
        641.714599609375
      ],
      [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -342.9916687011719,
        -2083.39306640625,
        642.1755981445312
      ],
      [
        -339.4825744628906,
        -2107.225830078125,
        663.9999389648438
      ],
      [
        -348.8858947753906,
        -2113.50048828125,
        663.9999389648438
      ],
      [
        -338.2374572753906,
        -2106.39501953125,
        663.9999389648438
      ],
      [
        -339.4825744628906,
        -2107.225830078125,
        663.9999389648438
      ],
      [
        -346.24395751953125,
        -2121.33203125,
        671.9999389648438
      ],
      [
        -348.1908264160156,
        -2117.833984375,
        667.9999389648438
      ],
      [
        -350.0992126464844,
        -2114.40478515625,
        663.9999389648438
      ],
      [
        -348.809326171875,
        -2114.083984375,
        664.5289916992188
      ],
      [
        -350.0992126464844,
        -2114.40478515625,
        664.0789184570312
      ],
      [
        -348.809326171875,
        -2114.083984375,
        664.5289916992188
      ],
      [
        -348.8858947753906,
        -2113.50048828125,
        663.9999389648438
      ],
      [
        -350.3255920410156,
        -2114.461181640625,
        663.9999389648438
      ],
      [
        -349.51275634765625,
        -2114.259033203125,
        663.9999389648438
      ],
      [
        -349.5128479003906,
        -2114.259033203125,
        659.4156494140625
      ],
      [
        -373.5609436035156,
        -2126.518310546875,
        661.1256713867188
      ],
      [
        -379.53021240234375,
        -2130.2578125,
        660.9224853515625
      ],
      [
        -379.53021240234375,
        -2130.2578125,
        660.9224853515625
      ],
      [
        -393.2631530761719,
        -2138.861328125,
        660.4552001953125
      ],
      [
        -359.77593994140625,
        -2117.882568359375,
        661.5947265625
      ],
      [
        -373.5609436035156,
        -2126.518310546875,
        661.1256713867188
      ],
      [
        -350.3255920410156,
        -2114.461181640625,
        663.9999389648438
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        663.1448974609375
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        660.742919921875
      ],
      [
        -349.5128479003906,
        -2114.259033203125,
        660.0
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        660.7428588867188
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        663.1448974609375
      ],
      [
        -352.967529296875,
        -2113.6171875,
        661.8264770507812
      ],
      [
        -404.0048828125,
        -2136.482421875,
        652.4952392578125
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        658.3058471679688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.4821166992188
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0118408203125
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        646.9889526367188
      ],
      [
        -404.0048828125,
        -2136.482421875,
        652.4952392578125
      ],
      [
        -376.83917236328125,
        -2109.251220703125,
        644.9041137695312
      ],
      [
        -367.435791015625,
        -2103.822265625,
        645.6093139648438
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0118408203125
      ],
      [
        -391.8966369628906,
        -2117.944580078125,
        643.7750244140625
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        645.012451171875
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        646.989013671875
      ],
      [
        -395.3541259765625,
        -2139.71044921875,
        659.9999389648438
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        658.3058471679688
      ],
      [
        -357.4365234375,
        -2098.81787109375,
        646.9999389648438
      ],
      [
        -357.809326171875,
        -2098.495361328125,
        646.5236206054688
      ],
      [
        -367.435791015625,
        -2103.822265625,
        645.6093139648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9978637695312
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        647.6097412109375
      ],
      [
        -376.1389465332031,
        -2111.15625,
        646.882080078125
      ],
      [
        -390.5455322265625,
        -2119.473876953125,
        645.8018188476562
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        645.012451171875
      ],
      [
        -376.1389465332031,
        -2111.15625,
        646.882080078125
      ],
      [
        -376.83917236328125,
        -2109.251220703125,
        644.9041137695312
      ],
      [
        -391.8966369628906,
        -2117.944580078125,
        643.7750244140625
      ],
      [
        -390.5455322265625,
        -2119.473876953125,
        645.8018188476562
      ],
      [
        -359.34417724609375,
        -2103.208984375,
        649.5999145507812
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9979248046875
      ],
      [
        -353.2326965332031,
        -2111.603515625,
        659.9998168945312
      ],
      [
        -353.63916015625,
        -2108.516845703125,
        657.1998901367188
      ],
      [
        -353.2326965332031,
        -2111.603515625,
        659.9998168945312
      ],
      [
        -358.9751281738281,
        -2117.160400390625,
        661.4381713867188
      ],
      [
        -359.77593994140625,
        -2117.882568359375,
        661.5947265625
      ],
      [
        -355.7687683105469,
        -2114.268798828125,
        660.8111572265625
      ],
      [
        -358.9751281738281,
        -2117.160400390625,
        661.4381713867188
      ],
      [
        -360.365234375,
        -2104.755126953125,
        650.3209838867188
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        647.6097412109375
      ],
      [
        -359.34417724609375,
        -2103.208984375,
        649.5999145507812
      ],
      [
        -357.77392578125,
        -2104.4140625,
        649.5999145507812
      ],
      [
        -360.0830078125,
        -2103.701904296875,
        649.5999145507812
      ],
      [
        -360.365234375,
        -2104.755126953125,
        650.3209838867188
      ],
      [
        -360.0830078125,
        -2103.701904296875,
        649.5999145507812
      ],
      [
        -354.94622802734375,
        -2112.746826171875,
        659.9998168945312
      ],
      [
        -355.3525390625,
        -2109.66015625,
        657.1998901367188
      ],
      [
        -353.63916015625,
        -2108.516845703125,
        657.1998901367188
      ],
      [
        -355.3525390625,
        -2109.66015625,
        657.1998901367188
      ],
      [
        -393.2631530761719,
        -2138.861328125,
        660.4552001953125
      ],
      [
        -393.53826904296875,
        -2138.972900390625,
        660.3953247070312
      ],
      [
        -395.3540954589844,
        -2139.71044921875,
        659.9999389648438
      ],
      [
        -393.53826904296875,
        -2138.972900390625,
        660.3953247070312
      ],
      [
        -355.7687683105469,
        -2114.268798828125,
        660.8111572265625
      ],
      [
        -354.94622802734375,
        -2112.746826171875,
        659.9998168945312
      ],
      [
        -353.7374572753906,
        -2102.01806640625,
        646.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9978637695312
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        646.4585571289062
      ],
      [
        -358.2016906738281,
        -2099.328369140625,
        646.9999389648438
      ],
      [
        -357.4365234375,
        -2098.81787109375,
        646.9999389648438
      ],
      [
        -358.2016906738281,
        -2099.328369140625,
        646.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9979248046875
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        642.7212524414062
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        642.8890380859375
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.6248779296875
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        642.72119140625
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        646.4585571289062
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        646.2623291015625
      ],
      [
        -357.809326171875,
        -2098.495361328125,
        646.5236206054688
      ],
      [
        -346.551025390625,
        -2091.995361328125,
        647.3677978515625
      ],
      [
        -359.8144836425781,
        -2093.958251953125,
        641.6248779296875
      ],
      [
        -350.6198425292969,
        -2087.82275390625,
        641.6248779296875
      ],
      [
        -346.4175109863281,
        -2092.2265625,
        663.9999389648438
      ],
      [
        -356.1224670410156,
        -2099.954833984375,
        663.9998779296875
      ],
      [
        -380.8684387207031,
        -2119.660400390625,
        664.0
      ],
      [
        -398.94976806640625,
        -2134.058837890625,
        664.0
      ],
      [
        -354.783447265625,
        -2101.11328125,
        665.9998779296875
      ],
      [
        -358.3617858886719,
        -2103.962890625,
        665.9999389648438
      ],
      [
        -354.08966064453125,
        -2107.235107421875,
        671.9999389648438
      ],
      [
        -355.8055419921875,
        -2104.152099609375,
        667.9999389648438
      ],
      [
        -354.783447265625,
        -2101.11328125,
        665.9998779296875
      ],
      [
        -356.1224670410156,
        -2099.954833984375,
        663.9998779296875
      ],
      [
        -358.3617858886719,
        -2103.962890625,
        665.9999389648438
      ],
      [
        -359.7845153808594,
        -2102.87109375,
        663.9999389648438
      ],
      [
        -346.4175109863281,
        -2092.2265625,
        663.9999389648438
      ],
      [
        -346.551025390625,
        -2091.995361328125,
        663.6964721679688
      ],
      [
        -353.031982421875,
        -2080.769775390625,
        641.7785034179688
      ],
      [
        -356.1893310546875,
        -2075.301025390625,
        641.7887573242188
      ],
      [
        -353.2671203613281,
        -2073.195556640625,
        641.98779296875
      ],
      [
        -353.031982421875,
        -2080.769775390625,
        641.7785034179688
      ],
      [
        -349.3767395019531,
        -2087.100830078125,
        641.714599609375
      ],
      [
        -367.435791015625,
        -2103.822265625,
        659.3778076171875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        663.9115600585938
      ],
      [
        -384.5960693359375,
        -2113.729736328125,
        655.9999389648438
      ],
      [
        -378.26910400390625,
        -2110.076904296875,
        657.2453002929688
      ],
      [
        -378.26910400390625,
        -2110.076904296875,
        657.2453002929688
      ],
      [
        -367.435791015625,
        -2103.822265625,
        659.3778076171875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        652.55908203125
      ],
      [
        -389.9620056152344,
        -2116.827880859375,
        654.9437255859375
      ],
      [
        -389.5427551269531,
        -2118.89501953125,
        657.1021728515625
      ],
      [
        -375.13299560546875,
        -2110.57568359375,
        659.9387817382812
      ],
      [
        -374.82244873046875,
        -2110.396240234375,
        659.9999389648438
      ],
      [
        -375.13299560546875,
        -2110.57568359375,
        659.9387817382812
      ],
      [
        -389.5427551269531,
        -2118.89501953125,
        657.1021728515625
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        654.8319702148438
      ],
      [
        -384.5960693359375,
        -2113.729736328125,
        655.9999389648438
      ],
      [
        -389.3301696777344,
        -2117.49951171875,
        655.9999389648438
      ],
      [
        -389.9620056152344,
        -2116.827880859375,
        654.9437255859375
      ],
      [
        -389.3301696777344,
        -2117.49951171875,
        655.9999389648438
      ],
      [
        -405.2591857910156,
        -2127.96923828125,
        644.6990356445312
      ],
      [
        -402.07666015625,
        -2123.822265625,
        652.55908203125
      ],
      [
        -405.25897216796875,
        -2127.968994140625,
        654.0087890625
      ],
      [
        -352.967529296875,
        -2113.6171875,
        661.8263549804688
      ],
      [
        -353.3514709472656,
        -2110.70166015625,
        663.9999389648438
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        654.8319702148438
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        656.530517578125
      ],
      [
        -406.736328125,
        -2129.89404296875,
        654.6817626953125
      ],
      [
        -404.3441467285156,
        -2133.905029296875,
        659.9999389648438
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        656.530517578125
      ],
      [
        -374.82244873046875,
        -2110.396240234375,
        659.9999389648438
      ],
      [
        -375.01593017578125,
        -2110.69287109375,
        660.1279296875
      ],
      [
        -380.86859130859375,
        -2119.660400390625,
        664.0
      ],
      [
        -375.01593017578125,
        -2110.69287109375,
        660.1279296875
      ],
      [
        -356.35150146484375,
        -2105.505615234375,
        663.9999389648438
      ],
      [
        -359.7845153808594,
        -2102.87109375,
        663.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        663.9114990234375
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        660.7428588867188
      ],
      [
        -398.94976806640625,
        -2134.058837890625,
        664.0
      ],
      [
        -400.1060791015625,
        -2134.2314453125,
        663.3273315429688
      ],
      [
        -357.77386474609375,
        -2104.4140625,
        657.1998901367188
      ],
      [
        -400.1060791015625,
        -2134.2314453125,
        663.3273315429688
      ],
      [
        -401.7503967285156,
        -2134.10498046875,
        662.0364379882812
      ],
      [
        -404.3441467285156,
        -2133.905029296875,
        659.9999389648438
      ],
      [
        -401.7503967285156,
        -2134.10498046875,
        662.0364379882812
      ],
      [
        -346.551025390625,
        -2091.995361328125,
        663.6964721679688
      ],
      [
        -351.3818359375,
        -2087.43603515625,
        656.1393432617188
      ],
      [
        -358.5946044921875,
        -2077.0341796875,
        641.6248779296875
      ],
      [
        -360.30859375,
        -2091.77294921875,
        653.6477661132812
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        651.2236938476562
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        661.3096313476562
      ],
      [
        -358.9546813964844,
        -2097.7607421875,
        659.9999389648438
      ],
      [
        -360.0203857421875,
        -2093.047607421875,
        654.9999389648438
      ],
      [
        -360.30859375,
        -2091.77294921875,
        653.6477661132812
      ],
      [
        -358.1379089355469,
        -2097.1103515625,
        659.9999389648438
      ],
      [
        -357.809326171875,
        -2098.495361328125,
        661.4803466796875
      ],
      [
        -359.2476501464844,
        -2092.43212890625,
        654.9999389648438
      ],
      [
        -359.342529296875,
        -2092.0322265625,
        654.572509765625
      ],
      [
        -359.2476501464844,
        -2092.43212890625,
        654.9999389648438
      ],
      [
        -358.1379089355469,
        -2097.1103515625,
        659.9999389648438
      ],
      [
        -358.1379089355469,
        -2097.1103515625,
        659.9999389648438
      ],
      [
        -359.2476501464844,
        -2092.43212890625,
        654.9999389648438
      ],
      [
        -356.68017578125,
        -2087.451171875,
        652.3602294921875
      ],
      [
        -351.3818359375,
        -2087.43603515625,
        656.1393432617188
      ],
      [
        -359.342529296875,
        -2092.0322265625,
        654.572509765625
      ],
      [
        -356.68017578125,
        -2087.451171875,
        652.3602294921875
      ],
      [
        -359.2476501464844,
        -2092.43212890625,
        654.9999389648438
      ],
      [
        -360.0203857421875,
        -2093.047607421875,
        654.9999389648438
      ],
      [
        -358.9546813964844,
        -2097.7607421875,
        659.9999389648438
      ],
      [
        -358.1379089355469,
        -2097.1103515625,
        659.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        663.9115600585938
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        661.3096313476562
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        663.9114990234375
      ],
      [
        -357.809326171875,
        -2098.495361328125,
        661.4803466796875
      ],
      [
        -346.7029113769531,
        -2091.85205078125,
        663.9999389648438
      ],
      [
        -357.8575439453125,
        -2098.292236328125,
        663.9998779296875
      ],
      [
        -357.8575439453125,
        -2098.292236328125,
        661.26318359375
      ],
      [
        -357.8575439453125,
        -2098.292236328125,
        663.9998779296875
      ],
      [
        -346.7029113769531,
        -2091.85205078125,
        663.9999389648438
      ],
      [
        -346.7029113769531,
        -2091.85205078125,
        663.4588623046875
      ],
      [
        -358.7216796875,
        -2098.791259765625,
        667.9999389648438
      ],
      [
        -358.7216796875,
        -2098.791259765625,
        671.9999389648438
      ],
      [
        -358.7216796875,
        -2098.791259765625,
        667.9999389648438
      ],
      [
        -358.7217102050781,
        -2098.791259765625,
        661.093017578125
      ],
      [
        -360.30859375,
        -2091.77294921875,
        663.9999389648438
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        663.9999389648438
      ],
      [
        -357.7043151855469,
        -2087.454345703125,
        654.9999389648438
      ],
      [
        -357.7043151855469,
        -2087.454345703125,
        659.9999389648438
      ],
      [
        -376.8465881347656,
        -2335.287109375,
        637.0
      ],
      [
        -376.8465881347656,
        -2333.129150390625,
        637.0
      ],
      [
        -376.8465881347656,
        -2333.129150390625,
        637.0
      ],
      [
        -376.84674072265625,
        -2319.006103515625,
        637.0
      ],
      [
        -376.8466491699219,
        -2335.287109375,
        652.0
      ],
      [
        -376.8465881347656,
        -2335.287109375,
        637.0
      ],
      [
        -376.8466491699219,
        -2334.37060546875,
        653.05908203125
      ],
      [
        -376.8466491699219,
        -2333.129150390625,
        654.5
      ],
      [
        -376.8466491699219,
        -2335.287109375,
        652.0
      ],
      [
        -376.8466491699219,
        -2334.37060546875,
        653.05908203125
      ],
      [
        -376.8467712402344,
        -2319.006103515625,
        638.002197265625
      ],
      [
        -376.8468017578125,
        -2314.728515625,
        638.002197265625
      ],
      [
        -376.84686279296875,
        -2314.728515625,
        652.0
      ],
      [
        -376.8468322753906,
        -2319.005859375,
        652.0
      ],
      [
        -376.84722900390625,
        -2282.430908203125,
        660.0
      ],
      [
        -376.8474426269531,
        -2260.360107421875,
        660.0
      ],
      [
        -376.84747314453125,
        -2259.277587890625,
        660.0
      ],
      [
        -376.8474426269531,
        -2260.360107421875,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.8076171875,
        660.0
      ],
      [
        -376.84747314453125,
        -2259.277587890625,
        660.0
      ],
      [
        -376.84722900390625,
        -2282.430908203125,
        660.0
      ],
      [
        -376.84716796875,
        -2282.430908203125,
        645.0
      ],
      [
        -285.0,
        -2392.0,
        640.0
      ],
      [
        -285.0,
        -2392.0,
        672.0
      ],
      [
        -246.6703338623047,
        -2278.4169921875,
        629.0
      ],
      [
        -246.6703338623047,
        -2278.4169921875,
        660.0
      ],
      [
        -284.2815246582031,
        -2369.218505859375,
        660.5
      ],
      [
        -285.0,
        -2370.952880859375,
        660.5
      ],
      [
        -255.0,
        -2331.5,
        652.0
      ],
      [
        -262.233154296875,
        -2326.44140625,
        652.0
      ],
      [
        -246.6703338623047,
        -2278.4169921875,
        660.0
      ],
      [
        -244.363037109375,
        -2272.8466796875,
        660.0
      ],
      [
        -244.363037109375,
        -2272.8466796875,
        660.0
      ],
      [
        -241.24147033691406,
        -2265.310546875,
        660.0
      ],
      [
        -241.24147033691406,
        -2265.310546875,
        660.0
      ],
      [
        -238.06411743164062,
        -2257.6396484375,
        660.0
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        660.5
      ],
      [
        -285.0,
        -2370.952880859375,
        660.5
      ],
      [
        -290.4967041015625,
        -2384.22314453125,
        641.0
      ],
      [
        -290.4967041015625,
        -2384.22314453125,
        651.5
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        651.30615234375
      ],
      [
        -314.350341796875,
        -2219.08642578125,
        653.0
      ],
      [
        -312.0603332519531,
        -2223.052734375,
        653.0
      ],
      [
        -314.350341796875,
        -2219.08642578125,
        653.0
      ],
      [
        -310.4394836425781,
        -2225.860107421875,
        653.0
      ],
      [
        -312.0603332519531,
        -2223.052734375,
        653.0
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        651.30615234375
      ],
      [
        -310.4394836425781,
        -2225.860107421875,
        653.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        660.0
      ],
      [
        -353.4643249511719,
        -2247.841064453125,
        660.0
      ],
      [
        -325.4989318847656,
        -2234.0,
        653.0
      ],
      [
        -325.6121826171875,
        -2234.0,
        652.8060913085938
      ],
      [
        -325.6121826171875,
        -2234.0,
        652.8060913085938
      ],
      [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      [
        -326.0,
        -2233.132080078125,
        653.0
      ],
      [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      [
        -325.4989318847656,
        -2234.0,
        653.0
      ],
      [
        -326.0,
        -2233.132080078125,
        653.0
      ],
      [
        -326.0,
        -2232.133544921875,
        637.4000244140625
      ],
      [
        -326.0,
        -2234.0,
        640.666259765625
      ],
      [
        -325.0197448730469,
        -2234.0,
        637.6951904296875
      ],
      [
        -324.9223937988281,
        -2234.0,
        637.4000244140625
      ],
      [
        -326.0,
        -2234.0,
        640.666259765625
      ],
      [
        -325.0197448730469,
        -2234.0,
        637.6951904296875
      ],
      [
        -326.0,
        -2232.133544921875,
        637.4000244140625
      ],
      [
        -324.9223937988281,
        -2234.0,
        637.4000244140625
      ],
      [
        -310.0,
        -2229.837890625,
        637.4000244140625
      ],
      [
        -320.0486755371094,
        -2234.0,
        637.4000244140625
      ],
      [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      [
        -326.0,
        -2234.0,
        641.0
      ],
      [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        641.0
      ],
      [
        -314.686279296875,
        -2218.6904296875,
        641.0
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        641.0
      ],
      [
        -310.0,
        -2227.60009765625,
        641.0
      ],
      [
        -314.686279296875,
        -2218.6904296875,
        641.0
      ],
      [
        -319.199951171875,
        -2217.199951171875,
        641.0
      ],
      [
        -320.0486755371094,
        -2234.0,
        637.4000244140625
      ],
      [
        -320.0487060546875,
        -2234.0,
        638.002197265625
      ],
      [
        -324.0,
        -2234.0,
        641.0
      ],
      [
        -326.0,
        -2234.0,
        641.0
      ],
      [
        -324.0,
        -2235.63671875,
        638.002197265625
      ],
      [
        -320.0487060546875,
        -2234.0,
        638.002197265625
      ],
      [
        -324.0,
        -2234.0,
        641.0
      ],
      [
        -324.0,
        -2235.63671875,
        638.002197265625
      ],
      [
        -324.0,
        -2235.63671875,
        641.0
      ],
      [
        -319.199951171875,
        -2217.199951171875,
        641.0
      ],
      [
        -310.0,
        -2229.837890625,
        637.4000244140625
      ],
      [
        -310.0,
        -2227.60009765625,
        641.0
      ],
      [
        -310.0,
        -2229.837890625,
        641.0
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        642.6163940429688
      ],
      [
        -313.05364990234375,
        -2220.61474609375,
        641.0
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        642.6163940429688
      ],
      [
        -310.76177978515625,
        -2224.584228515625,
        641.0
      ],
      [
        -320.0486755371094,
        -2234.0,
        653.0
      ],
      [
        -310.0,
        -2229.837890625,
        653.0
      ],
      [
        -310.0,
        -2229.837890625,
        653.0
      ],
      [
        -320.0486755371094,
        -2234.0,
        653.0
      ],
      [
        -320.0487060546875,
        -2234.0,
        652.0
      ],
      [
        -324.0,
        -2235.63671875,
        652.0
      ],
      [
        -320.0487060546875,
        -2234.0,
        652.0
      ],
      [
        -324.0,
        -2235.63671875,
        652.0
      ],
      [
        -322.2908630371094,
        -2216.714599609375,
        641.0
      ],
      [
        -324.13885498046875,
        -2217.769775390625,
        651.0
      ],
      [
        -327.48822021484375,
        -2219.71875,
        651.0
      ],
      [
        -327.4789733886719,
        -2219.733642578125,
        641.0
      ],
      [
        -327.48822021484375,
        -2219.71875,
        651.0
      ],
      [
        -325.6257629394531,
        -2218.635009765625,
        651.0
      ],
      [
        -327.4913330078125,
        -2219.7138671875,
        641.0
      ],
      [
        -324.6006164550781,
        -2218.03857421875,
        651.0
      ],
      [
        -282.5357971191406,
        -2247.84130859375,
        660.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        660.0
      ],
      [
        -241.1126251220703,
        -2264.99951171875,
        660.0
      ],
      [
        -257.0802001953125,
        -2258.385498046875,
        660.0
      ],
      [
        -315.9516296386719,
        -2234.0,
        637.4000244140625
      ],
      [
        -315.9516296386719,
        -2234.0,
        638.002197265625
      ],
      [
        -315.9516296386719,
        -2234.0,
        653.0
      ],
      [
        -315.9516296386719,
        -2234.0,
        652.0
      ],
      [
        -312.0,
        -2235.636962890625,
        638.002197265625
      ],
      [
        -312.0,
        -2235.636962890625,
        652.0
      ],
      [
        -312.0,
        -2235.636962890625,
        652.0
      ],
      [
        -315.9516296386719,
        -2234.0,
        652.0
      ],
      [
        -315.9516296386719,
        -2234.0,
        638.002197265625
      ],
      [
        -312.0,
        -2235.636962890625,
        638.002197265625
      ],
      [
        -315.9516296386719,
        -2234.0,
        637.4000244140625
      ],
      [
        -318.0001525878906,
        -2233.151611328125,
        637.4000244140625
      ],
      [
        -315.9516296386719,
        -2234.0,
        653.0
      ],
      [
        -318.0001525878906,
        -2233.151611328125,
        653.0
      ],
      [
        -351.0,
        -2392.0,
        640.0
      ],
      [
        -351.0,
        -2392.0,
        672.0
      ],
      [
        -372.2547607421875,
        -2325.815185546875,
        652.0
      ],
      [
        -372.2547607421875,
        -2325.815185546875,
        638.002197265625
      ],
      [
        -376.8466491699219,
        -2327.717041015625,
        637.0
      ],
      [
        -373.7668151855469,
        -2326.44140625,
        637.0
      ],
      [
        -376.8467102050781,
        -2321.22314453125,
        637.0
      ],
      [
        -375.2789306640625,
        -2322.791015625,
        637.0
      ],
      [
        -375.279052734375,
        -2322.790771484375,
        652.0
      ],
      [
        -372.2547607421875,
        -2325.815185546875,
        652.0
      ],
      [
        -372.2547607421875,
        -2325.815185546875,
        638.002197265625
      ],
      [
        -375.2790222167969,
        -2322.790771484375,
        638.002197265625
      ],
      [
        -259.15283203125,
        -2260.359375,
        660.0
      ],
      [
        -259.15283203125,
        -2282.430908203125,
        660.0
      ],
      [
        -259.15283203125,
        -2260.359375,
        660.0
      ],
      [
        -259.15283203125,
        -2259.27734375,
        660.0
      ],
      [
        -259.15283203125,
        -2259.27734375,
        660.0
      ],
      [
        -259.15283203125,
        -2258.8076171875,
        660.0
      ],
      [
        -259.15283203125,
        -2258.8076171875,
        660.0
      ],
      [
        -259.15283203125,
        -2258.466796875,
        660.0
      ],
      [
        -259.15283203125,
        -2282.430908203125,
        645.0
      ],
      [
        -259.15283203125,
        -2282.430908203125,
        660.0
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        656.0
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        649.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        649.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      [
        -259.15283203125,
        -2272.471923828125,
        660.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        657.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      [
        -376.8473205566406,
        -2272.471923828125,
        660.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        657.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        657.0
      ],
      [
        -376.5,
        -2282.5,
        657.0
      ],
      [
        -376.84722900390625,
        -2282.430908203125,
        657.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        649.0
      ],
      [
        -376.5,
        -2282.5,
        649.0
      ],
      [
        -376.8471984863281,
        -2282.430908203125,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        657.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      [
        -259.15283203125,
        -2282.430908203125,
        657.0
      ],
      [
        -259.5,
        -2282.5,
        657.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      [
        -259.15283203125,
        -2282.430908203125,
        649.0
      ],
      [
        -259.5,
        -2282.5,
        649.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      [
        -304.9999084472656,
        -2289.23388671875,
        620.0
      ],
      [
        -304.0915832519531,
        -2290.865966796875,
        620.4541625976562
      ],
      [
        -305.317138671875,
        -2292.359130859375,
        634.9540405273438
      ],
      [
        -331.9084167480469,
        -2290.865966796875,
        620.4541625976562
      ],
      [
        -331.0000915527344,
        -2289.23388671875,
        620.0
      ],
      [
        -330.682861328125,
        -2292.359130859375,
        634.9540405273438
      ],
      [
        -331.6534118652344,
        -2296.0,
        694.0
      ],
      [
        -341.6532897949219,
        -2296.0,
        704.0
      ],
      [
        -304.6982421875,
        -2296.0,
        694.0
      ],
      [
        -294.6982116699219,
        -2296.0,
        704.0
      ],
      [
        -319.5,
        -2283.304931640625,
        694.0
      ],
      [
        -317.0,
        -2283.304931640625,
        694.0
      ],
      [
        -317.0,
        -2273.30517578125,
        704.0
      ],
      [
        -319.5,
        -2273.30517578125,
        704.0
      ],
      [
        -319.5,
        -2273.30517578125,
        704.0
      ],
      [
        -317.0,
        -2273.30517578125,
        704.0
      ],
      [
        -317.0,
        -2273.30517578125,
        712.0
      ],
      [
        -319.5,
        -2273.30517578125,
        712.0
      ],
      [
        -317.0,
        -2283.304931640625,
        694.0
      ],
      [
        -319.5,
        -2283.304931640625,
        694.0
      ],
      [
        -319.5,
        -2283.304931640625,
        687.5
      ],
      [
        -317.0,
        -2283.304931640625,
        687.5
      ],
      [
        -317.0,
        -2283.304931640625,
        690.8841552734375
      ],
      [
        -304.6982421875,
        -2291.199951171875,
        687.5
      ],
      [
        -312.59326171875,
        -2283.30517578125,
        687.5
      ],
      [
        -312.59326171875,
        -2283.30517578125,
        687.5
      ],
      [
        -259.14990234375,
        -2294.0,
        687.5
      ],
      [
        -315.0,
        -2238.0,
        687.5
      ],
      [
        -319.5,
        -2283.304931640625,
        690.98876953125
      ],
      [
        -323.758544921875,
        -2283.304931640625,
        687.5
      ],
      [
        -331.6533203125,
        -2291.2001953125,
        687.5
      ],
      [
        -323.758544921875,
        -2283.304931640625,
        687.5
      ],
      [
        -376.840087890625,
        -2294.0,
        687.5
      ],
      [
        -321.5,
        -2238.0,
        687.5
      ],
      [
        -319.11553955078125,
        -2355.699951171875,
        656.0
      ],
      [
        -287.44775390625,
        -2342.578125,
        656.0
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        656.0
      ],
      [
        -319.11553955078125,
        -2355.699951171875,
        649.5
      ],
      [
        -287.44775390625,
        -2342.578125,
        649.5
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        649.5
      ],
      [
        -319.115478515625,
        -2355.699951171875,
        643.0
      ],
      [
        -317.7434997558594,
        -2350.796142578125,
        649.5
      ],
      [
        -341.53460693359375,
        -2350.796142578125,
        656.0
      ],
      [
        -341.53460693359375,
        -2350.796142578125,
        649.5
      ],
      [
        -317.7434997558594,
        -2350.796142578125,
        649.5
      ],
      [
        -312.51226806640625,
        -2352.9638671875,
        649.5
      ],
      [
        -348.55615234375,
        -2342.578125,
        656.0
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        656.0
      ],
      [
        -348.55615234375,
        -2342.578125,
        649.5
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        649.5
      ],
      [
        -328.9652404785156,
        -2288.511962890625,
        687.5
      ],
      [
        -331.6533203125,
        -2291.2001953125,
        684.9931030273438
      ],
      [
        -372.79205322265625,
        -2275.351806640625,
        657.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        657.0
      ],
      [
        -348.556396484375,
        -2251.1162109375,
        657.0
      ],
      [
        -372.79205322265625,
        -2275.351806640625,
        649.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        649.0
      ],
      [
        -348.556396484375,
        -2251.1162109375,
        649.0
      ],
      [
        -372.7919921875,
        -2275.351806640625,
        644.0
      ],
      [
        -263.2077941894531,
        -2275.35205078125,
        657.0
      ],
      [
        -287.443603515625,
        -2251.1162109375,
        657.0
      ],
      [
        -284.665771484375,
        -2246.958984375,
        657.0
      ],
      [
        -263.2077941894531,
        -2275.35205078125,
        649.0
      ],
      [
        -287.443603515625,
        -2251.1162109375,
        649.0
      ],
      [
        -284.665771484375,
        -2246.958984375,
        649.0
      ],
      [
        -263.2078857421875,
        -2275.35205078125,
        644.0
      ],
      [
        -324.4585876464844,
        -2284.005126953125,
        687.5
      ],
      [
        -313.58343505859375,
        -2283.30517578125,
        687.5
      ],
      [
        -742.0281982421875,
        -2313.18505859375,
        639.28125
      ],
      [
        -714.501953125,
        -2350.78662109375,
        639.3538208007812
      ],
      [
        -753.1447143554688,
        -2297.6806640625,
        627.40771484375
      ],
      [
        -757.0588989257812,
        -2296.81787109375,
        639.2581787109375
      ],
      [
        -758.4227294921875,
        -2290.446044921875,
        626.4732666015625
      ],
      [
        -758.4227294921875,
        -2290.446044921875,
        626.4732666015625
      ],
      [
        -757.0588989257812,
        -2296.81787109375,
        639.2581787109375
      ],
      [
        -758.8818969726562,
        -2290.162109375,
        639.2235717773438
      ],
      [
        -744.9747314453125,
        -2309.16015625,
        639.28125
      ],
      [
        -742.0281982421875,
        -2313.18505859375,
        639.28125
      ],
      [
        -760.4086303710938,
        -2289.218017578125,
        681.6158447265625
      ],
      [
        -837.6822509765625,
        -2184.484375,
        712.0
      ],
      [
        -837.9893188476562,
        -2183.86376953125,
        704.5283813476562
      ],
      [
        -751.966796875,
        -2303.48095703125,
        639.2774658203125
      ],
      [
        -752.1113891601562,
        -2299.47509765625,
        641.6248779296875
      ],
      [
        -751.0709228515625,
        -2300.896484375,
        641.6248779296875
      ],
      [
        -752.4519653320312,
        -2302.712646484375,
        641.6248779296875
      ],
      [
        -750.2799072265625,
        -2301.97705078125,
        641.6248779296875
      ],
      [
        -751.685302734375,
        -2303.782470703125,
        641.6248779296875
      ],
      [
        -761.5029296875,
        -2288.54150390625,
        712.0
      ],
      [
        -762.23095703125,
        -2301.5322265625,
        712.0
      ],
      [
        -740.9509887695312,
        -2328.661376953125,
        712.0
      ],
      [
        -740.5066528320312,
        -2329.119384765625,
        712.0
      ],
      [
        -879.5546264648438,
        -2495.927001953125,
        687.720458984375
      ],
      [
        -879.5546264648438,
        -2495.927001953125,
        687.720458984375
      ],
      [
        -902.8463745117188,
        -2520.06982421875,
        687.8468627929688
      ],
      [
        -930.0518798828125,
        -2560.52392578125,
        688.0962524414062
      ],
      [
        -902.8463745117188,
        -2520.06982421875,
        687.8468627929688
      ],
      [
        -804.64013671875,
        -2437.5029296875,
        687.4735107421875
      ],
      [
        -721.693115234375,
        -2348.508544921875,
        712.0
      ],
      [
        -725.3448486328125,
        -2344.7451171875,
        712.0
      ],
      [
        -712.4946899414062,
        -2354.813232421875,
        687.0797729492188
      ],
      [
        -879.8209228515625,
        -2495.801513671875,
        687.4075927734375
      ],
      [
        -930.3886108398438,
        -2560.419189453125,
        687.586669921875
      ],
      [
        -902.7665405273438,
        -2519.517333984375,
        687.478759765625
      ],
      [
        -879.8209228515625,
        -2495.801513671875,
        687.4075927734375
      ],
      [
        -902.7665405273438,
        -2519.517333984375,
        687.478759765625
      ],
      [
        -712.5010986328125,
        -2354.80078125,
        686.94580078125
      ],
      [
        -885.3936767578125,
        -2493.174072265625,
        680.860107421875
      ],
      [
        -849.696044921875,
        -2448.864013671875,
        687.2857666015625
      ],
      [
        -920.6704711914062,
        -2532.8935546875,
        676.42431640625
      ],
      [
        -901.159423828125,
        -2508.394775390625,
        680.0682373046875
      ],
      [
        -885.3936767578125,
        -2493.174072265625,
        680.860107421875
      ],
      [
        -901.159423828125,
        -2508.394775390625,
        680.0682373046875
      ],
      [
        -932.1755981445312,
        -2559.8056640625,
        677.4135131835938
      ],
      [
        -920.6704711914062,
        -2532.8935546875,
        676.42431640625
      ],
      [
        -922.5493774414062,
        -2539.2939453125,
        674.172119140625
      ],
      [
        -928.8388671875,
        -2560.71826171875,
        666.63330078125
      ],
      [
        -922.5493774414062,
        -2539.2939453125,
        674.172119140625
      ],
      [
        -749.12939453125,
        -2303.485107421875,
        639.28125
      ],
      [
        -749.1597900390625,
        -2303.507080078125,
        641.6248779296875
      ],
      [
        -749.12939453125,
        -2303.485107421875,
        639.28125
      ],
      [
        -749.1597900390625,
        -2303.507080078125,
        641.6248779296875
      ],
      [
        -710.5648803710938,
        -2352.47119140625,
        666.9880981445312
      ],
      [
        -786.7236328125,
        -2240.106689453125,
        712.0
      ],
      [
        -789.1318359375,
        -2233.482666015625,
        607.4151611328125
      ],
      [
        -762.0603637695312,
        -2273.451416015625,
        592.373291015625
      ],
      [
        -766.508056640625,
        -2270.27880859375,
        712.0
      ],
      [
        -726.7151489257812,
        -2327.56396484375,
        639.28125
      ],
      [
        -712.6064453125,
        -2348.622802734375,
        639.3294677734375
      ],
      [
        -759.3040771484375,
        -2277.6103515625,
        593.9219970703125
      ],
      [
        -762.0603637695312,
        -2273.451416015625,
        592.373291015625
      ],
      [
        -744.885498046875,
        -2300.444091796875,
        639.28125
      ],
      [
        -726.7151489257812,
        -2327.56396484375,
        639.28125
      ],
      [
        -747.693603515625,
        -2296.32080078125,
        641.6248779296875
      ],
      [
        -744.9161376953125,
        -2300.46630859375,
        641.6248779296875
      ],
      [
        -744.9161376953125,
        -2300.46630859375,
        641.6248779296875
      ],
      [
        -744.885498046875,
        -2300.444091796875,
        639.28125
      ],
      [
        -710.4674072265625,
        -2352.415283203125,
        666.5953979492188
      ],
      [
        -762.185791015625,
        -2272.865478515625,
        591.1973876953125
      ],
      [
        -766.708251953125,
        -2269.54833984375,
        712.0
      ],
      [
        -785.4612426757812,
        -2241.484619140625,
        712.0
      ],
      [
        -788.004150390625,
        -2234.6279296875,
        605.1737670898438
      ],
      [
        -744.742919921875,
        -2300.342041015625,
        639.28125
      ],
      [
        -726.2785034179688,
        -2327.973876953125,
        639.28125
      ],
      [
        -759.5247192382812,
        -2276.891357421875,
        592.7225341796875
      ],
      [
        -762.185791015625,
        -2272.865478515625,
        591.1973876953125
      ],
      [
        -726.2785034179688,
        -2327.973876953125,
        639.28125
      ],
      [
        -712.5354614257812,
        -2348.541748046875,
        639.3285522460938
      ],
      [
        -747.5454711914062,
        -2296.215087890625,
        641.6248779296875
      ],
      [
        -744.7731323242188,
        -2300.36376953125,
        641.6248779296875
      ],
      [
        -744.7731323242188,
        -2300.36376953125,
        641.6248779296875
      ],
      [
        -744.742919921875,
        -2300.342041015625,
        639.28125
      ],
      [
        -735.7808837890625,
        -2293.92041015625,
        639.28125
      ],
      [
        -738.2061767578125,
        -2289.547119140625,
        641.6248779296875
      ],
      [
        -735.8455200195312,
        -2293.966796875,
        641.6248779296875
      ],
      [
        -735.8455200195312,
        -2293.966796875,
        641.6248779296875
      ],
      [
        -735.7808837890625,
        -2293.92041015625,
        639.28125
      ],
      [
        -713.9149169921875,
        -2278.452392578125,
        639.28125
      ],
      [
        -704.7401123046875,
        -2341.316650390625,
        639.28125
      ],
      [
        -714.5120239257812,
        -2278.6806640625,
        641.6248779296875
      ],
      [
        -714.0125122070312,
        -2278.32275390625,
        639.5737915039062
      ],
      [
        -714.69677734375,
        -2277.414794921875,
        641.6248779296875
      ],
      [
        -714.5120239257812,
        -2278.6806640625,
        641.6248779296875
      ],
      [
        -705.3095092773438,
        -2341.73486328125,
        641.6248779296875
      ],
      [
        -704.3577880859375,
        -2348.25634765625,
        641.6248779296875
      ],
      [
        -705.3095092773438,
        -2341.73486328125,
        641.6248779296875
      ],
      [
        -704.7401123046875,
        -2341.316650390625,
        639.28125
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -2.6478233337402344,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -194.8513946533203,
        -1929.899169921875,
        754.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -194.8513946533203,
        -1924.322509765625,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.440481036901474,
        -0.8977619409561157,
        0.0
      ],
      "plane_d": -1797.645263671875,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -2.6478233337402344,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -51.42585754394531,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4577594995498657,
        -0.8173955082893372,
        0.3497438430786133
      ],
      "plane_d": -1698.0321044921875,
      "bbox_min": [
        -528.131103515625,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -299.8731384277344,
        -1907.083251953125,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.476491779088974,
        -0.7905871868133545,
        0.3846135139465332
      ],
      "plane_d": -1664.8924560546875,
      "bbox_min": [
        -528.131103515625,
        -2000.3544921875,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1907.9791259765625,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47970375418663025,
        -0.768060028553009,
        0.42422646284103394
      ],
      "plane_d": -1652.64599609375,
      "bbox_min": [
        -528.131103515625,
        -2000.3544921875,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1911.1502685546875,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -442.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        904.8359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1967.46337890625,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        871.3511962890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -360.0,
        -1939.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        796.7986450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -417.9999694824219,
        -1967.46337890625,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        837.8663330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        800.2041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1967.46337890625,
        778.7999267578125
      ],
      "bbox_max": [
        -369.9740295410156,
        -1950.0,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -398.94903564453125,
        -1953.6666259765625,
        788.1215209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -406.8780212402344,
        -1972.0,
        788.1215209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -528.131103515625,
        -2000.3544921875,
        833.3432006835938
      ],
      "bbox_max": [
        -379.359375,
        -1911.1502685546875,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -442.0,
        -1938.574951171875,
        880.78662109375
      ],
      "bbox_max": [
        -433.46563720703125,
        -1928.0,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -437.50244140625,
        -1938.574951171875,
        880.78662109375
      ],
      "bbox_max": [
        -435.8409729003906,
        -1937.4423828125,
        886.2202758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        880.78662109375
      ],
      "bbox_max": [
        -435.8409729003906,
        -1937.4423828125,
        886.2202758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703570008277893,
        -0.7688688039779663,
        0.433133989572525
      ],
      "plane_d": -1666.133544921875,
      "bbox_min": [
        -435.970703125,
        -1950.0,
        833.3432006835938
      ],
      "bbox_max": [
        -379.359375,
        -1911.1502685546875,
        886.5997314453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -435.970703125,
        -1950.0,
        833.3432006835938
      ],
      "bbox_max": [
        -414.0,
        -1935.8154296875,
        881.0968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.4741516113281,
        -1939.0,
        871.3511962890625
      ],
      "bbox_max": [
        -430.0,
        -1935.8154296875,
        881.0968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        833.3432006835938
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        843.8737182617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -435.970703125,
        -1939.0,
        863.5264282226562
      ],
      "bbox_max": [
        -422.5,
        -1935.8155517578125,
        886.5997314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1939.0,
        863.5264282226562
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        875.7761840820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        880.6350708007812
      ],
      "bbox_max": [
        -433.3038330078125,
        -1935.9715576171875,
        886.2141723632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -528.131103515625,
        -2000.3544921875,
        777.5933227539062
      ],
      "bbox_max": [
        -348.0,
        -1907.9791259765625,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -441.5986022949219,
        -1940.653564453125,
        885.9445190429688
      ],
      "bbox_max": [
        -433.4481201171875,
        -1928.367919921875,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -440.5136413574219,
        -1940.653564453125,
        885.9445190429688
      ],
      "bbox_max": [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        886.2141723632812
      ],
      "bbox_max": [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -435.8409729003906,
        -1968.8211669921875,
        777.5933227539062
      ],
      "bbox_max": [
        -348.0,
        -1907.9791259765625,
        898.0882568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -370.3378601074219,
        -1950.21923828125,
        777.5933227539062
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        804.571044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -369.0,
        -1939.0,
        789.0541381835938
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        804.571044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        789.0541381835938
      ],
      "bbox_max": [
        -360.0,
        -1939.0,
        804.119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -422.5,
        -1968.8211669921875,
        778.600341796875
      ],
      "bbox_max": [
        -366.64593505859375,
        -1939.0,
        844.0005493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -422.5,
        -1950.0,
        778.7999267578125
      ],
      "bbox_max": [
        -366.64593505859375,
        -1939.0,
        844.0005493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.8727416992188
      ],
      "bbox_max": [
        -366.64593505859375,
        -1939.0,
        805.4290161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        833.3432006835938
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        844.0005493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        778.600341796875
      ],
      "bbox_max": [
        -369.0,
        -1949.9139404296875,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -435.8409729003906,
        -1950.0,
        802.5244750976562
      ],
      "bbox_max": [
        -366.1393737792969,
        -1935.8231201171875,
        898.0882568359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -435.8409729003906,
        -1939.0,
        875.7761840820312
      ],
      "bbox_max": [
        -430.0,
        -1935.8231201171875,
        898.0882568359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1940.63623046875,
        802.5244750976562
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        806.3486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -441.18359375,
        -1941.115966796875,
        896.0842895507812
      ],
      "bbox_max": [
        -435.51080322265625,
        -1937.2509765625,
        900.1087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        897.4674072265625
      ],
      "bbox_max": [
        -435.51080322265625,
        -1937.2509765625,
        900.1087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -468.130615234375,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -299.8731384277344,
        -1907.083251953125,
        900.7531127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -366.1393737792969,
        -1939.0,
        765.0
      ],
      "bbox_max": [
        -299.8731384277344,
        -1920.0,
        808.5042724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -366.1393737792969,
        -1939.0,
        794.5689697265625
      ],
      "bbox_max": [
        -360.0,
        -1939.0,
        802.6044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      "bbox_max": [
        -299.8731384277344,
        -1920.0,
        765.1644287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      "bbox_max": [
        -299.8731384277344,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -361.6380920410156,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -361.6380920410156,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1940.6361083984375,
        804.3280639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -405.1982727050781,
        -1972.0,
        788.1215209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -369.0,
        -1946.408935546875,
        789.0960083007812
      ],
      "bbox_max": [
        -361.6380920410156,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        800.220703125
      ],
      "bbox_max": [
        -361.6380920410156,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -435.5732116699219,
        -1972.0,
        781.3281860351562
      ],
      "bbox_max": [
        -359.96112060546875,
        -1907.083251953125,
        900.7531127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -435.5732116699219,
        -1972.0,
        781.3281860351562
      ],
      "bbox_max": [
        -407.148681640625,
        -1935.8392333984375,
        900.7531127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -435.5732116699219,
        -1939.0,
        876.3716430664062
      ],
      "bbox_max": [
        -422.5,
        -1935.8392333984375,
        900.7531127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -435.5732116699219,
        -1939.0,
        886.18798828125
      ],
      "bbox_max": [
        -430.0,
        -1935.8392333984375,
        900.7531127929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      "bbox_max": [
        -433.3038330078125,
        -1935.9715576171875,
        900.267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        781.3281860351562
      ],
      "bbox_max": [
        -407.148681640625,
        -1972.0,
        790.2094116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -51.42585754394531,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -436.69482421875,
        -1935.8033447265625,
        900.9022827148438
      ],
      "bbox_max": [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -436.69482421875,
        -1935.8033447265625,
        900.9022827148438
      ],
      "bbox_max": [
        -433.48724365234375,
        -1932.863037109375,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        900.07568359375
      ],
      "bbox_max": [
        -421.8410339355469,
        -1928.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.4872741699219,
        -1935.8585205078125,
        900.7531127929688
      ],
      "bbox_max": [
        -433.427001953125,
        -1935.80322265625,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -51.42585754394531,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -470.63055419921875,
        -2038.730712890625,
        712.0
      ],
      "bbox_max": [
        -462.7181701660156,
        -2032.99267578125,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -468.130615234375,
        -2034.785888671875,
        712.0
      ],
      "bbox_max": [
        -462.7181701660156,
        -2032.99267578125,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -51.42585754394531,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -215.28782653808594,
        -1936.7972412109375,
        754.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1932.85205078125,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.160947784781456,
        -0.9869629144668579,
        0.0
      ],
      "plane_d": -1824.285400390625,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -99.88211059570312,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -99.88211059570312,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -300.0,
        -1978.3963623046875,
        712.0
      ],
      "bbox_max": [
        -99.88211059570312,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -300.0,
        -1978.3963623046875,
        712.0
      ],
      "bbox_max": [
        -170.0,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1952.92919921875,
        754.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1952.92919921875,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        765.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      "bbox_max": [
        -286.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -245.4150848388672,
        -1949.499755859375,
        765.0
      ],
      "bbox_max": [
        -224.35812377929688,
        -1948.4483642578125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -237.6776885986328,
        -1958.9871826171875,
        754.0
      ],
      "bbox_max": [
        -170.0,
        -1944.15771484375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1958.9871826171875,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -170.0,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -361.6380920410156,
        -1939.0,
        798.0972900390625
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        818.51708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -361.6380920410156,
        -1939.0,
        798.0972900390625
      ],
      "bbox_max": [
        -360.0,
        -1939.0,
        800.220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015454292297363,
        -0.8651313185691833,
        0.0
      ],
      "plane_d": -1457.548095703125,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -170.0,
        -1912.418212890625,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.4441223144531,
        -1935.9715576171875,
        900.267333984375
      ],
      "bbox_max": [
        -433.3037109375,
        -1935.8428955078125,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -170.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -433.30377197265625,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -180.0,
        -1928.0,
        930.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -433.30377197265625,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1928.0,
        930.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -433.30377197265625,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -369.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1938.9998779296875,
      "bbox_min": [
        -433.30377197265625,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -369.0,
        -1935.971435546875,
        912.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.30377197265625,
        -1939.0,
        888.8370971679688
      ],
      "bbox_max": [
        -430.0,
        -1935.971435546875,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -370.84454345703125,
        -1950.0,
        785.9027709960938
      ],
      "bbox_max": [
        -369.0,
        -1946.408935546875,
        793.1032104492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -405.1982727050781,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -369.0,
        -1952.1192626953125,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47035908699035645,
        -0.7688663601875305,
        0.4331360161304474
      ],
      "plane_d": -1666.129638671875,
      "bbox_min": [
        -375.3876953125,
        -1960.0589599609375,
        768.0467529296875
      ],
      "bbox_max": [
        -369.0,
        -1954.001220703125,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        893.999755859375
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1928.0,
        930.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -369.0,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -360.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1942.576416015625,
        792.2774658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3979502022266388,
        -0.8249621391296387,
        0.40133896470069885
      ],
      "plane_d": -1778.3778076171875,
      "bbox_min": [
        -369.0,
        -1961.5411376953125,
        765.0
      ],
      "bbox_max": [
        -367.1901550292969,
        -1960.0589599609375,
        768.0467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.685392236249754e-06,
        2.4760717565186496e-07,
        -1.0
      ],
      "plane_d": 778.798095703125,
      "bbox_min": [
        -369.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1969.5,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 367.5,
      "bbox_min": [
        -367.5,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -422.489501953125,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -180.0,
        -1972.0,
        781.3280029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -422.489501953125,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -290.0,
        -1972.0,
        781.3280029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -300.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -290.0,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -422.489501953125,
        -1992.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        781.3280029296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        2.303213477716781e-06,
        -8.291568519780412e-06,
        -1.0
      ],
      "plane_d": 778.7843627929688,
      "bbox_min": [
        -422.14593505859375,
        -1987.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        781.3280029296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -409.52386474609375,
        -1974.375732421875,
        778.7998046875
      ],
      "bbox_max": [
        -404.598876953125,
        -1972.0,
        781.3280029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794841408729553,
        -0.8249640464782715,
        0.4013371765613556
      ],
      "plane_d": -1778.3809814453125,
      "bbox_min": [
        -422.14593505859375,
        -1987.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        778.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 768.4999389648438,
      "bbox_min": [
        -325.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -325.0,
      "bbox_min": [
        -325.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -323.0,
        -1977.0,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -324.0,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1986.60009765625,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1978.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1978.400146484375,
      "bbox_min": [
        -324.0,
        -1978.400146484375,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1978.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 768.4999389648438,
      "bbox_min": [
        -422.489501953125,
        -1992.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1987.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1634.8309326171875,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1987.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -422.489501953125,
        -1987.3436279296875,
        765.0
      ],
      "bbox_max": [
        -421.7771301269531,
        -1987.0,
        765.3656616210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794841408729553,
        -0.8249640464782715,
        0.4013371765613556
      ],
      "plane_d": -1778.3809814453125,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -184.0,
        -1946.173095703125,
        765.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.47035908699035645,
        -0.7688663601875305,
        0.4331360161304474
      ],
      "plane_d": -1666.129638671875,
      "bbox_min": [
        -367.1901550292969,
        -1971.26513671875,
        712.0
      ],
      "bbox_max": [
        -335.2963562011719,
        -1952.3424072265625,
        765.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -184.0,
        -1946.173095703125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -674.18994140625,
        -2154.383544921875,
        712.0
      ],
      "bbox_max": [
        -184.0,
        -1946.173095703125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -2014.0,
        712.0
      ],
      "bbox_max": [
        -184.0,
        -1946.173095703125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -286.0,
        -2014.0,
        712.0
      ],
      "bbox_max": [
        -184.0,
        -1951.9654541015625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        712.0
      ],
      "bbox_max": [
        -184.0,
        -1951.9654541015625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1952.1719970703125,
        754.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1951.9654541015625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.41665470600128174,
        -0.9090648293495178
      ],
      "plane_d": -143.7080078125,
      "bbox_min": [
        -286.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1990.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1987.0,
        754.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.440481036901474,
        -0.8977619409561157,
        0.0
      ],
      "plane_d": -1797.645263671875,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        129.7200469970703,
        -2001.0638427734375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713609576225281,
        0.896252453327179,
        -0.24253378808498383
      ],
      "plane_d": 2193.633544921875,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37136074900627136,
        0.8962519764900208,
        -0.24253582954406738
      ],
      "plane_d": 2429.8193359375,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.896294891834259,
        -0.3712579011917114,
        -0.2425346076488495
      ],
      "plane_d": -884.5740356445312,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8962944149971008,
        0.3712576925754547,
        -0.2425367832183838
      ],
      "plane_d": 820.87255859375,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.896294891834259,
        0.3712579011917114,
        -0.2425346076488495
      ],
      "plane_d": 1390.914794921875,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8962944149971008,
        -0.3712576925754547,
        -0.2425367832183838
      ],
      "plane_d": -314.528564453125,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": -55.33412170410156,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -244.54034423828125,
        -2302.39990234375,
        729.9993286132812
      ],
      "bbox_max": [
        -239.53173828125,
        -2289.39990234375,
        750.012939453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -244.54034423828125,
        -2302.39990234375,
        729.9993286132812
      ],
      "bbox_max": [
        -239.53173828125,
        -2302.39990234375,
        750.012939453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": 561.676513671875,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6860024333000183,
        0.6859862804412842,
        -0.24253544211387634
      ],
      "plane_d": 1610.6280517578125,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3827912509441376,
        0.9238348603248596,
        0.0
      ],
      "plane_d": 2322.099609375,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827912509441376,
        0.9238348603248596,
        0.0
      ],
      "plane_d": 2078.644287109375,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707114577293396,
        0.7070989608764648,
        0.0
      ],
      "plane_d": 1477.69873046875,
      "bbox_min": [
        -396.462890625,
        -2370.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707114577293396,
        0.7070989608764648,
        0.0
      ],
      "plane_d": 1927.423583984375,
      "bbox_min": [
        -396.462890625,
        -2370.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -378.162841796875,
        -2356.99267578125,
        712.0
      ],
      "bbox_max": [
        -368.8941650390625,
        -2347.723876953125,
        730.43212890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -368.970458984375,
        -2356.99267578125,
        712.0
      ],
      "bbox_max": [
        -368.8941650390625,
        -2356.916259765625,
        730.431640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6860026717185974,
        0.6859864592552185,
        -0.2425343543291092
      ],
      "plane_d": 2046.92529296875,
      "bbox_min": [
        -396.462890625,
        -2370.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -378.0864562988281,
        -2356.916259765625,
        729.9866943359375
      ],
      "bbox_max": [
        -365.31292724609375,
        -2344.142578125,
        750.2597045898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -378.0864562988281,
        -2347.723876953125,
        729.9866943359375
      ],
      "bbox_max": [
        -374.5050048828125,
        -2344.142578125,
        750.2597045898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5341558456420898,
        -0.5341463088989258,
        -0.6552596688270569
      ],
      "plane_d": -585.7737426757812,
      "bbox_min": [
        -396.462890625,
        -2370.3154296875,
        712.0
      ],
      "bbox_max": [
        -252.0811309814453,
        -2230.929931640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364111065864563,
        -0.5364397168159485,
        -0.6515332460403442
      ],
      "plane_d": -934.5252075195312,
      "bbox_min": [
        -396.462890625,
        -2364.166015625,
        712.0
      ],
      "bbox_max": [
        -268.58868408203125,
        -2230.929931640625,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5372592806816101,
        0.5372592806816101,
        -0.6501576900482178
      ],
      "plane_d": 1530.2041015625,
      "bbox_min": [
        -385.4071044921875,
        -2325.798583984375,
        712.0
      ],
      "bbox_max": [
        -268.58868408203125,
        -2230.929931640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7598690986633301,
        1.9076609532930888e-05,
        -0.650076150894165
      ],
      "plane_d": 225.38882446289062,
      "bbox_min": [
        -377.5646667480469,
        -2325.798583984375,
        729.9274291992188
      ],
      "bbox_max": [
        -268.58868408203125,
        -2247.4248046875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7249156832695007,
        -0.3002679944038391,
        -0.61994868516922
      ],
      "plane_d": -477.7586975097656,
      "bbox_min": [
        -366.462890625,
        -2325.798583984375,
        729.9274291992188
      ],
      "bbox_max": [
        -268.58868408203125,
        -2247.4248046875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.725508987903595,
        0.30051371455192566,
        -0.6191350221633911
      ],
      "plane_d": 901.294677734375,
      "bbox_min": [
        -366.462890625,
        -2325.798583984375,
        729.9274291992188
      ],
      "bbox_max": [
        -268.58868408203125,
        -2247.4248046875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.720969557762146,
        -0.2986334562301636,
        -0.6253166794776917
      ],
      "plane_d": -9.845726013183594,
      "bbox_min": [
        -366.4575500488281,
        -2325.798583984375,
        729.9274291992188
      ],
      "bbox_max": [
        -268.58868408203125,
        -2247.4248046875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3002129793167114,
        0.7247829437255859,
        -0.6201305389404297
      ],
      "plane_d": 2011.8299560546875,
      "bbox_min": [
        -366.4575500488281,
        -2325.798583984375,
        729.9274291992188
      ],
      "bbox_max": [
        -275.2632141113281,
        -2247.4248046875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -366.4575500488281,
        -2325.798583984375,
        736.583740234375
      ],
      "bbox_max": [
        -275.2632141113281,
        -2254.058349609375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1841.56884765625,
      "bbox_min": [
        -278.66265869140625,
        -2325.798583984375,
        774.6270751953125
      ],
      "bbox_max": [
        -278.453369140625,
        -2325.58935546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -366.45733642578125,
        -2289.39990234375,
        774.9186401367188
      ],
      "bbox_max": [
        -366.3933410644531,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5105127861024812e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2273.313232421875,
      "bbox_min": [
        -327.900634765625,
        -2273.305419921875,
        736.583740234375
      ],
      "bbox_max": [
        -308.451171875,
        -2273.304931640625,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5105127861024812e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2273.313232421875,
      "bbox_min": [
        -345.451904296875,
        -2273.305419921875,
        729.9274291992188
      ],
      "bbox_max": [
        -308.451171875,
        -2247.4248046875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21227414906024933,
        -0.5124784708023071,
        -0.8320490121841431
      ],
      "plane_d": -437.861083984375,
      "bbox_min": [
        -345.451904296875,
        -2255.76220703125,
        772.7014770507812
      ],
      "bbox_max": [
        -331.69427490234375,
        -2247.4248046875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -276.9150390625,
        -2324.299072265625,
        772.7119750976562
      ],
      "bbox_max": [
        -268.58868408203125,
        -2310.5390625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -366.462890625,
        -2324.299072265625,
        773.3551025390625
      ],
      "bbox_max": [
        -359.0849609375,
        -2306.487060546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -374.4842224121094,
        -2316.330078125,
        767.5505981445312
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -374.4842224121094,
        -2304.60009765625,
        767.5505981445312
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -372.0876770019531,
        -2304.60009765625,
        767.6744995117188
      ],
      "bbox_max": [
        -364.78466796875,
        -2302.39990234375,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -373.4478454589844,
        -2291.60009765625,
        767.5505981445312
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -373.4478454589844,
        -2289.39990234375,
        768.3587036132812
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5105127861024812e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2273.313232421875,
      "bbox_min": [
        -327.900634765625,
        -2273.305419921875,
        712.0
      ],
      "bbox_max": [
        -308.451171875,
        -2273.304931640625,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -687.1036987304688,
      "bbox_min": [
        -385.4071044921875,
        -2296.831298828125,
        712.0
      ],
      "bbox_max": [
        -334.33319091796875,
        -2230.929931640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071412801742554,
        0.7070722579956055,
        -3.2557567465119064e-05
      ],
      "plane_d": 1854.4437255859375,
      "bbox_min": [
        -373.914306640625,
        -2255.903564453125,
        749.843994140625
      ],
      "bbox_max": [
        -357.54046630859375,
        -2239.557373046875,
        765.0780029296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071412801742554,
        0.7070722579956055,
        -3.2557567465119064e-05
      ],
      "plane_d": 1841.4437255859375,
      "bbox_min": [
        -364.6943359375,
        -2246.711181640625,
        749.977783203125
      ],
      "bbox_max": [
        -357.54046630859375,
        -2239.557373046875,
        765.0780029296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7687151432037354,
        -0.31841254234313965,
        -0.5546985864639282
      ],
      "plane_d": -9.744735717773438,
      "bbox_min": [
        -385.4071044921875,
        -2296.831298828125,
        712.0
      ],
      "bbox_max": [
        -334.33319091796875,
        -2230.929931640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124768614768982,
        -0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 347.1290283203125,
      "bbox_min": [
        -383.5801086425781,
        -2296.831298828125,
        712.0
      ],
      "bbox_max": [
        -334.33319091796875,
        -2230.929931640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071124315261841,
        0.7071011066436768,
        5.3263302106643096e-06
      ],
      "plane_d": 1854.46923828125,
      "bbox_min": [
        -366.7695617675781,
        -2266.44921875,
        765.0001220703125
      ],
      "bbox_max": [
        -346.9950866699219,
        -2246.674560546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21227414906024933,
        -0.5124784708023071,
        -0.8320490121841431
      ],
      "plane_d": -437.861083984375,
      "bbox_min": [
        -383.5801086425781,
        -2296.831298828125,
        712.0
      ],
      "bbox_max": [
        -334.33319091796875,
        -2238.583251953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1854.429931640625,
      "bbox_min": [
        -383.5801086425781,
        -2296.831298828125,
        712.0
      ],
      "bbox_max": [
        -339.642333984375,
        -2239.5927734375,
        774.9771118164062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.38998207449913025,
        -0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": -101.48300170898438,
      "bbox_min": [
        -383.5801086425781,
        -2296.831298828125,
        748.7863159179688
      ],
      "bbox_max": [
        -355.0224609375,
        -2250.68994140625,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -383.5801086425781,
        -2296.831298828125,
        748.7863159179688
      ],
      "bbox_max": [
        -365.316162109375,
        -2250.68994140625,
        771.53173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        -0.8320502638816833
      ],
      "plane_d": 848.115966796875,
      "bbox_min": [
        -383.5801086425781,
        -2296.831298828125,
        761.8241577148438
      ],
      "bbox_max": [
        -371.0528869628906,
        -2283.802490234375,
        771.53173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -383.5801086425781,
        -2289.77685546875,
        761.8241577148438
      ],
      "bbox_max": [
        -371.0528869628906,
        -2283.802490234375,
        770.337890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        -0.5547001957893372
      ],
      "plane_d": 741.741943359375,
      "bbox_min": [
        -381.5964660644531,
        -2289.77685546875,
        764.7996215820312
      ],
      "bbox_max": [
        -381.462890625,
        -2289.39990234375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071124315261841,
        0.7071011066436768,
        5.3263302106643096e-06
      ],
      "plane_d": 1841.46923828125,
      "bbox_min": [
        -364.6588439941406,
        -2259.9775390625,
        712.0
      ],
      "bbox_max": [
        -339.642333984375,
        -2239.5927734375,
        774.9771118164062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -364.31005859375,
        -2253.675048828125,
        712.0
      ],
      "bbox_max": [
        -354.3133544921875,
        -2241.49755859375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -358.0503234863281,
        -2253.675048828125,
        712.0
      ],
      "bbox_max": [
        -354.3133544921875,
        -2249.93798828125,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -354.3133544921875,
        -2249.93798828125,
        712.0
      ],
      "bbox_max": [
        -339.642333984375,
        -2242.115966796875,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -354.3133544921875,
        -2249.93798828125,
        712.0
      ],
      "bbox_max": [
        -351.334228515625,
        -2246.958984375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7687152028083801,
        0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": 1452.945068359375,
      "bbox_min": [
        -396.462890625,
        -2364.166015625,
        712.0
      ],
      "bbox_max": [
        -330.618408203125,
        -2251.245849609375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883575081825256,
        0.588341474533081,
        -0.5546978712081909
      ],
      "plane_d": 2015.5765380859375,
      "bbox_min": [
        -396.462890625,
        -2364.166015625,
        712.0
      ],
      "bbox_max": [
        -330.618408203125,
        -2251.245849609375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -374.5508728027344,
        -2353.380859375,
        750.0
      ],
      "bbox_max": [
        -358.3182067871094,
        -2337.056396484375,
        765.1295166015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39223402738571167,
        0.39222702383995056,
        -0.8320519328117371
      ],
      "plane_d": 1697.3385009765625,
      "bbox_min": [
        -396.462890625,
        -2364.166015625,
        712.0
      ],
      "bbox_max": [
        -330.618408203125,
        -2251.245849609375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31849759817123413,
        0.7686783075332642,
        -0.5547007918357849
      ],
      "plane_d": 2343.970458984375,
      "bbox_min": [
        -396.462890625,
        -2364.166015625,
        712.0
      ],
      "bbox_max": [
        -330.618408203125,
        -2251.245849609375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -396.462890625,
        -2356.916259765625,
        712.0
      ],
      "bbox_max": [
        -330.73065185546875,
        -2251.245849609375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862345933914185,
        0.6861268877983093,
        -0.24147889018058777
      ],
      "plane_d": 2043.697998046875,
      "bbox_min": [
        -366.864990234375,
        -2356.443115234375,
        726.6089477539062
      ],
      "bbox_max": [
        -355.30859375,
        -2344.886474609375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -366.864990234375,
        -2356.443115234375,
        726.6089477539062
      ],
      "bbox_max": [
        -355.30859375,
        -2344.886474609375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6801113486289978,
        0.6800045967102051,
        0.2739383578300476
      ],
      "plane_d": 1650.9686279296875,
      "bbox_min": [
        -366.864990234375,
        -2356.443115234375,
        726.6089477539062
      ],
      "bbox_max": [
        -365.2110290527344,
        -2354.278076171875,
        729.6334228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -378.0864562988281,
        -2347.723876953125,
        712.0
      ],
      "bbox_max": [
        -354.207275390625,
        -2318.24072265625,
        774.9572143554688
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6801113486289978,
        0.6800045967102051,
        0.2739383578300476
      ],
      "plane_d": 1650.9696044921875,
      "bbox_min": [
        -376.057373046875,
        -2347.250732421875,
        712.0
      ],
      "bbox_max": [
        -361.53094482421875,
        -2333.853515625,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -372.687255859375,
        -2343.880615234375,
        712.0
      ],
      "bbox_max": [
        -361.53094482421875,
        -2333.853515625,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1907.8232421875,
      "bbox_min": [
        -364.21600341796875,
        -2336.53857421875,
        712.0
      ],
      "bbox_max": [
        -361.53094482421875,
        -2333.853515625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 1231.6060791015625,
      "bbox_min": [
        -372.8341369628906,
        -2333.853515625,
        712.0
      ],
      "bbox_max": [
        -364.2159729003906,
        -2318.24072265625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1907.8232421875,
      "bbox_min": [
        -367.88818359375,
        -2333.853515625,
        712.0
      ],
      "bbox_max": [
        -364.2159729003906,
        -2330.181396484375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        -0.8320502638816833
      ],
      "plane_d": 848.115966796875,
      "bbox_min": [
        -396.462890625,
        -2318.24072265625,
        712.0
      ],
      "bbox_max": [
        -355.62115478515625,
        -2251.245849609375,
        771.5366821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.84716796875,
      "bbox_min": [
        -396.462890625,
        -2318.24072265625,
        712.0
      ],
      "bbox_max": [
        -355.62115478515625,
        -2251.245849609375,
        769.6476440429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7687151432037354,
        -0.31841254234313965,
        -0.5546985864639282
      ],
      "plane_d": -9.744735717773438,
      "bbox_min": [
        -396.462890625,
        -2304.60009765625,
        729.6334228515625
      ],
      "bbox_max": [
        -376.84716796875,
        -2267.61474609375,
        768.073974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -396.462890625,
        -2304.60009765625,
        729.6334228515625
      ],
      "bbox_max": [
        -376.84716796875,
        -2289.39990234375,
        768.073974609375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.4853515625,
        -2304.60009765625,
        729.6334228515625
      ],
      "bbox_max": [
        -376.84716796875,
        -2302.39990234375,
        764.5277099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -388.71923828125,
        -2304.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -376.84716796875,
        -2302.39990234375,
        764.5277099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -379.342041015625,
        -2304.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -376.84716796875,
        -2302.39990234375,
        764.5277099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -396.462890625,
        -2291.60009765625,
        729.6334228515625
      ],
      "bbox_max": [
        -378.07769775390625,
        -2289.39990234375,
        764.7996215820312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.4853515625,
        -2291.60009765625,
        729.6334228515625
      ],
      "bbox_max": [
        -378.07769775390625,
        -2289.39990234375,
        763.714111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -388.71923828125,
        -2291.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -378.07769775390625,
        -2289.39990234375,
        763.714111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -379.342041015625,
        -2291.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -378.07769775390625,
        -2289.39990234375,
        763.714111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -376.84716796875,
        -2318.24072265625,
        712.0
      ],
      "bbox_max": [
        -355.62115478515625,
        -2251.245849609375,
        769.6476440429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -376.84716796875,
        -2318.24072265625,
        712.0
      ],
      "bbox_max": [
        -355.62115478515625,
        -2251.245849609375,
        769.6476440429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 1231.6060791015625,
      "bbox_min": [
        -376.84716796875,
        -2318.24072265625,
        712.0
      ],
      "bbox_max": [
        -370.8673400878906,
        -2302.39990234375,
        769.6476440429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -376.84716796875,
        -2304.60009765625,
        764.5277099609375
      ],
      "bbox_max": [
        -370.8673400878906,
        -2302.39990234375,
        769.6476440429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -376.84716796875,
        -2302.39990234375,
        764.5277099609375
      ],
      "bbox_max": [
        -372.0876770019531,
        -2302.39990234375,
        769.6476440429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3184986114501953,
        0.7686806917190552,
        -0.5546968579292297
      ],
      "plane_d": 2141.408447265625,
      "bbox_min": [
        -372.2742919921875,
        -2370.3154296875,
        712.0
      ],
      "bbox_max": [
        -252.0811309814453,
        -2313.165771484375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883565545082092,
        0.5883404612541199,
        -0.5546999573707581
      ],
      "plane_d": 1641.380615234375,
      "bbox_min": [
        -372.2742919921875,
        -2370.3154296875,
        712.0
      ],
      "bbox_max": [
        -252.0811309814453,
        -2313.165771484375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3922361731529236,
        0.3922291696071625,
        -0.8320499062538147
      ],
      "plane_d": 1447.8804931640625,
      "bbox_min": [
        -372.2742919921875,
        -2370.3154296875,
        712.0
      ],
      "bbox_max": [
        -252.0811309814453,
        -2313.165771484375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -372.2742919921875,
        -2370.3154296875,
        712.0
      ],
      "bbox_max": [
        -252.0811309814453,
        -2313.165771484375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31849759817123413,
        0.7686783075332642,
        -0.5547007918357849
      ],
      "plane_d": 2343.970458984375,
      "bbox_min": [
        -372.2742919921875,
        -2370.3154296875,
        712.0
      ],
      "bbox_max": [
        -331.0267639160156,
        -2342.375244140625,
        761.9214477539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6801113486289978,
        0.6800045967102051,
        0.2739383578300476
      ],
      "plane_d": 1650.9686279296875,
      "bbox_min": [
        -372.2742919921875,
        -2356.916259765625,
        712.0
      ],
      "bbox_max": [
        -361.7578125,
        -2342.375244140625,
        729.1454467773438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -368.8941650390625,
        -2356.916259765625,
        712.0
      ],
      "bbox_max": [
        -363.313720703125,
        -2351.3359375,
        726.6089477539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -363.984375,
        -2356.181396484375,
        712.0
      ],
      "bbox_max": [
        -257.262939453125,
        -2318.486572265625,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1854.484130859375,
      "bbox_min": [
        -280.1171875,
        -2356.181396484375,
        712.0
      ],
      "bbox_max": [
        -257.262939453125,
        -2333.16064453125,
        768.0343017578125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6861807107925415,
        0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": 1607.2313232421875,
      "bbox_min": [
        -280.1171875,
        -2355.631591796875,
        712.0
      ],
      "bbox_max": [
        -268.560791015625,
        -2344.0751953125,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6800597310066223,
        0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": 1218.4066162109375,
      "bbox_min": [
        -280.1171875,
        -2355.631591796875,
        712.0
      ],
      "bbox_max": [
        -268.560791015625,
        -2344.0751953125,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -280.1171875,
        -2352.261474609375,
        748.7863159179688
      ],
      "bbox_max": [
        -271.930908203125,
        -2344.0751953125,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1841.484130859375,
      "bbox_min": [
        -272.6468200683594,
        -2346.989013671875,
        712.0
      ],
      "bbox_max": [
        -257.262939453125,
        -2333.16064453125,
        768.0343017578125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6861807107925415,
        0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": 1607.2313232421875,
      "bbox_min": [
        -272.6468200683594,
        -2346.439208984375,
        712.0
      ],
      "bbox_max": [
        -259.368408203125,
        -2333.160888671875,
        764.48828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6800597310066223,
        0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": 1218.4066162109375,
      "bbox_min": [
        -272.6468200683594,
        -2346.439208984375,
        712.0
      ],
      "bbox_max": [
        -259.368408203125,
        -2333.160888671875,
        764.48828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -272.6468200683594,
        -2343.069091796875,
        748.7863159179688
      ],
      "bbox_max": [
        -262.738525390625,
        -2333.160888671875,
        764.48828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -272.6468200683594,
        -2336.4384765625,
        762.878173828125
      ],
      "bbox_max": [
        -269.369140625,
        -2333.160888671875,
        764.48828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -363.984375,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -263.2676696777344,
        -2318.486572265625,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1907.8232421875,
      "bbox_min": [
        -363.984375,
        -2346.7353515625,
        712.0
      ],
      "bbox_max": [
        -263.2676696777344,
        -2318.486572265625,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -281.218505859375,
        -2334.716552734375,
        712.0
      ],
      "bbox_max": [
        -263.2676696777344,
        -2318.486572265625,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1841.56884765625,
      "bbox_min": [
        -279.662841796875,
        -2333.160888671875,
        764.48828125
      ],
      "bbox_max": [
        -271.0910949707031,
        -2324.589111328125,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186157226562,
      "bbox_min": [
        -268.11181640625,
        -2330.181396484375,
        712.0
      ],
      "bbox_max": [
        -263.2676696777344,
        -2318.486572265625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1061.293701171875,
      "bbox_min": [
        -350.8291320800781,
        -2329.672607421875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31841254234313965,
        -0.7687151432037354,
        -0.5546985864639282
      ],
      "plane_d": -1389.7275390625,
      "bbox_min": [
        -350.8291320800781,
        -2329.672607421875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -350.8291320800781,
        -2329.672607421875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7215692400932312,
        0.298881858587265,
        -0.6245057582855225
      ],
      "plane_d": 1362.08642578125,
      "bbox_min": [
        -350.8291320800781,
        -2311.494873046875,
        746.0
      ],
      "bbox_max": [
        -269.537109375,
        -2229.4970703125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7584289312362671,
        -0.6517557501792908
      ],
      "plane_d": 2210.350341796875,
      "bbox_min": [
        -350.8291320800781,
        -2311.494873046875,
        746.0
      ],
      "bbox_max": [
        -269.537109375,
        -2229.4970703125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.720969557762146,
        -0.2986334562301636,
        -0.6253166794776917
      ],
      "plane_d": -9.845726013183594,
      "bbox_min": [
        -332.6547546386719,
        -2311.494873046875,
        768.3970336914062
      ],
      "bbox_max": [
        -269.537109375,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3002129793167114,
        0.7247829437255859,
        -0.6201305389404297
      ],
      "plane_d": 2011.8299560546875,
      "bbox_min": [
        -332.6547546386719,
        -2302.39990234375,
        768.3970336914062
      ],
      "bbox_max": [
        -269.54083251953125,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -325.60009765625,
        -2302.39990234375,
        774.4044189453125
      ],
      "bbox_max": [
        -269.54083251953125,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -279.5075988769531,
        -2302.39990234375,
        774.4052734375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2267.19677734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -269.5799560546875,
        -2302.39990234375,
        774.95068359375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2302.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -279.5075988769531,
        -2267.52978515625,
        774.4052734375
      ],
      "bbox_max": [
        -279.17462158203125,
        -2267.19677734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      "bbox_max": [
        -310.39990234375,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      "bbox_max": [
        -325.60009765625,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -312.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      "bbox_max": [
        -310.39990234375,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      "bbox_max": [
        -312.60009765625,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21227414906024933,
        -0.5124784708023071,
        -0.8320490121841431
      ],
      "plane_d": -437.861083984375,
      "bbox_min": [
        -332.6547546386719,
        -2250.063720703125,
        774.1633911132812
      ],
      "bbox_max": [
        -327.639892578125,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -271.21551513671875,
        -2311.494873046875,
        774.1673583984375
      ],
      "bbox_max": [
        -269.537109375,
        -2306.487060546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2122735232114792,
        -0.5124768614768982,
        -0.832050085067749
      ],
      "plane_d": -572.86279296875,
      "bbox_min": [
        -308.360107421875,
        -2255.76220703125,
        773.3587036132812
      ],
      "bbox_max": [
        -290.548095703125,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31841254234313965,
        -0.7687152028083801,
        -0.5546984672546387
      ],
      "plane_d": -1187.2174072265625,
      "bbox_min": [
        -350.8291320800781,
        -2250.0625,
        750.0
      ],
      "bbox_max": [
        -298.52166748046875,
        -2229.4970703125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21227414906024933,
        -0.5124784708023071,
        -0.8320490121841431
      ],
      "plane_d": -437.861083984375,
      "bbox_min": [
        -343.1751708984375,
        -2250.0625,
        761.8826904296875
      ],
      "bbox_max": [
        -298.52166748046875,
        -2231.30615234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -331.0368957519531,
        -2250.0625,
        761.8826904296875
      ],
      "bbox_max": [
        -298.52166748046875,
        -2231.30615234375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -331.0368957519531,
        -2250.0625,
        761.8826904296875
      ],
      "bbox_max": [
        -298.52166748046875,
        -2231.30615234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -331.0368957519531,
        -2250.0625,
        761.8826904296875
      ],
      "bbox_max": [
        -325.1485290527344,
        -2231.30615234375,
        774.9934692382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": -1433.9423828125,
      "bbox_min": [
        -325.60009765625,
        -2233.38427734375,
        764.7609252929688
      ],
      "bbox_max": [
        -325.1485290527344,
        -2233.224853515625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": -1433.9423828125,
      "bbox_min": [
        -331.0368957519531,
        -2233.38427734375,
        761.8826904296875
      ],
      "bbox_max": [
        -325.60009765625,
        -2231.30615234375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2250.0625,
        767.6395874023438
      ],
      "bbox_max": [
        -310.39990234375,
        -2240.3017578125,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -310.39990234375,
        -2250.0625,
        768.4441528320312
      ],
      "bbox_max": [
        -310.39990234375,
        -2241.5146484375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -276.9150390625,
        -2287.207275390625,
        773.3617553710938
      ],
      "bbox_max": [
        -269.537109375,
        -2269.395263671875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2122735232114792,
        -0.5124768614768982,
        -0.832050085067749
      ],
      "plane_d": -572.86279296875,
      "bbox_min": [
        -347.3697814941406,
        -2277.354248046875,
        712.0
      ],
      "bbox_max": [
        -270.9585266113281,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -602.3402709960938,
      "bbox_min": [
        -347.3697814941406,
        -2277.354248046875,
        712.0
      ],
      "bbox_max": [
        -270.9585266113281,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31841254234313965,
        -0.7687152028083801,
        -0.5546984672546387
      ],
      "plane_d": -1187.2174072265625,
      "bbox_min": [
        -347.3697814941406,
        -2277.354248046875,
        712.0
      ],
      "bbox_max": [
        -270.9585266113281,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -339.642333984375,
        -2277.354248046875,
        712.0
      ],
      "bbox_max": [
        -270.9585266113281,
        -2223.38427734375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -312.60009765625,
        -2277.354248046875,
        748.7863159179688
      ],
      "bbox_max": [
        -270.9585266113281,
        -2223.38427734375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -312.60009765625,
        -2243.923583984375,
        748.7863159179688
      ],
      "bbox_max": [
        -310.39990234375,
        -2226.1279296875,
        768.4441528320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -312.60009765625,
        -2243.923583984375,
        762.878173828125
      ],
      "bbox_max": [
        -310.39990234375,
        -2235.505126953125,
        768.4441528320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -289.595703125,
        -2277.354248046875,
        763.2664794921875
      ],
      "bbox_max": [
        -270.9585266113281,
        -2247.666015625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.54376220703125,
      "bbox_min": [
        -289.595703125,
        -2277.354248046875,
        763.2664794921875
      ],
      "bbox_max": [
        -270.9585266113281,
        -2249.354736328125,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -280.4033203125,
        -2277.354248046875,
        768.0119018554688
      ],
      "bbox_max": [
        -270.9585266113281,
        -2261.9169921875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -280.4033203125,
        -2268.425537109375,
        768.0119018554688
      ],
      "bbox_max": [
        -273.8948669433594,
        -2261.9169921875,
        774.9501342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -339.642333984375,
        -2242.115966796875,
        712.0
      ],
      "bbox_max": [
        -320.7265319824219,
        -2223.38427734375,
        765.6420288085938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -339.642333984375,
        -2242.115966796875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2223.38427734375,
        764.7609252929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2235.512451171875,
        748.7863159179688
      ],
      "bbox_max": [
        -325.60009765625,
        -2223.38427734375,
        764.7609252929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -339.642333984375,
        -2242.115966796875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2235.505126953125,
        763.6904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -325.60009765625,
        -2235.96435546875,
        762.878173828125
      ],
      "bbox_max": [
        -323.6819152832031,
        -2235.505126953125,
        763.1818237304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2235.516845703125,
        762.878173828125
      ],
      "bbox_max": [
        -325.60009765625,
        -2235.505126953125,
        762.889404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -323.39990234375,
        -2238.0,
        712.918701171875
      ],
      "bbox_max": [
        -320.7265319824219,
        -2238.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -0.0,
        -0.8320502638816833
      ],
      "plane_d": 495.32666015625,
      "bbox_min": [
        -324.19696044921875,
        -2329.672607421875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -324.19696044921875,
        -2329.672607421875,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39223313331604004,
        -0.39223313331604004,
        -0.8320494890213013
      ],
      "plane_d": -353.9089050292969,
      "bbox_min": [
        -324.19696044921875,
        -2322.019287109375,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -324.19696044921875,
        -2322.019287109375,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -324.19696044921875,
        -2318.486572265625,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2238.0,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -279.7173156738281,
        -2289.39990234375,
        729.6334228515625
      ],
      "bbox_max": [
        -239.53695678710938,
        -2240.368896484375,
        768.005615234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6861807107925415,
        -0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": -1544.914794921875,
      "bbox_min": [
        -271.80126953125,
        -2289.39990234375,
        729.6334228515625
      ],
      "bbox_max": [
        -239.53695678710938,
        -2248.131103515625,
        764.4598999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.6221923828125,
      "bbox_min": [
        -271.80126953125,
        -2289.39990234375,
        729.66845703125
      ],
      "bbox_max": [
        -239.53695678710938,
        -2251.501220703125,
        764.4598999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -271.80126953125,
        -2289.39990234375,
        729.66845703125
      ],
      "bbox_max": [
        -239.53695678710938,
        -2258.1318359375,
        764.4598999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.543212890625,
      "bbox_min": [
        -271.80126953125,
        -2261.379150390625,
        762.878173828125
      ],
      "bbox_max": [
        -268.553955078125,
        -2258.1318359375,
        764.4598999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -279.7173156738281,
        -2251.76953125,
        748.7863159179688
      ],
      "bbox_max": [
        -270.7314453125,
        -2240.368896484375,
        765.2129516601562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.623046875,
      "bbox_min": [
        -279.7173156738281,
        -2251.76953125,
        748.7863159179688
      ],
      "bbox_max": [
        -271.11572265625,
        -2242.308837890625,
        764.069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.54376220703125,
      "bbox_min": [
        -279.7173156738281,
        -2251.76953125,
        762.878173828125
      ],
      "bbox_max": [
        -277.746337890625,
        -2248.939453125,
        764.069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -324.19696044921875,
        -2318.486572265625,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2238.0,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -324.19696044921875,
        -2318.486572265625,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2238.0,
        774.9957885742188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9704055190086365,
        -0.0,
        -0.24148114025592804
      ],
      "plane_d": -59.13962936401367,
      "bbox_min": [
        -271.2099609375,
        -2318.486572265625,
        712.0
      ],
      "bbox_max": [
        -242.50927734375,
        -2302.39990234375,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -271.2099609375,
        -2318.486572265625,
        712.0
      ],
      "bbox_max": [
        -247.275390625,
        -2302.39990234375,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -263.2676696777344,
        -2318.486572265625,
        712.0
      ],
      "bbox_max": [
        -247.275390625,
        -2302.39990234375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186157226562,
      "bbox_min": [
        -263.2676696777344,
        -2318.486572265625,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2302.39990234375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -259.15283203125,
        -2308.552490234375,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2302.39990234375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        -0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -324.19696044921875,
        -2302.39990234375,
        712.0
      ],
      "bbox_max": [
        -242.22479248046875,
        -2238.0,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9704055190086365,
        -0.0,
        -0.24148114025592804
      ],
      "plane_d": -59.13962936401367,
      "bbox_min": [
        -257.3890686035156,
        -2291.60009765625,
        729.6334228515625
      ],
      "bbox_max": [
        -242.22479248046875,
        -2289.39990234375,
        766.9028930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -257.3890686035156,
        -2291.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -247.275390625,
        -2289.39990234375,
        766.9028930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -257.3890686035156,
        -2289.39990234375,
        748.7863159179688
      ],
      "bbox_max": [
        -247.275390625,
        -2289.39990234375,
        766.9028930664062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -257.3890686035156,
        -2291.177978515625,
        762.878173828125
      ],
      "bbox_max": [
        -256.652587890625,
        -2289.39990234375,
        763.9849243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -257.3890686035156,
        -2289.39990234375,
        762.878173828125
      ],
      "bbox_max": [
        -256.652587890625,
        -2289.39990234375,
        763.9849243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -324.19696044921875,
        -2302.39990234375,
        712.0
      ],
      "bbox_max": [
        -256.477783203125,
        -2238.0,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -271.2099609375,
        -2289.39990234375,
        763.3651123046875
      ],
      "bbox_max": [
        -257.3890075683594,
        -2289.39990234375,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -324.19696044921875,
        -2302.39990234375,
        712.0
      ],
      "bbox_max": [
        -256.477783203125,
        -2238.0,
        769.9774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -256.652587890625,
        -2291.60009765625,
        762.615478515625
      ],
      "bbox_max": [
        -256.477783203125,
        -2291.177978515625,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -324.19696044921875,
        -2266.036865234375,
        712.0
      ],
      "bbox_max": [
        -270.24554443359375,
        -2238.0,
        769.9774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.543212890625,
      "bbox_min": [
        -275.60009765625,
        -2266.036865234375,
        764.4598388671875
      ],
      "bbox_max": [
        -270.24554443359375,
        -2259.823486328125,
        769.9774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -275.60009765625,
        -2263.622314453125,
        764.4598999023438
      ],
      "bbox_max": [
        -271.80126953125,
        -2259.823486328125,
        769.9774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -955.4878540039062,
        -2806.955322265625,
        712.0
      ],
      "bbox_max": [
        -485.73870849609375,
        -2133.624755859375,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -955.4878540039062,
        -2806.955322265625,
        712.0
      ],
      "bbox_max": [
        -498.223876953125,
        -2133.624755859375,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -955.4878540039062,
        -2806.955322265625,
        712.0
      ],
      "bbox_max": [
        -498.223876953125,
        -2133.624755859375,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -955.4878540039062,
        -2806.955322265625,
        712.0
      ],
      "bbox_max": [
        -498.223876953125,
        -2133.624755859375,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -955.4878540039062,
        -2806.955322265625,
        712.0
      ],
      "bbox_max": [
        -498.223876953125,
        -2133.624755859375,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -914.2557983398438,
        -2806.955322265625,
        712.0
      ],
      "bbox_max": [
        -498.223876953125,
        -2357.11669921875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9314306974411011,
        0.3556700348854065,
        0.0770426094532013
      ],
      "plane_d": 1355.5810546875,
      "bbox_min": [
        -914.2557983398438,
        -2806.955322265625,
        712.0
      ],
      "bbox_max": [
        -498.223876953125,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -914.2557983398438,
        -2566.875,
        712.0
      ],
      "bbox_max": [
        -594.252197265625,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -914.2557983398438,
        -2566.875,
        712.0
      ],
      "bbox_max": [
        -594.252197265625,
        -2409.47900390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -914.2557983398438,
        -2566.875,
        712.0
      ],
      "bbox_max": [
        -901.8233032226562,
        -2549.875,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -914.2557983398438,
        -2566.875,
        712.0
      ],
      "bbox_max": [
        -908.08447265625,
        -2556.32177734375,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -698.2745361328125,
        -2409.47900390625,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -860.804443359375,
        -2408.3671875,
        712.0
      ],
      "bbox_max": [
        -685.0712890625,
        -2168.956298828125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -774.505126953125,
        -2408.3671875,
        1051.602294921875
      ],
      "bbox_max": [
        -685.0712890625,
        -2299.141845703125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        1165.040283203125
      ],
      "bbox_max": [
        -685.0712890625,
        -2317.737060546875,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -738.92578125,
        -2408.3671875,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2339.8720703125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -860.804443359375,
        -2316.442138671875,
        712.0
      ],
      "bbox_max": [
        -752.8074951171875,
        -2173.491455078125,
        1403.453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -771.3399047851562,
        -2309.72265625,
        712.0
      ],
      "bbox_max": [
        -755.806396484375,
        -2276.37548828125,
        861.0977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -786.48876953125,
        -2316.442138671875,
        712.0
      ],
      "bbox_max": [
        -752.8074951171875,
        -2261.742919921875,
        1371.9813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -773.9360961914062,
        -2311.53076171875,
        712.0
      ],
      "bbox_max": [
        -754.3880615234375,
        -2268.585205078125,
        910.4207153320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -767.9937133789062,
        -2293.91650390625,
        712.0
      ],
      "bbox_max": [
        -760.0298461914062,
        -2277.914306640625,
        831.6309814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -852.66796875,
        -2248.078125,
        712.0
      ],
      "bbox_max": [
        -787.0260620117188,
        -2168.956298828125,
        929.3052978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -777.7199096679688,
        -2287.79248046875,
        712.0
      ],
      "bbox_max": [
        -761.7081909179688,
        -2262.626220703125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.7066650390625,
        -2277.914306640625,
        831.6309814453125
      ],
      "bbox_max": [
        -767.9937133789062,
        -2263.272216796875,
        944.0587768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.7066650390625,
        -2271.98486328125,
        903.442138671875
      ],
      "bbox_max": [
        -771.7666625976562,
        -2263.272216796875,
        944.0587768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -777.7199096679688,
        -2272.615966796875,
        902.1463623046875
      ],
      "bbox_max": [
        -771.3638305664062,
        -2262.626220703125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -777.7199096679688,
        -2272.615966796875,
        902.1463623046875
      ],
      "bbox_max": [
        -771.3638305664062,
        -2262.626220703125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.0943603515625,
        -2272.615966796875,
        902.1463623046875
      ],
      "bbox_max": [
        -771.3638305664062,
        -2264.15380859375,
        942.9470825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -787.0260620117188,
        -2259.135009765625,
        929.3052978515625
      ],
      "bbox_max": [
        -779.9501342773438,
        -2248.078125,
        1019.874267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -787.0260620117188,
        -2256.06494140625,
        929.3052978515625
      ],
      "bbox_max": [
        -781.0300903320312,
        -2248.078125,
        974.869384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -786.7236328125,
        -2407.66796875,
        712.0
      ],
      "bbox_max": [
        -685.0712890625,
        -2240.106689453125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -778.8007202148438,
        -2407.66796875,
        712.0
      ],
      "bbox_max": [
        -685.0712890625,
        -2261.486328125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.980712890625,
        -2264.432373046875,
        932.41943359375
      ],
      "bbox_max": [
        -774.7032470703125,
        -2262.449951171875,
        949.2651977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.980712890625,
        -2264.15380859375,
        942.9470825195312
      ],
      "bbox_max": [
        -775.0943603515625,
        -2262.449951171875,
        949.2651977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -778.8007202148438,
        -2407.66796875,
        942.7564697265625
      ],
      "bbox_max": [
        -685.0712890625,
        -2261.486328125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.7510375976562,
        -2333.14013671875,
        1156.9876708984375
      ],
      "bbox_max": [
        -733.1166381835938,
        -2332.1337890625,
        1178.760986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.7510375976562,
        -2332.5322265625,
        1156.9876708984375
      ],
      "bbox_max": [
        -733.1773681640625,
        -2332.1337890625,
        1165.0404052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.3422241210938,
        -2264.304931640625,
        942.7564697265625
      ],
      "bbox_max": [
        -774.9893798828125,
        -2261.486328125,
        1036.4188232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.5611572265625,
        -2264.304931640625,
        942.7564697265625
      ],
      "bbox_max": [
        -774.9893798828125,
        -2263.055419921875,
        948.4864501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -781.3290405273438,
        -2261.899169921875,
        946.2813720703125
      ],
      "bbox_max": [
        -778.0450439453125,
        -2254.945068359375,
        1062.635009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -781.3290405273438,
        -2261.899169921875,
        946.2813720703125
      ],
      "bbox_max": [
        -778.0450439453125,
        -2254.945068359375,
        1062.635009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -781.3290405273438,
        -2257.5849609375,
        946.2813720703125
      ],
      "bbox_max": [
        -779.5615234375,
        -2254.945068359375,
        969.53857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -785.4612426757812,
        -2356.0107421875,
        712.0
      ],
      "bbox_max": [
        -718.0658569335938,
        -2241.484619140625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.055419921875,
        948.4864501953125
      ],
      "bbox_max": [
        -775.5611572265625,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.0450439453125,
        -2356.0107421875,
        948.3524780273438
      ],
      "bbox_max": [
        -718.0658569335938,
        -2260.681396484375,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524780273438
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        964.4517822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524780273438
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -733.188232421875,
        -2356.0107421875,
        1154.5731201171875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2332.494140625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -733.188232421875,
        -2356.0107421875,
        1154.5731201171875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2332.494140625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -733.188232421875,
        -2332.73046875,
        1154.5731201171875
      ],
      "bbox_max": [
        -732.9428100585938,
        -2332.494140625,
        1164.033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.188232421875,
        -2332.73046875,
        1158.9423828125
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494140625,
        1164.033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.188232421875,
        -2332.605712890625,
        1158.9423828125
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494140625,
        1160.839599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -779.7763061523438,
        -2261.486328125,
        950.908203125
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -779.7763061523438,
        -2261.3818359375,
        950.908203125
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -779.7763061523438,
        -2260.681396484375,
        950.908203125
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        966.5499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.091210275888443,
        0.16736166179180145,
        0.9816673398017883
      ],
      "plane_d": 141.69515991210938,
      "bbox_min": [
        -716.9764404296875,
        -2327.779052734375,
        57.121009826660156
      ],
      "bbox_max": [
        54.0048828125,
        -1207.348876953125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -716.9764404296875,
        -2327.779052734375,
        635.0
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        635.0
      ],
      "bbox_max": [
        -281.0429382324219,
        -1979.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        635.0
      ],
      "bbox_max": [
        -281.0429382324219,
        -1979.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -281.0429382324219,
        -1979.0,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -281.0429382324219,
        -1987.0,
        636.369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -465.15191650390625,
        -2068.681396484375,
        639.28125
      ],
      "bbox_max": [
        -283.0,
        -1979.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -416.1728515625,
        -2068.681396484375,
        639.28125
      ],
      "bbox_max": [
        -409.1650085449219,
        -2064.272216796875,
        639.5584106445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -716.9764404296875,
        -2327.779052734375,
        635.0
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        636.369140625
      ],
      "bbox_max": [
        -283.0,
        -1984.2921142578125,
        639.2814331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -716.9764404296875,
        -2327.779052734375,
        639.28125
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5919927358627319,
        0.8059433102607727,
        0.0
      ],
      "plane_d": 1469.767333984375,
      "bbox_min": [
        -714.0125122070312,
        -2323.25634765625,
        639.28125
      ],
      "bbox_max": [
        -275.0,
        -1982.1131591796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05406983569264412,
        0.1127212643623352,
        0.9921544790267944
      ],
      "plane_d": -417.09210205078125,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -330.3504333496094,
        -2083.614990234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8327006101608276,
        0.4807601869106293,
        0.27473509311676025
      ],
      "plane_d": 1169.4652099609375,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -330.3504333496094,
        -2105.415283203125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10863621532917023,
        0.1850149929523468,
        0.9767126441001892
      ],
      "plane_d": -275.51318359375,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -383.5627746582031,
        -2116.6298828125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9998779296875,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -383.5627746582031,
        -2120.63427734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -560.1396484375,
        -2237.27685546875,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -562.7290649414062,
        -2241.306640625,
        639.9999389648438
      ],
      "bbox_max": [
        -560.1396484375,
        -2237.78125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        639.9999389648438
      ],
      "bbox_max": [
        -404.5227355957031,
        -2127.009521484375,
        640.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476275444031,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -399.0545349121094,
        -2124.38671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.608748733997345,
        0.793363094329834,
        0.0
      ],
      "plane_d": 1940.9437255859375,
      "bbox_min": [
        -404.0048828125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -399.0545349121094,
        -2124.38671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        9.911101187753957e-06
      ],
      "plane_d": -1640.2421875,
      "bbox_min": [
        -401.07666015625,
        -2125.55419921875,
        639.9999389648438
      ],
      "bbox_max": [
        -399.0545349121094,
        -2124.38671875,
        640.0223999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -425.91278076171875,
        -2136.50830078125,
        639.28125
      ],
      "bbox_max": [
        -393.262939453125,
        -2116.6298828125,
        639.9134521484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9998779296875,
      "bbox_min": [
        -393.30682373046875,
        -2146.992919921875,
        639.28125
      ],
      "bbox_max": [
        -354.70849609375,
        -2105.415283203125,
        641.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -393.30682373046875,
        -2116.8046875,
        639.28125
      ],
      "bbox_max": [
        -380.9677734375,
        -2109.384765625,
        639.4542236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999973177909851,
        0.8660269379615784,
        0.0
      ],
      "plane_d": 1656.249755859375,
      "bbox_min": [
        -383.81024169921875,
        -2146.992919921875,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2105.415283203125,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660218715667725,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        640.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        0.866020917892456,
        0.0
      ],
      "plane_d": 1673.533203125,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        640.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        641.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.86605304479599,
        0.49995216727256775,
        0.0
      ],
      "plane_d": 1393.328125,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        640.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25884971022605896,
        0.9659175872802734,
        0.0
      ],
      "plane_d": 2170.00927734375,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        640.0
      ],
      "bbox_max": [
        -371.609375,
        -2133.052490234375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659175872802734,
        -0.2588496804237366,
        0.0
      ],
      "plane_d": -186.1974334716797,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        640.0
      ],
      "bbox_max": [
        -377.464111328125,
        -2133.052490234375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000227689743042,
        -0.8660122752189636,
        0.0
      ],
      "plane_d": -1658.509033203125,
      "bbox_min": [
        -379.109375,
        -2134.00244140625,
        640.0
      ],
      "bbox_max": [
        -377.464111328125,
        -2133.052490234375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659175872802734,
        0.2588496804237366,
        0.0
      ],
      "plane_d": 203.87515258789062,
      "bbox_min": [
        -373.41796875,
        -2141.992919921875,
        640.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997738003730774,
        -0.86603844165802,
        0.0
      ],
      "plane_d": -1658.581787109375,
      "bbox_min": [
        -373.41796875,
        -2130.052490234375,
        640.0
      ],
      "bbox_max": [
        -367.717041015625,
        -2128.060546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86605304479599,
        -0.49995216727256775,
        -0.0
      ],
      "plane_d": -1387.3282470703125,
      "bbox_min": [
        -373.41796875,
        -2130.052490234375,
        640.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25884971022605896,
        -0.9659175872802734,
        -0.0
      ],
      "plane_d": -2152.33154296875,
      "bbox_min": [
        -370.44921875,
        -2129.734619140625,
        640.0
      ],
      "bbox_max": [
        -367.717041015625,
        -2129.00244140625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.793363094329834,
        0.608748733997345,
        0.0
      ],
      "plane_d": 1005.81884765625,
      "bbox_min": [
        -359.5050048828125,
        -2119.41064453125,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2105.415283203125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476275444031,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -359.5050048828125,
        -2114.552978515625,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2105.415283203125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.2069091796875,
      "bbox_min": [
        -359.5050048828125,
        -2108.482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -355.507568359375,
        -2105.415283203125,
        640.5662231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8261845707893372,
        -0.47699832916259766,
        0.29981938004493713
      ],
      "plane_d": -1510.0537109375,
      "bbox_min": [
        -383.9648742675781,
        -2190.361328125,
        641.0
      ],
      "bbox_max": [
        -330.3504333496094,
        -2112.073486328125,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1983572542667389,
        -0.11451967060565948,
        0.9734165072441101
      ],
      "plane_d": -940.360595703125,
      "bbox_min": [
        -340.07177734375,
        -2182.478271484375,
        641.0
      ],
      "bbox_max": [
        -332.7718811035156,
        -2172.489990234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000067353248596,
        -0.8660215139389038,
        0.0
      ],
      "plane_d": -1712.534912109375,
      "bbox_min": [
        -340.07177734375,
        -2182.478271484375,
        641.0
      ],
      "bbox_max": [
        -332.7718811035156,
        -2172.489990234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999865889549255,
        0.8660261631011963,
        -1.130802593252156e-05
      ],
      "plane_d": 1722.5550537109375,
      "bbox_min": [
        -335.07177734375,
        -2182.478271484375,
        641.0
      ],
      "bbox_max": [
        -332.7718811035156,
        -2181.150390625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.793363094329834,
        0.608748733997345,
        0.0
      ],
      "plane_d": 1005.81884765625,
      "bbox_min": [
        -358.435791015625,
        -2119.41064453125,
        641.0
      ],
      "bbox_max": [
        -354.70849609375,
        -2112.073486328125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660218715667725,
        0.5000061392784119,
        0.0
      ],
      "plane_d": 1397.33154296875,
      "bbox_min": [
        -383.9648742675781,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2124.96240234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000038146972656,
        0.8660231828689575,
        0.0
      ],
      "plane_d": 1656.2393798828125,
      "bbox_min": [
        -383.9648742675781,
        -2134.14990234375,
        641.0
      ],
      "bbox_max": [
        -381.9916687011719,
        -2133.0107421875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660218715667725,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -381.99169921875,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2124.96240234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999973177909851,
        0.8660269379615784,
        0.0
      ],
      "plane_d": 1656.249755859375,
      "bbox_min": [
        -369.86724853515625,
        -2126.010498046875,
        641.0
      ],
      "bbox_max": [
        -368.0517272949219,
        -2124.96240234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999973177909851,
        0.8660269379615784,
        0.0
      ],
      "plane_d": 1656.249755859375,
      "bbox_min": [
        -381.99169921875,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2126.010498046875,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25884971022605896,
        0.9659175872802734,
        0.0
      ],
      "plane_d": 2170.00927734375,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659175872802734,
        0.2588496804237366,
        0.0
      ],
      "plane_d": 203.87515258789062,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49997738003730774,
        0.86603844165802,
        0.0
      ],
      "plane_d": 1673.581787109375,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.94921875,
        -2128.060546875,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8608181476593018,
        0.4970272481441498,
        -0.10934361815452576
      ],
      "plane_d": 1455.202880859375,
      "bbox_min": [
        -369.964111328125,
        -2146.908935546875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2143.04296875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8617133498191833,
        -0.49754413962364197,
        -0.09949871897697449
      ],
      "plane_d": -1316.8052978515625,
      "bbox_min": [
        -364.8221740722656,
        -2143.940185546875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2143.04296875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997738003730774,
        -0.86603844165802,
        0.0
      ],
      "plane_d": -1658.581787109375,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        641.0
      ],
      "bbox_max": [
        -367.717041015625,
        -2128.060546875,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.86605304479599,
        0.49995216727256775,
        0.0
      ],
      "plane_d": 1393.328125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        641.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86605304479599,
        -0.49995216727256775,
        -0.0
      ],
      "plane_d": -1387.3282470703125,
      "bbox_min": [
        -373.41796875,
        -2130.052490234375,
        641.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25884971022605896,
        -0.9659175872802734,
        -0.0
      ],
      "plane_d": -2152.33154296875,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        641.0
      ],
      "bbox_max": [
        -367.717041015625,
        -2129.00244140625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659175872802734,
        -0.2588496804237366,
        0.0
      ],
      "plane_d": -186.1974334716797,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        641.0
      ],
      "bbox_max": [
        -379.109375,
        -2134.00244140625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9998779296875,
      "bbox_min": [
        -449.04290771484375,
        -2153.498046875,
        639.28125
      ],
      "bbox_max": [
        -348.6988830566406,
        -2083.614990234375,
        641.6248779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -426.59326171875,
        -2137.008056640625,
        639.28125
      ],
      "bbox_max": [
        -371.0722961425781,
        -2098.886474609375,
        640.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -394.2156677246094,
        -2118.44580078125,
        639.28125
      ],
      "bbox_max": [
        -375.3222351074219,
        -2106.9033203125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3261350393295288,
        0.5656664967536926,
        0.7574017643928528
      ],
      "plane_d": 584.7685546875,
      "bbox_min": [
        -393.1123962402344,
        -2117.34912109375,
        639.28125
      ],
      "bbox_max": [
        -375.3222351074219,
        -2106.9033203125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2591370642185211,
        0.32625335454940796,
        0.9090691208839417
      ],
      "plane_d": 8.32012939453125,
      "bbox_min": [
        -380.9677734375,
        -2110.094482421875,
        639.28125
      ],
      "bbox_max": [
        -375.3222351074219,
        -2106.9033203125,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726297914981842,
        0.536638617515564,
        0.7570772171020508
      ],
      "plane_d": 506.0321044921875,
      "bbox_min": [
        -380.9677734375,
        -2110.094482421875,
        639.28125
      ],
      "bbox_max": [
        -379.28436279296875,
        -2109.229736328125,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -383.8895263671875,
        -2109.384765625,
        639.28125
      ],
      "bbox_max": [
        -371.0722961425781,
        -2098.886474609375,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726341724395752,
        0.5366532206535339,
        0.7570648193359375
      ],
      "plane_d": 506.0691223144531,
      "bbox_min": [
        -380.9677734375,
        -2109.384765625,
        639.28125
      ],
      "bbox_max": [
        -371.0722961425781,
        -2103.527587890625,
        639.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2591370642185211,
        0.32625335454940796,
        0.9090691208839417
      ],
      "plane_d": 8.32012939453125,
      "bbox_min": [
        -380.9677734375,
        -2109.384765625,
        639.28125
      ],
      "bbox_max": [
        -371.0722961425781,
        -2103.527587890625,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -449.04290771484375,
        -2153.498046875,
        639.9999389648438
      ],
      "bbox_max": [
        -348.6988830566406,
        -2083.614990234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -406.736328125,
        -2139.301513671875,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2097.13623046875,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.13058817386627197,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -406.736328125,
        -2139.301513671875,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2098.790771484375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        9.911101187753957e-06
      ],
      "plane_d": -1640.2421875,
      "bbox_min": [
        -406.736328125,
        -2139.301513671875,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2104.755126953125,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254074692726135,
        -0.17237462103366852
      ],
      "plane_d": -1249.18896484375,
      "bbox_min": [
        -376.2414855957031,
        -2110.6962890625,
        640.0
      ],
      "bbox_max": [
        -375.095947265625,
        -2108.822265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.608748733997345,
        0.0
      ],
      "plane_d": -975.72900390625,
      "bbox_min": [
        -406.736328125,
        -2139.301513671875,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2104.755126953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        640.06884765625
      ],
      "bbox_max": [
        -405.25909423828125,
        -2127.96923828125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476275444031,
        0.0
      ],
      "plane_d": -2039.7249755859375,
      "bbox_min": [
        -404.803955078125,
        -2139.301513671875,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2104.755126953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476275444031,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -404.803955078125,
        -2139.301513671875,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2104.755126953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476275444031,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -404.0048828125,
        -2139.301513671875,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2104.755126953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.2069091796875,
      "bbox_min": [
        -404.0048828125,
        -2139.301513671875,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2104.755126953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530882596969604,
        -0.49248817563056946,
        -0.17232513427734375
      ],
      "plane_d": -1249.125,
      "bbox_min": [
        -392.9296875,
        -2118.322265625,
        639.9999389648438
      ],
      "bbox_max": [
        -376.095947265625,
        -2107.806884765625,
        640.96044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492053747177124,
        0.4903010427951813,
        -0.19610005617141724
      ],
      "plane_d": 1497.4755859375,
      "bbox_min": [
        -392.9296875,
        -2118.322265625,
        640.0
      ],
      "bbox_max": [
        -392.44219970703125,
        -2117.66552734375,
        640.6255493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -449.04290771484375,
        -2153.498046875,
        639.9999389648438
      ],
      "bbox_max": [
        -348.6988830566406,
        -2083.614990234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563422560691833,
        0.5164087414741516,
        0.0
      ],
      "plane_d": 771.662353515625,
      "bbox_min": [
        -360.30859375,
        -2098.155517578125,
        639.9999389648438
      ],
      "bbox_max": [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753774404525757,
        -0.22054219245910645,
        -0.0
      ],
      "plane_d": -812.7610473632812,
      "bbox_min": [
        -360.30859375,
        -2098.155517578125,
        639.9999389648438
      ],
      "bbox_max": [
        -358.86541748046875,
        -2091.77294921875,
        640.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753774404525757,
        -0.22054219245910645,
        -0.0
      ],
      "plane_d": -812.7610473632812,
      "bbox_min": [
        -359.2350769042969,
        -2099.238525390625,
        640.8145751953125
      ],
      "bbox_max": [
        -358.675537109375,
        -2096.520751953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -358.75,
        -2099.238525390625,
        641.4857177734375
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580765724182129,
        0.6098299026489258,
        0.7070280313491821
      ],
      "plane_d": 697.96044921875,
      "bbox_min": [
        -449.04290771484375,
        -2153.498046875,
        639.9999389648438
      ],
      "bbox_max": [
        -357.18017578125,
        -2086.585205078125,
        641.6248779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -404.525634765625,
        -2127.013427734375,
        640.4264526367188
      ],
      "bbox_max": [
        -365.99072265625,
        -2103.6318359375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491909503936768,
        0.490313857793808,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.44219970703125,
        -2119.208984375,
        640.62548828125
      ],
      "bbox_max": [
        -365.99072265625,
        -2103.6318359375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058817386627197,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -376.28717041015625,
        -2109.666748046875,
        640.96044921875
      ],
      "bbox_max": [
        -365.99072265625,
        -2103.6318359375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254074692726135,
        -0.17237462103366852
      ],
      "plane_d": -1249.18896484375,
      "bbox_min": [
        -376.28717041015625,
        -2109.666748046875,
        640.96044921875
      ],
      "bbox_max": [
        -375.9366455078125,
        -2108.90625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530882596969604,
        -0.49248817563056946,
        -0.17232513427734375
      ],
      "plane_d": -1249.125,
      "bbox_min": [
        -393.1123962402344,
        -2118.259765625,
        639.9999389648438
      ],
      "bbox_max": [
        -376.241455078125,
        -2107.72802734375,
        641.2645263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492053747177124,
        0.4903010427951813,
        -0.19610005617141724
      ],
      "plane_d": 1497.4755859375,
      "bbox_min": [
        -393.1123962402344,
        -2118.259765625,
        640.0
      ],
      "bbox_max": [
        -392.3555908203125,
        -2117.34912109375,
        641.1256103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726341724395752,
        0.5366532206535339,
        0.7570648193359375
      ],
      "plane_d": 506.0691223144531,
      "bbox_min": [
        -403.0185241699219,
        -2125.049560546875,
        639.9999389648438
      ],
      "bbox_max": [
        -357.18017578125,
        -2086.585205078125,
        641.6248779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.13058817386627197,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        641.3368530273438
      ],
      "bbox_max": [
        -366.7024841308594,
        -2103.7255859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753774404525757,
        -0.22054219245910645,
        -0.0
      ],
      "plane_d": -812.7610473632812,
      "bbox_min": [
        -359.2350769042969,
        -2098.328369140625,
        640.859619140625
      ],
      "bbox_max": [
        -358.8263244628906,
        -2096.520751953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491909503936768,
        0.490313857793808,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.35552978515625,
        -2118.59130859375,
        641.125732421875
      ],
      "bbox_max": [
        -376.1604309082031,
        -2108.9326171875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254074692726135,
        -0.17237462103366852
      ],
      "plane_d": -1249.18896484375,
      "bbox_min": [
        -376.3421936035156,
        -2109.279052734375,
        641.2617797851562
      ],
      "bbox_max": [
        -376.1604309082031,
        -2108.9326171875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563422560691833,
        0.5164087414741516,
        0.0
      ],
      "plane_d": 771.662353515625,
      "bbox_min": [
        -360.30859375,
        -2097.453857421875,
        640.859619140625
      ],
      "bbox_max": [
        -357.18017578125,
        -2086.585205078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753774404525757,
        -0.22054219245910645,
        -0.0
      ],
      "plane_d": -812.7610473632812,
      "bbox_min": [
        -360.30859375,
        -2097.453857421875,
        640.859619140625
      ],
      "bbox_max": [
        -359.0240783691406,
        -2091.77294921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -714.0125122070312,
        -2278.32275390625,
        639.28125
      ],
      "bbox_max": [
        -275.0,
        -1982.1131591796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -600.715087890625,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -511.7373046875,
        -2132.99560546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -600.715087890625,
        -2195.306396484375,
        639.2813110351562
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -599.257568359375,
        -2195.333251953125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.18994140625,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -563.099609375,
        -2237.27685546875,
        639.28125
      ],
      "bbox_max": [
        -275.0,
        -1982.1131591796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -481.86572265625,
        -2175.087646484375,
        639.28125
      ],
      "bbox_max": [
        -353.90350341796875,
        -2077.0341796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -432.43115234375,
        -2140.79345703125,
        639.28125
      ],
      "bbox_max": [
        -420.93878173828125,
        -2132.854736328125,
        640.6549072265625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.10863621532917023,
        0.1850149929523468,
        0.9767126441001892
      ],
      "plane_d": -275.51318359375,
      "bbox_min": [
        -432.43115234375,
        -2139.602783203125,
        639.28125
      ],
      "bbox_max": [
        -420.93878173828125,
        -2132.854736328125,
        639.4351806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -481.86572265625,
        -2175.087646484375,
        639.28125
      ],
      "bbox_max": [
        -478.2337646484375,
        -2172.58935546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -412.7320861816406,
        -2098.81298828125,
        639.28125
      ],
      "bbox_max": [
        -275.0,
        -1982.1131591796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -409.1650085449219,
        -2078.708984375,
        639.2814331054688
      ],
      "bbox_max": [
        -275.0,
        -1982.1131591796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        639.2814331054688
      ],
      "bbox_max": [
        -283.0,
        -1982.1131591796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -388.2838439941406,
        -2051.13671875,
        640.9827270507812
      ],
      "bbox_max": [
        -377.6329040527344,
        -2046.1793212890625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -388.48822021484375,
        -2051.011962890625,
        641.1808471679688
      ],
      "bbox_max": [
        -381.7648620605469,
        -2047.9122314453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        641.6248779296875
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        690.058837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        641.6248779296875
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        681.0655517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -406.5951232910156,
        -2073.8486328125,
        641.6248779296875
      ],
      "bbox_max": [
        -217.74951171875,
        -1970.763427734375,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        678.6296997070312
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        703.77734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        678.6296997070312
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        692.03515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -406.5951232910156,
        -2073.8486328125,
        641.6248779296875
      ],
      "bbox_max": [
        -217.74951171875,
        -1970.763427734375,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -406.5951232910156,
        -2073.8486328125,
        641.6248779296875
      ],
      "bbox_max": [
        -217.74951171875,
        -1970.763427734375,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -406.5951232910156,
        -2073.8486328125,
        641.6248779296875
      ],
      "bbox_max": [
        -217.74951171875,
        -1970.763427734375,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -377.63287353515625,
        -2073.8486328125,
        641.6248779296875
      ],
      "bbox_max": [
        -299.30364990234375,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -309.987548828125,
        -2066.0234375,
        645.5848999023438
      ],
      "bbox_max": [
        -297.43212890625,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -341.9967956542969,
        -1987.0,
        691.2603759765625
      ],
      "bbox_max": [
        -275.0,
        -1970.763427734375,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        691.2603759765625
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        701.46728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47035908699035645,
        -0.7688663601875305,
        0.4331360161304474
      ],
      "plane_d": -1666.129638671875,
      "bbox_min": [
        -341.9967956542969,
        -1974.93994140625,
        710.3526000976562
      ],
      "bbox_max": [
        -334.1983642578125,
        -1970.763427734375,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -335.2963562011719,
        -1971.594482421875,
        710.3526000976562
      ],
      "bbox_max": [
        -334.1983642578125,
        -1970.763427734375,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -644.8826904296875,
        -2237.091064453125,
        641.6248779296875
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -375.6366271972656,
        -2000.8775634765625,
        692.8463745117188
      ],
      "bbox_max": [
        -219.687744140625,
        -1972.45947265625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -223.32188415527344,
        -1983.23779296875,
        703.2808227539062
      ],
      "bbox_max": [
        -219.687744140625,
        -1978.3231201171875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -375.6366271972656,
        -2000.8775634765625,
        692.8463745117188
      ],
      "bbox_max": [
        -275.0,
        -1973.01123046875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794841408729553,
        -0.8249640464782715,
        0.4013371765613556
      ],
      "plane_d": -1778.3809814453125,
      "bbox_min": [
        -370.9345703125,
        -1988.2584228515625,
        701.36328125
      ],
      "bbox_max": [
        -275.0,
        -1973.01123046875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        701.36328125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        701.36328125
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        705.44970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -481.7292785644531,
        -2232.79736328125,
        641.6248779296875
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7727664709091187,
        0.44615715742111206,
        -0.45141535997390747
      ],
      "plane_d": 1543.02392578125,
      "bbox_min": [
        -406.736328125,
        -2200.361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -243.34596252441406,
        -2065.764892578125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000038146972656,
        0.8660231828689575,
        0.0
      ],
      "plane_d": 1656.2393798828125,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -381.10101318359375,
        -2127.088623046875,
        658.137451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1305050551891327,
        0.9914476275444031,
        0.0
      ],
      "plane_d": 2069.815185546875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -393.07666015625,
        -2127.088623046875,
        657.8483276367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.608748733997345,
        0.793363094329834,
        0.0
      ],
      "plane_d": 1940.9437255859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -399.147216796875,
        -2127.088623046875,
        655.2444458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476275444031,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -406.736328125,
        -2136.482421875,
        641.6248779296875
      ],
      "bbox_max": [
        -402.25396728515625,
        -2127.088623046875,
        649.1953735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -406.5956115722656,
        -2129.710693359375,
        641.7142333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.608748733997345,
        0.0
      ],
      "plane_d": -975.72900390625,
      "bbox_min": [
        -404.803955078125,
        -2130.411865234375,
        641.6248779296875
      ],
      "bbox_max": [
        -402.25396728515625,
        -2127.088623046875,
        643.2442016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        -388.33538818359375,
        -2200.361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -243.34596252441406,
        -2065.764892578125,
        671.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8737850189208984,
        -0.4863123297691345,
        -0.0
      ],
      "plane_d": -1334.172607421875,
      "bbox_min": [
        -345.8387451171875,
        -2144.902587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -333.12548828125,
        -2122.06005859375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8327006101608276,
        0.4807601869106293,
        0.27473509311676025
      ],
      "plane_d": 1169.4652099609375,
      "bbox_min": [
        -388.33538818359375,
        -2200.361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -243.34596252441406,
        -2065.764892578125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660250902175903,
        -0.5000004768371582,
        -0.0
      ],
      "plane_d": -1343.420654296875,
      "bbox_min": [
        -370.9185485839844,
        -2183.130126953125,
        641.6248779296875
      ],
      "bbox_max": [
        -243.34596252441406,
        -2065.764892578125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -305.87005615234375,
        -2161.239013671875,
        643.0
      ],
      "bbox_max": [
        -243.34596252441406,
        -2065.764892578125,
        659.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.0,
      "bbox_min": [
        -305.87005615234375,
        -2161.239013671875,
        643.0
      ],
      "bbox_max": [
        -303.4555969238281,
        -2157.05712890625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914367198944092,
        -0.13058817386627197,
        -0.0
      ],
      "plane_d": -583.0892944335938,
      "bbox_min": [
        -305.87005615234375,
        -2161.239013671875,
        643.0
      ],
      "bbox_max": [
        -303.4555969238281,
        -2157.05712890625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -251.72581481933594,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -243.34596252441406,
        -2065.764892578125,
        645.7661743164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087730526924133,
        -0.7933444380760193,
        -0.0
      ],
      "plane_d": -1897.4947509765625,
      "bbox_min": [
        -305.87005615234375,
        -2161.239013671875,
        645.7384643554688
      ],
      "bbox_max": [
        -303.4555969238281,
        -2157.05712890625,
        659.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3730744285567198e-05,
        1.7893711628858e-05,
        -1.0
      ],
      "plane_d": 659.9428100585938,
      "bbox_min": [
        -305.87005615234375,
        -2161.239013671875,
        659.9000244140625
      ],
      "bbox_max": [
        -303.4555969238281,
        -2157.05712890625,
        659.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123877763748169,
        -0.35356271266937256,
        -0.7070888876914978
      ],
      "plane_d": -486.1156921386719,
      "bbox_min": [
        -370.9185485839844,
        -2183.130126953125,
        641.6248779296875
      ],
      "bbox_max": [
        -303.297119140625,
        -2096.643798828125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3730744285567198e-05,
        1.7893711628858e-05,
        -1.0
      ],
      "plane_d": 659.9428100585938,
      "bbox_min": [
        -338.1441650390625,
        -2165.39208984375,
        656.0001220703125
      ],
      "bbox_max": [
        -303.297119140625,
        -2107.012939453125,
        659.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13052546977996826,
        -0.9914449453353882,
        0.0
      ],
      "plane_d": -2097.821533203125,
      "bbox_min": [
        -338.1441650390625,
        -2165.39208984375,
        656.0001220703125
      ],
      "bbox_max": [
        -303.297119140625,
        -2107.012939453125,
        659.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000298619270325,
        0.8660081624984741,
        0.0
      ],
      "plane_d": 1656.3992919921875,
      "bbox_min": [
        -338.1441650390625,
        -2107.926513671875,
        658.7000732421875
      ],
      "bbox_max": [
        -337.551025390625,
        -2107.012939453125,
        659.3994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087730526924133,
        -0.7933444380760193,
        -0.0
      ],
      "plane_d": -1897.4947509765625,
      "bbox_min": [
        -306.832763671875,
        -2157.05712890625,
        656.0001220703125
      ],
      "bbox_max": [
        -305.87005615234375,
        -2156.318359375,
        659.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4924207925796509,
        -0.8528348207473755,
        -0.17376579344272614
      ],
      "plane_d": -1573.84912109375,
      "bbox_min": [
        -344.200927734375,
        -2183.130126953125,
        642.21435546875
      ],
      "bbox_max": [
        -318.79925537109375,
        -2164.6328125,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5854437947273254,
        -0.7921016216278076,
        -0.17271529138088226
      ],
      "plane_d": -1412.0927734375,
      "bbox_min": [
        -330.54541015625,
        -2170.916015625,
        648.0
      ],
      "bbox_max": [
        -322.5734558105469,
        -2164.6328125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46015921235084534,
        -0.8878363966941833,
        0.0
      ],
      "plane_d": -1773.008056640625,
      "bbox_min": [
        -330.54541015625,
        -2170.916015625,
        648.0
      ],
      "bbox_max": [
        -322.5734558105469,
        -2164.6328125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4696516990661621,
        -0.27115491032600403,
        -0.8401799201965332
      ],
      "plane_d": -184.4716339111328,
      "bbox_min": [
        -329.04541015625,
        -2170.916015625,
        659.83642578125
      ],
      "bbox_max": [
        -322.5734558105469,
        -2165.341552734375,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49239566922187805,
        0.8528446555137634,
        -0.1737886518239975
      ],
      "plane_d": 1808.9420166015625,
      "bbox_min": [
        -342.200927734375,
        -2183.130126953125,
        642.21435546875
      ],
      "bbox_max": [
        -318.79925537109375,
        -2164.6328125,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3932713568210602,
        0.9030541777610779,
        -0.17271600663661957
      ],
      "plane_d": 1949.8216552734375,
      "bbox_min": [
        -327.04541015625,
        -2176.978271484375,
        648.0
      ],
      "bbox_max": [
        -318.79925537109375,
        -2171.169189453125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5388208627700806,
        0.8424203395843506,
        0.0
      ],
      "plane_d": 1658.5201416015625,
      "bbox_min": [
        -327.04541015625,
        -2176.978271484375,
        648.0
      ],
      "bbox_max": [
        -318.79925537109375,
        -2171.169189453125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4696516990661621,
        -0.27115491032600403,
        -0.8401799201965332
      ],
      "plane_d": -184.4716339111328,
      "bbox_min": [
        -327.04541015625,
        -2174.380126953125,
        659.83642578125
      ],
      "bbox_max": [
        -319.2083740234375,
        -2171.169189453125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4696516990661621,
        -0.27115491032600403,
        -0.8401799201965332
      ],
      "plane_d": -184.4716339111328,
      "bbox_min": [
        -338.16650390625,
        -2181.378173828125,
        642.21435546875
      ],
      "bbox_max": [
        -318.79925537109375,
        -2164.6328125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46015921235084534,
        -0.8878363966941833,
        0.0
      ],
      "plane_d": -1773.008056640625,
      "bbox_min": [
        -338.16650390625,
        -2181.378173828125,
        642.21435546875
      ],
      "bbox_max": [
        -318.79925537109375,
        -2164.6328125,
        650.0630493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5388208627700806,
        0.8424203395843506,
        0.0
      ],
      "plane_d": 1658.5201416015625,
      "bbox_min": [
        -338.16650390625,
        -2181.378173828125,
        642.21435546875
      ],
      "bbox_max": [
        -318.79925537109375,
        -2164.6328125,
        650.0601806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000067353248596,
        -0.8660215139389038,
        0.0
      ],
      "plane_d": -1712.534912109375,
      "bbox_min": [
        -338.16650390625,
        -2181.378173828125,
        642.21435546875
      ],
      "bbox_max": [
        -318.79925537109375,
        -2164.6328125,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.0,
      "bbox_min": [
        -335.6023864746094,
        -2181.378173828125,
        642.21435546875
      ],
      "bbox_max": [
        -318.79925537109375,
        -2164.6328125,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1983572542667389,
        -0.11451967060565948,
        0.9734165072441101
      ],
      "plane_d": -940.360595703125,
      "bbox_min": [
        -335.6023864746094,
        -2180.0986328125,
        642.21435546875
      ],
      "bbox_max": [
        -327.710693359375,
        -2169.56787109375,
        643.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999865889549255,
        0.8660261631011963,
        -1.130802593252156e-05
      ],
      "plane_d": 1722.5550537109375,
      "bbox_min": [
        -330.9505615234375,
        -2180.0986328125,
        642.21435546875
      ],
      "bbox_max": [
        -327.710693359375,
        -2178.228271484375,
        643.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999865889549255,
        0.8660261631011963,
        -1.130802593252156e-05
      ],
      "plane_d": 1722.5550537109375,
      "bbox_min": [
        -333.16650390625,
        -2181.378173828125,
        643.0
      ],
      "bbox_max": [
        -325.54541015625,
        -2176.978271484375,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -354.70849609375,
        -2115.07080078125,
        646.9999389648438
      ],
      "bbox_max": [
        -352.1414794921875,
        -2112.798583984375,
        658.0526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914408326148987,
        0.13055682182312012,
        0.0
      ],
      "plane_d": 625.8935546875,
      "bbox_min": [
        -354.70849609375,
        -2115.07080078125,
        646.9999389648438
      ],
      "bbox_max": [
        -352.1414794921875,
        -2112.798583984375,
        657.8478393554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5999145507812,
      "bbox_min": [
        -354.70849609375,
        -2115.07080078125,
        649.5999145507812
      ],
      "bbox_max": [
        -352.776123046875,
        -2112.798583984375,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.1998901367188,
      "bbox_min": [
        -353.5945129394531,
        -2115.07080078125,
        657.1998901367188
      ],
      "bbox_max": [
        -352.776123046875,
        -2114.409912109375,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -352.9905700683594,
        -2115.07080078125,
        646.9999389648438
      ],
      "bbox_max": [
        -352.1414794921875,
        -2113.442138671875,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476275444031,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -370.115478515625,
        -2114.552978515625,
        641.6248779296875
      ],
      "bbox_max": [
        -353.3621826171875,
        -2102.00146484375,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5999145507812,
      "bbox_min": [
        -355.40521240234375,
        -2114.552978515625,
        649.5999145507812
      ],
      "bbox_max": [
        -353.3621826171875,
        -2109.260009765625,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476275444031,
        0.0
      ],
      "plane_d": -2039.7249755859375,
      "bbox_min": [
        -370.115478515625,
        -2108.010009765625,
        641.6248779296875
      ],
      "bbox_max": [
        -356.1233215332031,
        -2102.00146484375,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058817386627197,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -362.6966247558594,
        -2103.197998046875,
        641.6248779296875
      ],
      "bbox_max": [
        -359.5959167480469,
        -2102.00146484375,
        642.8467407226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -359.5959167480469,
        -2102.00146484375,
        642.8467407226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.2069091796875,
      "bbox_min": [
        -370.115478515625,
        -2108.010009765625,
        641.6248779296875
      ],
      "bbox_max": [
        -356.1233215332031,
        -2104.755126953125,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        -0.8660229444503784,
        0.0
      ],
      "plane_d": -1640.23876953125,
      "bbox_min": [
        -370.115478515625,
        -2107.6787109375,
        641.6248779296875
      ],
      "bbox_max": [
        -366.435791015625,
        -2105.55419921875,
        641.7137451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4696516990661621,
        -0.27115491032600403,
        -0.8401799201965332
      ],
      "plane_d": -184.4716339111328,
      "bbox_min": [
        -352.1414794921875,
        -2172.541015625,
        655.9998168945312
      ],
      "bbox_max": [
        -316.92413330078125,
        -2114.148193359375,
        659.83642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -350.2869873046875,
        -2114.451416015625,
        658.3313598632812
      ],
      "bbox_max": [
        -349.0675964355469,
        -2114.148193359375,
        659.0441284179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -352.1414794921875,
        -2114.912841796875,
        656.0000610351562
      ],
      "bbox_max": [
        -349.787353515625,
        -2114.3271484375,
        658.6508178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932713568210602,
        0.9030541777610779,
        -0.17271600663661957
      ],
      "plane_d": 1949.8216552734375,
      "bbox_min": [
        -319.2083740234375,
        -2172.541015625,
        655.9998779296875
      ],
      "bbox_max": [
        -316.92413330078125,
        -2171.247802734375,
        659.83642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 658.0,
      "bbox_min": [
        -359.5959167480469,
        -2172.663330078125,
        641.6248779296875
      ],
      "bbox_max": [
        -303.297119140625,
        -2096.643798828125,
        659.8999633789062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 659.8999633789062,
      "bbox_min": [
        -350.1219482421875,
        -2171.431640625,
        658.0
      ],
      "bbox_max": [
        -304.3089599609375,
        -2106.44140625,
        659.8999633789062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.499996542930603,
        0.8660274147987366,
        0.0
      ],
      "plane_d": 1722.5511474609375,
      "bbox_min": [
        -350.1219482421875,
        -2171.431640625,
        658.0
      ],
      "bbox_max": [
        -304.3089599609375,
        -2106.44140625,
        659.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999484419822693,
        -0.8660244345664978,
        -0.0026099965907633305
      ],
      "plane_d": -1710.82275390625,
      "bbox_min": [
        -350.1219482421875,
        -2171.431640625,
        658.0
      ],
      "bbox_max": [
        -304.3089599609375,
        -2106.44140625,
        659.8999633789062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4999948740005493,
        0.866028368473053,
        -1.664797127887141e-05
      ],
      "plane_d": 1656.46484375,
      "bbox_min": [
        -350.1219482421875,
        -2114.410400390625,
        658.0
      ],
      "bbox_max": [
        -337.551025390625,
        -2106.44140625,
        659.3850708007812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660277128219604,
        -0.49999600648880005,
        -0.0
      ],
      "plane_d": -1346.112060546875,
      "bbox_min": [
        -338.210693359375,
        -2107.583984375,
        658.0
      ],
      "bbox_max": [
        -337.551025390625,
        -2106.44140625,
        658.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660243153572083,
        0.5000019073486328,
        2.3740627511870116e-05
      ],
      "plane_d": 1358.4080810546875,
      "bbox_min": [
        -321.5696716308594,
        -2171.431640625,
        658.0
      ],
      "bbox_max": [
        -304.3089599609375,
        -2156.535400390625,
        659.8999633789062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4696516990661621,
        -0.27115491032600403,
        -0.8401799201965332
      ],
      "plane_d": -184.4716339111328,
      "bbox_min": [
        -321.5696716308594,
        -2171.431640625,
        658.0
      ],
      "bbox_max": [
        -316.4211120605469,
        -2163.35888671875,
        658.3314208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5854437947273254,
        -0.7921016216278076,
        -0.17271529138088226
      ],
      "plane_d": -1412.0927734375,
      "bbox_min": [
        -321.5696716308594,
        -2171.431640625,
        658.0
      ],
      "bbox_max": [
        -316.4211120605469,
        -2163.35888671875,
        658.3314208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933372855186462,
        0.6087823510169983,
        0.0
      ],
      "plane_d": 1075.8397216796875,
      "bbox_min": [
        -320.1533203125,
        -2165.478271484375,
        658.0
      ],
      "bbox_max": [
        -304.3089599609375,
        -2162.086669921875,
        659.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5094318985939026,
        -0.8605110049247742,
        0.0
      ],
      "plane_d": -1697.60205078125,
      "bbox_min": [
        -320.1533203125,
        -2162.31787109375,
        658.0
      ],
      "bbox_max": [
        -319.76287841796875,
        -2162.086669921875,
        659.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.499996542930603,
        0.8660274147987366,
        0.0
      ],
      "plane_d": 1722.5511474609375,
      "bbox_min": [
        -359.5959167480469,
        -2172.663330078125,
        641.6248779296875
      ],
      "bbox_max": [
        -303.297119140625,
        -2096.643798828125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5196319818496704,
        -0.3000100553035736,
        0.7999853491783142
      ],
      "plane_d": -1324.0692138671875,
      "bbox_min": [
        -359.5959167480469,
        -2172.663330078125,
        641.6248779296875
      ],
      "bbox_max": [
        -303.297119140625,
        -2096.643798828125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660250902175903,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": -1347.4207763671875,
      "bbox_min": [
        -320.2043151855469,
        -2166.47802734375,
        643.0
      ],
      "bbox_max": [
        -303.297119140625,
        -2138.997314453125,
        647.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.0,
      "bbox_min": [
        -320.0495910644531,
        -2165.478271484375,
        643.0
      ],
      "bbox_max": [
        -303.297119140625,
        -2138.997314453125,
        647.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13052546977996826,
        -0.9914449453353882,
        0.0
      ],
      "plane_d": -2097.821533203125,
      "bbox_min": [
        -320.0495910644531,
        -2165.478271484375,
        643.0
      ],
      "bbox_max": [
        -303.297119140625,
        -2138.997314453125,
        647.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -320.0495910644531,
        -2140.896240234375,
        645.0
      ],
      "bbox_max": [
        -318.760986328125,
        -2138.997314453125,
        645.2499389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660412430763245,
        -0.49997252225875854,
        0.0
      ],
      "plane_d": -1346.3660888671875,
      "bbox_min": [
        -320.0495910644531,
        -2140.896240234375,
        645.0
      ],
      "bbox_max": [
        -318.760986328125,
        -2138.997314453125,
        645.2499389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000253915786743,
        0.8660107254981995,
        0.0
      ],
      "plane_d": 1694.506103515625,
      "bbox_min": [
        -320.0495910644531,
        -2140.896240234375,
        645.0
      ],
      "bbox_max": [
        -318.760986328125,
        -2138.997314453125,
        645.2499389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000009536743164,
        -0.8660248517990112,
        0.0
      ],
      "plane_d": -1692.5440673828125,
      "bbox_min": [
        -320.0495910644531,
        -2139.163818359375,
        645.0
      ],
      "bbox_max": [
        -319.760986328125,
        -2138.997314453125,
        645.2499389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933372855186462,
        0.6087823510169983,
        0.0
      ],
      "plane_d": 1075.8397216796875,
      "bbox_min": [
        -306.832763671875,
        -2165.478271484375,
        643.0
      ],
      "bbox_max": [
        -303.297119140625,
        -2156.318359375,
        647.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087730526924133,
        -0.7933444380760193,
        -0.0
      ],
      "plane_d": -1897.4947509765625,
      "bbox_min": [
        -306.832763671875,
        -2157.05712890625,
        643.0
      ],
      "bbox_max": [
        -305.87005615234375,
        -2156.318359375,
        647.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49993693828582764,
        -0.8659241795539856,
        0.015438675880432129
      ],
      "plane_d": -1722.27392578125,
      "bbox_min": [
        -312.3587341308594,
        -2157.817626953125,
        643.0
      ],
      "bbox_max": [
        -310.626953125,
        -2156.81787109375,
        643.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4966428279876709,
        -0.8679550290107727,
        0.0
      ],
      "plane_d": -1717.750244140625,
      "bbox_min": [
        -311.92803955078125,
        -2157.562255859375,
        643.0
      ],
      "bbox_max": [
        -310.626953125,
        -2156.81787109375,
        643.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4966428279876709,
        -0.8679550290107727,
        0.0
      ],
      "plane_d": -1717.750244140625,
      "bbox_min": [
        -311.2054443359375,
        -2157.14892578125,
        643.9999389648438
      ],
      "bbox_max": [
        -310.626953125,
        -2156.81787109375,
        644.4998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499996542930603,
        -0.8660274147987366,
        0.0
      ],
      "plane_d": -1694.551025390625,
      "bbox_min": [
        -320.2043151855469,
        -2141.562744140625,
        643.9999389648438
      ],
      "bbox_max": [
        -319.626953125,
        -2141.2294921875,
        644.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000253915786743,
        0.8660107254981995,
        0.0
      ],
      "plane_d": 1694.5057373046875,
      "bbox_min": [
        -359.5959167480469,
        -2172.663330078125,
        641.6248779296875
      ],
      "bbox_max": [
        -303.297119140625,
        -2096.643798828125,
        658.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660250902175903,
        0.5000004768371582,
        -0.0
      ],
      "plane_d": 1358.4207763671875,
      "bbox_min": [
        -329.1533203125,
        -2172.663330078125,
        643.0
      ],
      "bbox_max": [
        -303.297119140625,
        -2141.2294921875,
        658.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5000253915786743,
        -0.8660107254981995,
        0.0
      ],
      "plane_d": -1713.0057373046875,
      "bbox_min": [
        -323.4356384277344,
        -2172.663330078125,
        643.0
      ],
      "bbox_max": [
        -315.4033203125,
        -2162.7509765625,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46015921235084534,
        -0.8878363966941833,
        0.0
      ],
      "plane_d": -1773.008056640625,
      "bbox_min": [
        -323.4356384277344,
        -2164.755126953125,
        643.0
      ],
      "bbox_max": [
        -320.769287109375,
        -2163.2509765625,
        657.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5854437947273254,
        -0.7921016216278076,
        -0.17271529138088226
      ],
      "plane_d": -1412.0927734375,
      "bbox_min": [
        -323.4356384277344,
        -2164.755126953125,
        643.0
      ],
      "bbox_max": [
        -320.769287109375,
        -2163.2509765625,
        657.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.0,
      "bbox_min": [
        -323.4356384277344,
        -2164.751220703125,
        643.0
      ],
      "bbox_max": [
        -320.769287109375,
        -2163.2509765625,
        643.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000253915786743,
        0.8660107254981995,
        0.0
      ],
      "plane_d": 1722.0057373046875,
      "bbox_min": [
        -323.3673400878906,
        -2172.663330078125,
        643.0
      ],
      "bbox_max": [
        -315.4033203125,
        -2162.7509765625,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5388208627700806,
        0.8424203395843506,
        0.0
      ],
      "plane_d": 1658.5201416015625,
      "bbox_min": [
        -318.8698425292969,
        -2172.663330078125,
        643.0
      ],
      "bbox_max": [
        -316.269287109375,
        -2171.045166015625,
        657.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932713568210602,
        0.9030541777610779,
        -0.17271600663661957
      ],
      "plane_d": 1949.8216552734375,
      "bbox_min": [
        -318.8698425292969,
        -2172.663330078125,
        643.0
      ],
      "bbox_max": [
        -316.269287109375,
        -2171.045166015625,
        657.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.0,
      "bbox_min": [
        -318.867431640625,
        -2172.663330078125,
        643.0
      ],
      "bbox_max": [
        -316.269287109375,
        -2171.045166015625,
        643.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.0,
      "bbox_min": [
        -323.3673400878906,
        -2172.545166015625,
        643.0
      ],
      "bbox_max": [
        -315.4033203125,
        -2162.7509765625,
        658.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4696516990661621,
        -0.27115491032600403,
        -0.8401799201965332
      ],
      "plane_d": -184.4716339111328,
      "bbox_min": [
        -323.36505126953125,
        -2172.541015625,
        655.9998168945312
      ],
      "bbox_max": [
        -315.4033203125,
        -2162.7509765625,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.8999633789062,
      "bbox_min": [
        -320.769287109375,
        -2171.045166015625,
        657.8999633789062
      ],
      "bbox_max": [
        -315.4033203125,
        -2162.7509765625,
        657.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5854437947273254,
        -0.7921016216278076,
        -0.17271529138088226
      ],
      "plane_d": -1412.0927734375,
      "bbox_min": [
        -323.36505126953125,
        -2172.541015625,
        655.9998168945312
      ],
      "bbox_max": [
        -316.269287109375,
        -2163.2509765625,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13052546977996826,
        -0.9914449453353882,
        0.0
      ],
      "plane_d": -2097.821533203125,
      "bbox_min": [
        -310.626953125,
        -2165.478271484375,
        644.4998168945312
      ],
      "bbox_max": [
        -303.297119140625,
        -2156.318359375,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914367198944092,
        -0.13058817386627197,
        -0.0
      ],
      "plane_d": -583.0892944335938,
      "bbox_min": [
        -303.4555969238281,
        -2162.442138671875,
        647.1517944335938
      ],
      "bbox_max": [
        -303.297119140625,
        -2161.239013671875,
        656.46435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.9999389648438,
      "bbox_min": [
        -329.1533203125,
        -2170.978271484375,
        643.0
      ],
      "bbox_max": [
        -307.35870361328125,
        -2141.562744140625,
        658.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.0,
      "bbox_min": [
        -320.1533203125,
        -2170.978271484375,
        643.0
      ],
      "bbox_max": [
        -307.35870361328125,
        -2157.14892578125,
        643.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49993693828582764,
        -0.8659241795539856,
        0.015438675880432129
      ],
      "plane_d": -1722.27392578125,
      "bbox_min": [
        -320.1533203125,
        -2162.31787109375,
        643.0
      ],
      "bbox_max": [
        -311.2054443359375,
        -2157.14892578125,
        643.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5023776888847351,
        -0.8646395802497864,
        -0.0038786001969128847
      ],
      "plane_d": -1706.2938232421875,
      "bbox_min": [
        -320.1533203125,
        -2162.31787109375,
        643.0
      ],
      "bbox_max": [
        -311.2054443359375,
        -2157.14892578125,
        643.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4966428279876709,
        -0.8679550290107727,
        0.0
      ],
      "plane_d": -1717.750244140625,
      "bbox_min": [
        -314.0910949707031,
        -2158.800048828125,
        643.3755493164062
      ],
      "bbox_max": [
        -311.2054443359375,
        -2157.14892578125,
        643.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999946355819702,
        0.8660184741020203,
        0.004163676407188177
      ],
      "plane_d": 1708.8509521484375,
      "bbox_min": [
        -320.6533203125,
        -2162.31787109375,
        643.9998779296875
      ],
      "bbox_max": [
        -310.626953125,
        -2155.951904296875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480128645896912,
        0.5299756526947021,
        0.0
      ],
      "plane_d": 1416.0614013671875,
      "bbox_min": [
        -320.6533203125,
        -2162.31787109375,
        643.9998779296875
      ],
      "bbox_max": [
        -310.626953125,
        -2156.81787109375,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5094318985939026,
        -0.8605110049247742,
        0.0
      ],
      "plane_d": -1697.60205078125,
      "bbox_min": [
        -320.6533203125,
        -2162.31787109375,
        643.9998779296875
      ],
      "bbox_max": [
        -318.9353332519531,
        -2160.800048828125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4735405147075653,
        0.880772054195404,
        0.0
      ],
      "plane_d": 1751.904052734375,
      "bbox_min": [
        -320.6533203125,
        -2161.604736328125,
        643.9998779296875
      ],
      "bbox_max": [
        -318.9408874511719,
        -2160.800048828125,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999484419822693,
        -0.8660244345664978,
        -0.0026099965907633305
      ],
      "plane_d": -1710.82275390625,
      "bbox_min": [
        -319.76287841796875,
        -2162.086669921875,
        653.9998779296875
      ],
      "bbox_max": [
        -318.9353332519531,
        -2161.60009765625,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4966428279876709,
        -0.8679550290107727,
        0.0
      ],
      "plane_d": -1717.750244140625,
      "bbox_min": [
        -319.4408874511719,
        -2161.60888671875,
        643.9998779296875
      ],
      "bbox_max": [
        -310.626953125,
        -2156.81787109375,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480128645896912,
        -0.5299756526947021,
        -0.0
      ],
      "plane_d": -1410.4647216796875,
      "bbox_min": [
        -319.4408874511719,
        -2161.58154296875,
        643.9998779296875
      ],
      "bbox_max": [
        -314.0910949707031,
        -2157.951904296875,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8614603877067566,
        -0.507818877696991,
        -0.002445030026137829
      ],
      "plane_d": -1365.2818603515625,
      "bbox_min": [
        -314.5910949707031,
        -2158.800048828125,
        643.9998779296875
      ],
      "bbox_max": [
        -314.0910949707031,
        -2157.951904296875,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.9998779296875,
      "bbox_min": [
        -319.4408874511719,
        -2161.58154296875,
        653.9998779296875
      ],
      "bbox_max": [
        -314.0910949707031,
        -2158.0,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.9998779296875,
      "bbox_min": [
        -318.9524230957031,
        -2161.60009765625,
        653.9998779296875
      ],
      "bbox_max": [
        -314.0910949707031,
        -2158.800048828125,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4735405147075653,
        0.880772054195404,
        0.0
      ],
      "plane_d": 1751.904052734375,
      "bbox_min": [
        -320.6533203125,
        -2161.451904296875,
        643.9999389648438
      ],
      "bbox_max": [
        -311.126953125,
        -2155.951904296875,
        657.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999755918979645,
        0.8659769892692566,
        -0.010404189117252827
      ],
      "plane_d": 1718.2947998046875,
      "bbox_min": [
        -320.6533203125,
        -2161.451904296875,
        653.9998779296875
      ],
      "bbox_max": [
        -311.126953125,
        -2155.951904296875,
        657.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.0,
      "bbox_min": [
        -359.5959167480469,
        -2147.2294921875,
        641.6248779296875
      ],
      "bbox_max": [
        -317.162841796875,
        -2096.643798828125,
        658.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5000009536743164,
        -0.8660248517990112,
        0.0
      ],
      "plane_d": -1692.5440673828125,
      "bbox_min": [
        -359.5959167480469,
        -2147.2294921875,
        641.6248779296875
      ],
      "bbox_max": [
        -318.760986328125,
        -2101.172119140625,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.2069091796875,
      "bbox_min": [
        -359.5959167480469,
        -2109.260009765625,
        641.6248779296875
      ],
      "bbox_max": [
        -355.40521240234375,
        -2101.172119140625,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.5959167480469,
        -2102.00146484375,
        641.6248779296875
      ],
      "bbox_max": [
        -359.34197998046875,
        -2101.172119140625,
        642.23876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660412430763245,
        0.49997252225875854,
        -0.0
      ],
      "plane_d": 1359.3660888671875,
      "bbox_min": [
        -331.019287109375,
        -2147.2294921875,
        645.0
      ],
      "bbox_max": [
        -318.760986328125,
        -2138.997314453125,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660412430763245,
        -0.49997252225875854,
        0.0
      ],
      "plane_d": -1346.3660888671875,
      "bbox_min": [
        -319.760986328125,
        -2140.7294921875,
        645.2499389648438
      ],
      "bbox_max": [
        -318.760986328125,
        -2138.997314453125,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5195968151092529,
        0.2999897599220276,
        0.8000158071517944
      ],
      "plane_d": 299.4135437011719,
      "bbox_min": [
        -356.51251220703125,
        -2147.2294921875,
        645.9999389648438
      ],
      "bbox_max": [
        -317.162841796875,
        -2096.643798828125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914408326148987,
        0.13055682182312012,
        0.0
      ],
      "plane_d": 625.8935546875,
      "bbox_min": [
        -356.1262512207031,
        -2114.912841796875,
        646.0
      ],
      "bbox_max": [
        -351.4681701660156,
        -2108.0078125,
        647.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.2069091796875,
      "bbox_min": [
        -356.1262512207031,
        -2108.482421875,
        646.0
      ],
      "bbox_max": [
        -355.507568359375,
        -2108.0078125,
        647.498291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -353.21807861328125,
        -2114.912841796875,
        646.9999389648438
      ],
      "bbox_max": [
        -351.4681701660156,
        -2111.714599609375,
        647.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -352.1414794921875,
        -2114.912841796875,
        646.9999389648438
      ],
      "bbox_max": [
        -351.4681701660156,
        -2114.745361328125,
        647.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000077486038208,
        -0.866020917892456,
        7.122488023014739e-05
      ],
      "plane_d": -1658.580322265625,
      "bbox_min": [
        -356.51251220703125,
        -2147.2294921875,
        645.9999389648438
      ],
      "bbox_max": [
        -317.162841796875,
        -2096.643798828125,
        658.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.8660277128219604,
        -0.49999600648880005,
        -0.0
      ],
      "plane_d": -1346.112060546875,
      "bbox_min": [
        -356.51251220703125,
        -2114.912841796875,
        645.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2096.643798828125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999851584434509,
        0.8660339713096619,
        0.0
      ],
      "plane_d": 1656.4691162109375,
      "bbox_min": [
        -356.51251220703125,
        -2114.912841796875,
        645.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2102.363525390625,
        658.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660597205162048,
        0.49994051456451416,
        -0.0
      ],
      "plane_d": 1355.3056640625,
      "bbox_min": [
        -345.604736328125,
        -2114.052490234375,
        645.9999389648438
      ],
      "bbox_max": [
        -339.35888671875,
        -2109.234130859375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.865980327129364,
        -0.5000780820846558,
        0.0
      ],
      "plane_d": -1349.5692138671875,
      "bbox_min": [
        -345.604736328125,
        -2114.052490234375,
        645.9999389648438
      ],
      "bbox_max": [
        -339.35888671875,
        -2109.234130859375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 655.9999389648438,
      "bbox_min": [
        -345.604736328125,
        -2114.052490234375,
        655.9999389648438
      ],
      "bbox_max": [
        -339.35888671875,
        -2109.234130859375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -356.51251220703125,
        -2114.912841796875,
        645.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2102.363525390625,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -356.51251220703125,
        -2114.745361328125,
        645.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2102.363525390625,
        649.5999145507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6542752981185913,
        0.7562564611434937,
        0.0
      ],
      "plane_d": 1821.1064453125,
      "bbox_min": [
        -353.3381652832031,
        -2105.2822265625,
        645.9999389648438
      ],
      "bbox_max": [
        -349.964599609375,
        -2102.363525390625,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914408326148987,
        0.13055682182312012,
        0.0
      ],
      "plane_d": 625.8935546875,
      "bbox_min": [
        -356.51251220703125,
        -2113.442138671875,
        646.9999389648438
      ],
      "bbox_max": [
        -352.9905700683594,
        -2105.3818359375,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5999145507812,
      "bbox_min": [
        -356.51251220703125,
        -2113.442138671875,
        646.9999389648438
      ],
      "bbox_max": [
        -352.9905700683594,
        -2105.3818359375,
        649.5999145507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6087977886199951,
        0.7933254241943359,
        0.0
      ],
      "plane_d": 1887.297119140625,
      "bbox_min": [
        -356.51251220703125,
        -2109.260009765625,
        646.9999389648438
      ],
      "bbox_max": [
        -353.775390625,
        -2105.3818359375,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476275444031,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -356.1250305175781,
        -2109.260009765625,
        647.27490234375
      ],
      "bbox_max": [
        -355.40521240234375,
        -2108.0087890625,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49991968274116516,
        0.8660717606544495,
        0.0
      ],
      "plane_d": 1692.67041015625,
      "bbox_min": [
        -319.760986328125,
        -2138.997314453125,
        646.0
      ],
      "bbox_max": [
        -317.162841796875,
        -2137.497314453125,
        658.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660412430763245,
        0.49997252225875854,
        -0.0
      ],
      "plane_d": 1359.3660888671875,
      "bbox_min": [
        -333.617431640625,
        -2147.2294921875,
        646.0
      ],
      "bbox_max": [
        -330.019287109375,
        -2145.497314453125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000253915786743,
        0.8660107254981995,
        0.0
      ],
      "plane_d": 1692.505615234375,
      "bbox_min": [
        -333.617431640625,
        -2146.997314453125,
        646.0
      ],
      "bbox_max": [
        -331.019287109375,
        -2145.497314453125,
        658.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8261845707893372,
        -0.47699832916259766,
        0.29981938004493713
      ],
      "plane_d": -1510.0537109375,
      "bbox_min": [
        -385.54241943359375,
        -2191.826416015625,
        641.6248779296875
      ],
      "bbox_max": [
        -328.615234375,
        -2122.329345703125,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49999865889549255,
        0.8660261631011963,
        -1.130802593252156e-05
      ],
      "plane_d": 1722.5550537109375,
      "bbox_min": [
        -339.9017028808594,
        -2182.380126953125,
        641.6248779296875
      ],
      "bbox_max": [
        -330.60235595703125,
        -2171.2373046875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000067353248596,
        -0.8660215139389038,
        0.0
      ],
      "plane_d": -1712.534912109375,
      "bbox_min": [
        -339.9017028808594,
        -2173.7197265625,
        641.6248779296875
      ],
      "bbox_max": [
        -335.6023864746094,
        -2171.2373046875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999828040599823,
        -0.8660353422164917,
        -2.6044453989015892e-06
      ],
      "plane_d": -1674.571533203125,
      "bbox_min": [
        -385.54241943359375,
        -2191.826416015625,
        641.6248779296875
      ],
      "bbox_max": [
        -335.32568359375,
        -2123.96044921875,
        665.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.4999973177909851,
        0.8660269379615784,
        0.0
      ],
      "plane_d": 1656.249755859375,
      "bbox_min": [
        -385.54241943359375,
        -2146.992919921875,
        641.6248779296875
      ],
      "bbox_max": [
        -362.217041015625,
        -2123.96044921875,
        658.3834838867188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660218715667725,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.6248779296875
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6018845438957214,
        0.3474956154823303,
        -0.7190144658088684
      ],
      "plane_d": 1439.971923828125,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.6248779296875
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6018845438957214,
        -0.3474956154823303,
        -0.7190144658088684
      ],
      "plane_d": -492.55126953125,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.6248779296875
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25884971022605896,
        0.9659175872802734,
        0.0
      ],
      "plane_d": 2170.00927734375,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.6248779296875
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659175872802734,
        0.2588496804237366,
        0.0
      ],
      "plane_d": 203.87515258789062,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.6248779296875
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49997738003730774,
        0.86603844165802,
        0.0
      ],
      "plane_d": 1673.581787109375,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.6248779296875
      ],
      "bbox_max": [
        -362.94921875,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8608181476593018,
        0.4970272481441498,
        -0.10934361815452576
      ],
      "plane_d": 1455.202880859375,
      "bbox_min": [
        -369.9045715332031,
        -2146.87451171875,
        641.6248779296875
      ],
      "bbox_max": [
        -364.3221740722656,
        -2143.07421875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8617133498191833,
        -0.49754413962364197,
        -0.09949871897697449
      ],
      "plane_d": -1316.8052978515625,
      "bbox_min": [
        -369.011474609375,
        -2146.35888671875,
        641.6248779296875
      ],
      "bbox_max": [
        -364.3221740722656,
        -2143.07421875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -369.011474609375,
        -2146.35888671875,
        651.0
      ],
      "bbox_max": [
        -365.134033203125,
        -2143.54296875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997738003730774,
        -0.86603844165802,
        0.0
      ],
      "plane_d": -1658.581787109375,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        641.6248779296875
      ],
      "bbox_max": [
        -367.717041015625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.86605304479599,
        0.49995216727256775,
        0.0
      ],
      "plane_d": 1393.328125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        641.6248779296875
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        649.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86605304479599,
        -0.49995216727256775,
        -0.0
      ],
      "plane_d": -1387.3282470703125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        641.6248779296875
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        649.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.9999389648438,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        649.9999389648438
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        649.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25884971022605896,
        -0.9659175872802734,
        -0.0
      ],
      "plane_d": -2152.33154296875,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        641.6248779296875
      ],
      "bbox_max": [
        -367.717041015625,
        -2129.00244140625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659175872802734,
        -0.2588496804237366,
        0.0
      ],
      "plane_d": -186.1974334716797,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        641.6248779296875
      ],
      "bbox_max": [
        -379.109375,
        -2134.00244140625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999884068965912,
        0.8660321235656738,
        2.6311850888305344e-05
      ],
      "plane_d": 1701.547119140625,
      "bbox_min": [
        -370.263671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2147.406494140625,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4999884068965912,
        0.8660321235656738,
        2.6311850888305344e-05
      ],
      "plane_d": 1722.547119140625,
      "bbox_min": [
        -360.263671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2164.72705078125,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1723.5611572265625,
      "bbox_min": [
        -349.763671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2182.91357421875,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -349.763671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2182.91357421875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -349.763671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2182.91357421875,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7588072419166565,
        -0.4381272494792938,
        -0.4819295108318329
      ],
      "plane_d": -900.0076904296875,
      "bbox_min": [
        -345.810546875,
        -2189.544189453125,
        654.0
      ],
      "bbox_max": [
        -339.248291015625,
        -2185.17822265625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745586633682251,
        0.44722193479537964,
        -0.44727107882499695
      ],
      "plane_d": 1539.1907958984375,
      "bbox_min": [
        -345.810546875,
        -2189.544189453125,
        654.0
      ],
      "bbox_max": [
        -344.4443359375,
        -2188.17822265625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1702.5611572265625,
      "bbox_min": [
        -360.263671875,
        -2173.639892578125,
        654.0
      ],
      "bbox_max": [
        -345.82568359375,
        -2164.72705078125,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -360.263671875,
        -2173.639892578125,
        654.0
      ],
      "bbox_max": [
        -345.82568359375,
        -2164.72705078125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -360.263671875,
        -2173.639892578125,
        654.0
      ],
      "bbox_max": [
        -345.82568359375,
        -2164.72705078125,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7588072419166565,
        -0.4381272494792938,
        -0.4819295108318329
      ],
      "plane_d": -900.0071411132812,
      "bbox_min": [
        -356.310546875,
        -2171.357666015625,
        654.0
      ],
      "bbox_max": [
        -349.748291015625,
        -2166.99169921875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745586633682251,
        0.44722193479537964,
        -0.44727107882499695
      ],
      "plane_d": 1539.190185546875,
      "bbox_min": [
        -356.310546875,
        -2171.357666015625,
        654.0
      ],
      "bbox_max": [
        -354.9443359375,
        -2169.99169921875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999884068965912,
        0.8660321235656738,
        2.6311850888305344e-05
      ],
      "plane_d": 1681.547119140625,
      "bbox_min": [
        -370.263671875,
        -2156.319580078125,
        654.0
      ],
      "bbox_max": [
        -355.82568359375,
        -2147.406494140625,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1682.5611572265625,
      "bbox_min": [
        -370.263671875,
        -2156.319580078125,
        654.0
      ],
      "bbox_max": [
        -355.82568359375,
        -2147.406494140625,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -370.263671875,
        -2156.319580078125,
        654.0
      ],
      "bbox_max": [
        -355.82568359375,
        -2147.406494140625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -370.263671875,
        -2156.319580078125,
        654.0
      ],
      "bbox_max": [
        -355.82568359375,
        -2147.406494140625,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7588072419166565,
        -0.4381272494792938,
        -0.4819295108318329
      ],
      "plane_d": -900.006591796875,
      "bbox_min": [
        -366.310546875,
        -2154.037109375,
        654.0
      ],
      "bbox_max": [
        -359.748291015625,
        -2149.671142578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745586633682251,
        0.44722193479537964,
        -0.44727107882499695
      ],
      "plane_d": 1539.189697265625,
      "bbox_min": [
        -366.310546875,
        -2154.037109375,
        654.0
      ],
      "bbox_max": [
        -364.9443359375,
        -2152.671142578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -478.2337646484375,
        -2180.35791015625,
        641.6248779296875
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -431.2630920410156,
        -2180.35791015625,
        641.6248779296875
      ],
      "bbox_max": [
        -302.4421081542969,
        -2067.486572265625,
        686.3023681640625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660277128219604,
        -0.49999600648880005,
        -0.0
      ],
      "plane_d": -1346.112060546875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -337.551025390625,
        -2095.707763671875,
        659.7164306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999973177909851,
        0.8660269379615784,
        0.0
      ],
      "plane_d": 1656.249755859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -337.551025390625,
        -2095.707763671875,
        659.7164306640625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4999948740005493,
        0.866028368473053,
        -1.664797127887141e-05
      ],
      "plane_d": 1656.46484375,
      "bbox_min": [
        -349.5128479003906,
        -2114.259033203125,
        658.9005126953125
      ],
      "bbox_max": [
        -337.551025390625,
        -2107.583984375,
        659.7164306640625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -349.5128479003906,
        -2114.259033203125,
        658.9005126953125
      ],
      "bbox_max": [
        -348.809326171875,
        -2114.083984375,
        659.6209716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.608748733997345,
        0.793363094329834,
        0.0
      ],
      "plane_d": 1940.9437255859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -343.8673400878906,
        -2095.707763671875,
        659.4156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.793363094329834,
        0.608748733997345,
        0.0
      ],
      "plane_d": 1005.81884765625,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -343.8673400878906,
        -2095.707763671875,
        659.4156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -354.70849609375,
        -2115.07080078125,
        656.31787109375
      ],
      "bbox_max": [
        -349.5128479003906,
        -2113.71142578125,
        659.4156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.1998901367188,
      "bbox_min": [
        -354.70849609375,
        -2115.07080078125,
        656.31787109375
      ],
      "bbox_max": [
        -352.776123046875,
        -2113.71142578125,
        658.4631958007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914408326148987,
        0.13055682182312012,
        0.0
      ],
      "plane_d": 625.8935546875,
      "bbox_min": [
        -352.95513916015625,
        -2115.07080078125,
        657.1998901367188
      ],
      "bbox_max": [
        -352.776123046875,
        -2113.71142578125,
        658.4631958007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883978605270386,
        0.9659202694892883,
        -0.0
      ],
      "plane_d": 2134.30224609375,
      "bbox_min": [
        -354.70849609375,
        -2114.8515625,
        656.31787109375
      ],
      "bbox_max": [
        -353.5945129394531,
        -2114.552978515625,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1305050551891327,
        0.9914476275444031,
        0.0
      ],
      "plane_d": 2069.815185546875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -343.8673400878906,
        -2095.707763671875,
        659.0468139648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2136.482421875,
        641.6248779296875
      ],
      "bbox_max": [
        -343.8673400878906,
        -2095.707763671875,
        650.9864501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476275444031,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -404.803955078125,
        -2136.482421875,
        641.6248779296875
      ],
      "bbox_max": [
        -343.8673400878906,
        -2095.707763671875,
        650.9864501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.9999389648438,
      "bbox_min": [
        -404.803955078125,
        -2130.411865234375,
        641.6248779296875
      ],
      "bbox_max": [
        -343.8673400878906,
        -2095.707763671875,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476275444031,
        0.0
      ],
      "plane_d": -2039.7249755859375,
      "bbox_min": [
        -404.803955078125,
        -2130.411865234375,
        641.6248779296875
      ],
      "bbox_max": [
        -358.68206787109375,
        -2099.0166015625,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058817386627197,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -366.7017822265625,
        -2103.7255859375,
        641.6248779296875
      ],
      "bbox_max": [
        -358.68206787109375,
        -2099.0166015625,
        644.3175659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -358.68206787109375,
        -2099.0166015625,
        644.3175659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254074692726135,
        -0.17237462103366852
      ],
      "plane_d": -1249.18896484375,
      "bbox_min": [
        -392.01971435546875,
        -2119.8916015625,
        641.6248779296875
      ],
      "bbox_max": [
        -375.3421936035156,
        -2109.279296875,
        643.25927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491909503936768,
        0.490313857793808,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.01971435546875,
        -2119.8916015625,
        641.6248779296875
      ],
      "bbox_max": [
        -391.0085754394531,
        -2118.591552734375,
        643.128662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.608748733997345,
        0.0
      ],
      "plane_d": -975.72900390625,
      "bbox_min": [
        -404.803955078125,
        -2130.411865234375,
        641.6248779296875
      ],
      "bbox_max": [
        -359.0142822265625,
        -2104.755126953125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.2069091796875,
      "bbox_min": [
        -360.365234375,
        -2105.791748046875,
        644.3176879882812
      ],
      "bbox_max": [
        -359.0142822265625,
        -2104.755126953125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.2069091796875,
      "bbox_min": [
        -360.1273193359375,
        -2108.010009765625,
        645.9999389648438
      ],
      "bbox_max": [
        -352.588623046875,
        -2101.522216796875,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -357.5514831542969,
        -2108.010009765625,
        645.9999389648438
      ],
      "bbox_max": [
        -352.588623046875,
        -2101.522216796875,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6542752981185913,
        0.7562564611434937,
        0.0
      ],
      "plane_d": 1821.1064453125,
      "bbox_min": [
        -354.310546875,
        -2103.011962890625,
        645.9999389648438
      ],
      "bbox_max": [
        -352.588623046875,
        -2101.522216796875,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087977886199951,
        0.7933254241943359,
        0.0
      ],
      "plane_d": 1887.297119140625,
      "bbox_min": [
        -357.5514831542969,
        -2108.010009765625,
        646.9999389648438
      ],
      "bbox_max": [
        -354.4248046875,
        -2104.58447265625,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5999145507812,
      "bbox_min": [
        -357.0459289550781,
        -2108.010009765625,
        649.5999145507812
      ],
      "bbox_max": [
        -354.4248046875,
        -2106.292236328125,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -302.4421081542969,
        -2067.486572265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2591370642185211,
        0.32625335454940796,
        0.9090691208839417
      ],
      "plane_d": 8.32012939453125,
      "bbox_min": [
        -349.3767395019531,
        -2090.324462890625,
        641.6876831054688
      ],
      "bbox_max": [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -349.3767395019531,
        -2089.772705078125,
        641.6876831054688
      ],
      "bbox_max": [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -342.9916687011719,
        -2084.468994140625,
        642.1755981445312
      ],
      "bbox_max": [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 663.9999389648438,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -337.551025390625,
        -2087.100830078125,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8737850189208984,
        -0.4863123297691345,
        -0.0
      ],
      "plane_d": -1334.172607421875,
      "bbox_min": [
        -350.3255920410156,
        -2125.356689453125,
        663.9999389648438
      ],
      "bbox_max": [
        -344.0039978027344,
        -2113.50048828125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -350.0992126464844,
        -2114.40478515625,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2113.50048828125,
        664.5289916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914957880973816,
        -0.13013863563537598,
        -0.0
      ],
      "plane_d": -620.9669799804688,
      "bbox_min": [
        -348.8858947753906,
        -2114.083984375,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2113.50048828125,
        664.5289916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -350.3255920410156,
        -2114.461181640625,
        663.9999389648438
      ],
      "bbox_max": [
        -350.0992126464844,
        -2114.40478515625,
        664.0789184570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999973177909851,
        0.8660269379615784,
        0.0
      ],
      "plane_d": 1656.249755859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -337.551025390625,
        -2087.100830078125,
        663.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4999948740005493,
        0.866028368473053,
        -1.664797127887141e-05
      ],
      "plane_d": 1656.46484375,
      "bbox_min": [
        -349.5128479003906,
        -2114.259033203125,
        659.4156494140625
      ],
      "bbox_max": [
        -337.551025390625,
        -2107.583984375,
        663.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -349.5128479003906,
        -2114.259033203125,
        659.4156494140625
      ],
      "bbox_max": [
        -348.809326171875,
        -2114.083984375,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3123513460159302,
        0.5410122871398926,
        -0.7808600068092346
      ],
      "plane_d": 1550.036865234375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -344.4078063964844,
        -2087.100830078125,
        663.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -352.967529296875,
        -2115.07080078125,
        660.0
      ],
      "bbox_max": [
        -349.51275634765625,
        -2113.6171875,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -344.4078063964844,
        -2087.100830078125,
        661.8264770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -344.4078063964844,
        -2087.100830078125,
        661.8264770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.608748733997345,
        0.0
      ],
      "plane_d": -975.72900390625,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -344.4078063964844,
        -2091.995361328125,
        661.8264770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1305050551891327,
        0.9914476275444031,
        0.0
      ],
      "plane_d": 2069.815185546875,
      "bbox_min": [
        -401.07666015625,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -344.4078063964844,
        -2091.995361328125,
        661.8264770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6542752981185913,
        0.7562564611434937,
        0.0
      ],
      "plane_d": 1821.1064453125,
      "bbox_min": [
        -401.07666015625,
        -2139.71044921875,
        641.6248779296875
      ],
      "bbox_max": [
        -344.4078063964844,
        -2091.995361328125,
        661.8264770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058817386627197,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -401.07666015625,
        -2139.71044921875,
        641.6248779296875
      ],
      "bbox_max": [
        -349.5128479003906,
        -2098.790771484375,
        661.8264770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        9.911101187753957e-06
      ],
      "plane_d": -1640.2421875,
      "bbox_min": [
        -401.07666015625,
        -2139.71044921875,
        641.6248779296875
      ],
      "bbox_max": [
        -349.5128479003906,
        -2102.01806640625,
        661.8264770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254074692726135,
        -0.17237462103366852
      ],
      "plane_d": -1249.18896484375,
      "bbox_min": [
        -392.2690734863281,
        -2119.7412109375,
        641.6248779296875
      ],
      "bbox_max": [
        -375.58990478515625,
        -2108.96435546875,
        646.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914408326148987,
        0.13055682182312012,
        0.0
      ],
      "plane_d": 625.8935546875,
      "bbox_min": [
        -395.3540954589844,
        -2139.71044921875,
        643.3367919921875
      ],
      "bbox_max": [
        -349.5128479003906,
        -2103.208984375,
        661.8264770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49564361572265625,
        0.3802885115146637,
        -0.7808444499969482
      ],
      "plane_d": 1143.6883544921875,
      "bbox_min": [
        -395.3540954589844,
        -2139.71044921875,
        643.3367919921875
      ],
      "bbox_max": [
        -352.95513916015625,
        -2103.208984375,
        661.5947265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476275444031,
        0.0
      ],
      "plane_d": -2039.7249755859375,
      "bbox_min": [
        -395.3540954589844,
        -2139.71044921875,
        643.3367919921875
      ],
      "bbox_max": [
        -352.95513916015625,
        -2103.208984375,
        660.8111572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5999145507812,
      "bbox_min": [
        -360.365234375,
        -2104.755126953125,
        649.5999145507812
      ],
      "bbox_max": [
        -357.77392578125,
        -2103.208984375,
        650.3209838867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659202694892883,
        -0.25883978605270386,
        0.0
      ],
      "plane_d": -196.7102813720703,
      "bbox_min": [
        -360.365234375,
        -2104.755126953125,
        649.5999145507812
      ],
      "bbox_max": [
        -360.0830078125,
        -2103.701904296875,
        650.3209838867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5999145507812,
      "bbox_min": [
        -395.3540954589844,
        -2139.71044921875,
        645.7219848632812
      ],
      "bbox_max": [
        -352.95513916015625,
        -2104.4140625,
        660.8111572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.2069091796875,
      "bbox_min": [
        -360.365234375,
        -2107.302001953125,
        645.7219848632812
      ],
      "bbox_max": [
        -357.0459289550781,
        -2104.755126953125,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476275444031,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -395.3540954589844,
        -2139.71044921875,
        657.037841796875
      ],
      "bbox_max": [
        -352.95513916015625,
        -2108.516845703125,
        660.8111572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.1998901367188,
      "bbox_min": [
        -355.3525390625,
        -2114.61181640625,
        657.037841796875
      ],
      "bbox_max": [
        -352.95513916015625,
        -2108.516845703125,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883978605270386,
        0.9659202694892883,
        -0.0
      ],
      "plane_d": 2134.30224609375,
      "bbox_min": [
        -354.70849609375,
        -2114.61181640625,
        657.037841796875
      ],
      "bbox_max": [
        -354.4888610839844,
        -2114.552978515625,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.793363094329834,
        0.608748733997345,
        0.0
      ],
      "plane_d": 1005.81884765625,
      "bbox_min": [
        -395.3540954589844,
        -2139.71044921875,
        657.0379028320312
      ],
      "bbox_max": [
        -354.70849609375,
        -2112.746826171875,
        660.8111572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08152862638235092,
        0.6193733811378479,
        -0.7808519005775452
      ],
      "plane_d": 1808.4091796875,
      "bbox_min": [
        -395.3540954589844,
        -2139.71044921875,
        659.9998168945312
      ],
      "bbox_max": [
        -354.70849609375,
        -2112.746826171875,
        660.8111572265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6193848848342896,
        -0.0815301313996315,
        -0.7808426022529602
      ],
      "plane_d": 123.25511169433594,
      "bbox_min": [
        -355.7687683105469,
        -2114.552978515625,
        659.9998168945312
      ],
      "bbox_max": [
        -354.70849609375,
        -2112.746826171875,
        660.8111572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -352.776123046875,
        -2115.07080078125,
        658.463134765625
      ],
      "bbox_max": [
        -349.5128479003906,
        -2114.259033203125,
        660.742919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -359.847412109375,
        -2104.58447265625,
        646.9999389648438
      ],
      "bbox_max": [
        -353.51226806640625,
        -2102.01806640625,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        646.9999389648438
      ],
      "bbox_max": [
        -353.7374572753906,
        -2098.81787109375,
        648.9979248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9046844840049744,
        -0.42608213424682617,
        0.0
      ],
      "plane_d": -570.4268188476562,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        646.9999389648438
      ],
      "bbox_max": [
        -358.2016906738281,
        -2099.328369140625,
        648.9979248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263527512550354,
        0.5366376042366028,
        0.7570752501487732
      ],
      "plane_d": 506.02935791015625,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        641.6248779296875
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        646.4585571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753774404525757,
        -0.22054219245910645,
        -0.0
      ],
      "plane_d": -812.7610473632812,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        642.8890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753774404525757,
        -0.22054219245910645,
        -0.0
      ],
      "plane_d": -812.7610473632812,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        642.72119140625
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        646.4585571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000009536743164,
        -0.8660248517990112,
        0.0
      ],
      "plane_d": -1638.444091796875,
      "bbox_min": [
        -357.809326171875,
        -2101.522216796875,
        645.9999389648438
      ],
      "bbox_max": [
        -344.4078063964844,
        -2091.995361328125,
        647.3677978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.9999389648438,
      "bbox_min": [
        -357.809326171875,
        -2101.522216796875,
        645.9999389648438
      ],
      "bbox_max": [
        -344.4078063964844,
        -2091.995361328125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753774404525757,
        -0.22054219245910645,
        -0.0
      ],
      "plane_d": -812.7610473632812,
      "bbox_min": [
        -371.9428405761719,
        -2106.424560546875,
        641.6248779296875
      ],
      "bbox_max": [
        -347.51568603515625,
        -2087.100830078125,
        646.2623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -350.6198425292969,
        -2090.284423828125,
        641.6248779296875
      ],
      "bbox_max": [
        -347.8341979980469,
        -2087.100830078125,
        641.714599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263527512550354,
        0.5366376042366028,
        0.7570752501487732
      ],
      "plane_d": 506.02935791015625,
      "bbox_min": [
        -371.9428405761719,
        -2106.424560546875,
        641.6248779296875
      ],
      "bbox_max": [
        -358.7217712402344,
        -2097.4541015625,
        642.7212524414062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 664.0,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 665.9999389648438,
      "bbox_min": [
        -359.7845153808594,
        -2121.33203125,
        663.9998779296875
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8737850189208984,
        -0.4863123297691345,
        -0.0
      ],
      "plane_d": -1334.172607421875,
      "bbox_min": [
        -355.8055419921875,
        -2121.33203125,
        667.9999389648438
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -99.88211059570312,
        -1968.9686279296875,
        711.7363891601562
      ],
      "bbox_max": [
        -99.46600341796875,
        -1968.8143310546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914957880973816,
        -0.13013863563537598,
        -0.0
      ],
      "plane_d": -620.9669799804688,
      "bbox_min": [
        -359.7845153808594,
        -2115.07080078125,
        663.9998779296875
      ],
      "bbox_max": [
        -348.809326171875,
        -2099.954833984375,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6542752981185913,
        -0.7562564611434937,
        -0.0
      ],
      "plane_d": -1821.1064453125,
      "bbox_min": [
        -359.7845153808594,
        -2115.07080078125,
        663.9998779296875
      ],
      "bbox_max": [
        -348.809326171875,
        -2099.954833984375,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914408326148987,
        0.13055682182312012,
        0.0
      ],
      "plane_d": 625.8935546875,
      "bbox_min": [
        -359.7845153808594,
        -2115.07080078125,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2102.87109375,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087977886199951,
        0.7933254241943359,
        0.0
      ],
      "plane_d": 1887.297119140625,
      "bbox_min": [
        -359.7845153808594,
        -2107.482421875,
        663.9999389648438
      ],
      "bbox_max": [
        -353.775390625,
        -2102.87109375,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -352.776123046875,
        -2115.07080078125,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2114.083984375,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277128219604,
        -0.49999600648880005,
        -0.0
      ],
      "plane_d": -1346.112060546875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -318.8418884277344,
        -2069.56640625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -356.1893310546875,
        -2087.100830078125,
        641.714599609375
      ],
      "bbox_max": [
        -318.8418884277344,
        -2069.56640625,
        644.083251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -353.031982421875,
        -2087.100830078125,
        641.714599609375
      ],
      "bbox_max": [
        -342.9916687011719,
        -2080.769775390625,
        642.1755981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058817386627197,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -346.551025390625,
        -2075.301025390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660229444503784,
        5.422088634077227e-06
      ],
      "plane_d": 1638.2352294921875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        643.0118408203125
      ],
      "bbox_max": [
        -350.3255920410156,
        -2102.82275390625,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        9.911101187753957e-06
      ],
      "plane_d": -1640.2421875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        643.0118408203125
      ],
      "bbox_max": [
        -350.3255920410156,
        -2102.82275390625,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 655.9999389648438,
      "bbox_min": [
        -405.2591857910156,
        -2127.96923828125,
        643.0118408203125
      ],
      "bbox_max": [
        -376.1389465332031,
        -2109.251220703125,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491909503936768,
        0.490313857793808,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -405.2591857910156,
        -2127.96923828125,
        643.0118408203125
      ],
      "bbox_max": [
        -376.1389465332031,
        -2109.251220703125,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -405.2591857910156,
        -2127.96923828125,
        643.0118408203125
      ],
      "bbox_max": [
        -402.07666015625,
        -2123.822265625,
        654.0087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254074692726135,
        -0.17237462103366852
      ],
      "plane_d": -1249.18896484375,
      "bbox_min": [
        -378.520751953125,
        -2111.9541015625,
        644.9041137695312
      ],
      "bbox_max": [
        -376.1389465332031,
        -2109.251220703125,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3123541474342346,
        0.5410076975822449,
        -0.780862033367157
      ],
      "plane_d": 1550.02734375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        644.6990356445312
      ],
      "bbox_max": [
        -350.3255920410156,
        -2102.82275390625,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9914408326148987,
        0.13055682182312012,
        -0.0
      ],
      "plane_d": 625.8935546875,
      "bbox_min": [
        -353.3514709472656,
        -2115.07080078125,
        661.8263549804688
      ],
      "bbox_max": [
        -350.3255920410156,
        -2110.70166015625,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112091064453,
        0.9704229235649109,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -352.776123046875,
        -2115.07080078125,
        663.1448974609375
      ],
      "bbox_max": [
        -350.3255920410156,
        -2114.461181640625,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.608748733997345,
        0.0
      ],
      "plane_d": -975.72900390625,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        644.6990356445312
      ],
      "bbox_max": [
        -352.967529296875,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        644.6990356445312
      ],
      "bbox_max": [
        -405.25897216796875,
        -2127.968994140625,
        654.6817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476275444031,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        646.9889526367188
      ],
      "bbox_max": [
        -352.967529296875,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.608748733997345,
        0.793363094329834,
        0.0
      ],
      "plane_d": 1940.9437255859375,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        647.6097412109375
      ],
      "bbox_max": [
        -352.967529296875,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3123505115509033,
        -0.5410104990005493,
        -0.7808616161346436
      ],
      "plane_d": -509.30194091796875,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        647.6097412109375
      ],
      "bbox_max": [
        -352.967529296875,
        -2102.82275390625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6087977886199951,
        0.7933254241943359,
        0.0
      ],
      "plane_d": 1887.297119140625,
      "bbox_min": [
        -359.847412109375,
        -2105.505615234375,
        660.7428588867188
      ],
      "bbox_max": [
        -356.35150146484375,
        -2102.82275390625,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3802962005138397,
        0.4956280589103699,
        -0.7808505892753601
      ],
      "plane_d": 1727.9034423828125,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        647.6097412109375
      ],
      "bbox_max": [
        -352.967529296875,
        -2102.82275390625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6087977886199951,
        0.7933254241943359,
        0.0
      ],
      "plane_d": 1887.297119140625,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        647.6097412109375
      ],
      "bbox_max": [
        -352.967529296875,
        -2102.82275390625,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476275444031,
        0.0
      ],
      "plane_d": -2039.7249755859375,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        647.6097412109375
      ],
      "bbox_max": [
        -352.967529296875,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659202694892883,
        -0.25883978605270386,
        0.0
      ],
      "plane_d": -196.7102813720703,
      "bbox_min": [
        -360.365234375,
        -2104.755126953125,
        649.5999145507812
      ],
      "bbox_max": [
        -357.77386474609375,
        -2102.82275390625,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.1998901367188,
      "bbox_min": [
        -360.365234375,
        -2104.755126953125,
        649.5999145507812
      ],
      "bbox_max": [
        -357.77386474609375,
        -2102.82275390625,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5999145507812,
      "bbox_min": [
        -360.0830078125,
        -2103.701904296875,
        649.5999145507812
      ],
      "bbox_max": [
        -359.34417724609375,
        -2102.82275390625,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08152862638235092,
        0.6193733811378479,
        -0.7808519005775452
      ],
      "plane_d": 1808.4091796875,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -352.967529296875,
        -2104.4140625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.1998901367188,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -352.967529296875,
        -2104.4140625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9914408326148987,
        0.13055682182312012,
        -0.0
      ],
      "plane_d": 625.8935546875,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -352.967529296875,
        -2104.755126953125,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.08151418715715408,
        -0.6193829774856567,
        -0.7808457612991333
      ],
      "plane_d": -758.9165649414062,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -354.94622802734375,
        -2104.755126953125,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3803032636642456,
        -0.49563726782798767,
        -0.7808412909507751
      ],
      "plane_d": -664.8880615234375,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -354.94622802734375,
        -2104.755126953125,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6193848848342896,
        -0.0815301313996315,
        -0.7808426022529602
      ],
      "plane_d": 123.25511169433594,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -354.94622802734375,
        -2104.755126953125,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.2069091796875,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -354.94622802734375,
        -2104.755126953125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49564361572265625,
        0.3802885115146637,
        -0.7808444499969482
      ],
      "plane_d": 1143.6883544921875,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -354.94622802734375,
        -2108.482421875,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6193183660507202,
        0.08161082118749619,
        -0.7808869481086731
      ],
      "plane_d": 939.9530639648438,
      "bbox_min": [
        -404.3441467285156,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -354.94622802734375,
        -2108.482421875,
        663.3273315429688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9914476275444031,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -354.94622802734375,
        -2108.482421875,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1305050551891327,
        0.9914476275444031,
        0.0
      ],
      "plane_d": 2069.815185546875,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        658.3058471679688
      ],
      "bbox_max": [
        -395.3541259765625,
        -2139.71044921875,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000009536743164,
        -0.8660248517990112,
        0.0
      ],
      "plane_d": -1638.444091796875,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -346.551025390625,
        -2075.301025390625,
        663.9115600585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6863763332366943,
        -0.7272465229034424,
        -0.0
      ],
      "plane_d": -1759.2607421875,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -346.551025390625,
        -2075.301025390625,
        663.6964721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -358.5946044921875,
        -2087.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -349.3767395019531,
        -2075.301025390625,
        641.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -358.5946044921875,
        -2080.769775390625,
        641.6248779296875
      ],
      "bbox_max": [
        -353.031982421875,
        -2075.301025390625,
        641.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563422560691833,
        0.5164087414741516,
        0.0
      ],
      "plane_d": 771.662353515625,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.585205078125,
        661.4803466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753774404525757,
        -0.22054219245910645,
        -0.0
      ],
      "plane_d": -812.7610473632812,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -346.551025390625,
        -2087.43603515625,
        661.4803466796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.97299724817276,
        -0.23081716895103455,
        0.0
      ],
      "plane_d": -832.5162353515625,
      "bbox_min": [
        -360.0203857421875,
        -2098.995361328125,
        650.9999389648438
      ],
      "bbox_max": [
        -351.3818359375,
        -2087.43603515625,
        661.4803466796875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.002856867853552103,
        -0.9999959468841553,
        0.0
      ],
      "plane_d": -2086.423828125,
      "bbox_min": [
        -359.342529296875,
        -2092.0322265625,
        650.9999389648438
      ],
      "bbox_max": [
        -351.3818359375,
        -2087.43603515625,
        656.1393432617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8645933270454407,
        -0.5024722814559937,
        0.0
      ],
      "plane_d": -740.5030517578125,
      "bbox_min": [
        -359.342529296875,
        -2092.0322265625,
        650.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        654.572509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -654.9999389648438,
      "bbox_min": [
        -360.0203857421875,
        -2098.995361328125,
        654.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2092.43212890625,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 659.9999389648438,
      "bbox_min": [
        -358.9546813964844,
        -2098.995361328125,
        659.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2097.1103515625,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        646.4585571289062
      ],
      "bbox_max": [
        -357.4365234375,
        -2098.495361328125,
        663.9115600585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9046844840049744,
        -0.42608213424682617,
        0.0
      ],
      "plane_d": -570.4268188476562,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        646.5236206054688
      ],
      "bbox_max": [
        -357.4365234375,
        -2098.495361328125,
        663.9114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -358.2016906738281,
        -2099.328369140625,
        646.5236206054688
      ],
      "bbox_max": [
        -357.4365234375,
        -2098.495361328125,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6542752981185913,
        0.7562564611434937,
        0.0
      ],
      "plane_d": 1821.1064453125,
      "bbox_min": [
        -357.809326171875,
        -2098.81787109375,
        646.5236206054688
      ],
      "bbox_max": [
        -357.4365234375,
        -2098.495361328125,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -462.7181701660156,
        -2134.2314453125,
        641.6248779296875
      ],
      "bbox_max": [
        -275.0,
        -1983.2685546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2134.2314453125,
        641.6248779296875
      ],
      "bbox_max": [
        -275.0,
        -1983.2685546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.8660248517990112,
        4.537152562988922e-06
      ],
      "plane_d": 1638.2410888671875,
      "bbox_min": [
        -404.803955078125,
        -2134.2314453125,
        641.6248779296875
      ],
      "bbox_max": [
        -275.0,
        -1983.2685546875,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3123505115509033,
        -0.5410104990005493,
        -0.7808616161346436
      ],
      "plane_d": -509.30194091796875,
      "bbox_min": [
        -404.803955078125,
        -2134.2314453125,
        654.8319702148438
      ],
      "bbox_max": [
        -346.4175109863281,
        -2091.85205078125,
        671.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -367.435791015625,
        -2107.235107421875,
        659.3778076171875
      ],
      "bbox_max": [
        -346.4175109863281,
        -2091.85205078125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 663.9999389648438,
      "bbox_min": [
        -359.847412109375,
        -2107.235107421875,
        661.26318359375
      ],
      "bbox_max": [
        -346.4175109863281,
        -2091.85205078125,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.141818979202071e-06,
        -1.2624659575521946e-05,
        -1.0
      ],
      "plane_d": 665.9722900390625,
      "bbox_min": [
        -359.847412109375,
        -2107.235107421875,
        663.9998779296875
      ],
      "bbox_max": [
        -354.08966064453125,
        -2098.495361328125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850189208984,
        -0.4863123297691345,
        -0.0
      ],
      "plane_d": -1334.172607421875,
      "bbox_min": [
        -358.675537109375,
        -2107.235107421875,
        667.9999389648438
      ],
      "bbox_max": [
        -354.08966064453125,
        -2098.995361328125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9046844840049744,
        -0.42608213424682617,
        0.0
      ],
      "plane_d": -570.4268188476562,
      "bbox_min": [
        -359.847412109375,
        -2103.962890625,
        663.9998779296875
      ],
      "bbox_max": [
        -354.783447265625,
        -2098.495361328125,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6542752981185913,
        -0.7562564611434937,
        -0.0
      ],
      "plane_d": -1821.1064453125,
      "bbox_min": [
        -359.847412109375,
        -2103.962890625,
        663.9998779296875
      ],
      "bbox_max": [
        -354.783447265625,
        -2098.495361328125,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087977886199951,
        0.7933254241943359,
        0.0
      ],
      "plane_d": 1887.297119140625,
      "bbox_min": [
        -359.847412109375,
        -2103.962890625,
        663.9999389648438
      ],
      "bbox_max": [
        -358.3617858886719,
        -2102.82275390625,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9046844840049744,
        -0.42608213424682617,
        0.0
      ],
      "plane_d": -570.4268188476562,
      "bbox_min": [
        -359.847412109375,
        -2102.87109375,
        661.26318359375
      ],
      "bbox_max": [
        -346.4175109863281,
        -2091.85205078125,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9729971289634705,
        0.23081713914871216,
        -0.0
      ],
      "plane_d": 832.51611328125,
      "bbox_min": [
        -357.8575439453125,
        -2098.495361328125,
        661.26318359375
      ],
      "bbox_max": [
        -357.809326171875,
        -2098.292236328125,
        663.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277128219604,
        -0.49999600648880005,
        -0.0
      ],
      "plane_d": -1346.112060546875,
      "bbox_min": [
        -359.847412109375,
        -2102.87109375,
        663.6964721679688
      ],
      "bbox_max": [
        -346.4175109863281,
        -2091.995361328125,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087977886199951,
        0.7933254241943359,
        0.0
      ],
      "plane_d": 1887.297119140625,
      "bbox_min": [
        -359.847412109375,
        -2102.87109375,
        663.9114990234375
      ],
      "bbox_max": [
        -359.7845153808594,
        -2102.82275390625,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058817386627197,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        659.3778076171875
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.791259765625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753774404525757,
        -0.22054219245910645,
        -0.0
      ],
      "plane_d": -812.7610473632812,
      "bbox_min": [
        -358.7217102050781,
        -2098.995361328125,
        661.093017578125
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.791259765625,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 664.0,
      "bbox_min": [
        -404.803955078125,
        -2134.2314453125,
        654.8319702148438
      ],
      "bbox_max": [
        -374.82244873046875,
        -2110.396240234375,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000009536743164,
        -0.8660248517990112,
        5.125979896547506e-06
      ],
      "plane_d": -1640.247314453125,
      "bbox_min": [
        -404.803955078125,
        -2134.2314453125,
        654.8319702148438
      ],
      "bbox_max": [
        -374.82244873046875,
        -2110.396240234375,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 655.9999389648438,
      "bbox_min": [
        -389.9620056152344,
        -2117.49951171875,
        654.9437255859375
      ],
      "bbox_max": [
        -384.5960693359375,
        -2113.729736328125,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491909503936768,
        0.490313857793808,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -389.9620056152344,
        -2117.49951171875,
        654.9437255859375
      ],
      "bbox_max": [
        -389.3301696777344,
        -2116.72216796875,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4956280589103699,
        -0.3802962005138397,
        -0.7808505892753601
      ],
      "plane_d": -94.19400024414062,
      "bbox_min": [
        -404.803955078125,
        -2134.2314453125,
        654.8319702148438
      ],
      "bbox_max": [
        -397.71533203125,
        -2125.55419921875,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.608748733997345,
        0.0
      ],
      "plane_d": -975.72900390625,
      "bbox_min": [
        -404.803955078125,
        -2134.2314453125,
        654.8319702148438
      ],
      "bbox_max": [
        -398.94976806640625,
        -2125.55419921875,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6193733811378479,
        0.08152862638235092,
        -0.7808519005775452
      ],
      "plane_d": 939.7765502929688,
      "bbox_min": [
        -404.803955078125,
        -2134.2314453125,
        656.530517578125
      ],
      "bbox_max": [
        -398.94976806640625,
        -2130.411865234375,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9914476275444031,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -404.803955078125,
        -2134.2314453125,
        656.530517578125
      ],
      "bbox_max": [
        -398.94976806640625,
        -2130.411865234375,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38034573197364807,
        0.49552738666534424,
        -0.7808903455734253
      ],
      "plane_d": 1727.734619140625,
      "bbox_min": [
        -400.1060791015625,
        -2134.2314453125,
        663.3273315429688
      ],
      "bbox_max": [
        -398.94976806640625,
        -2133.7763671875,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -360.5601806640625,
        -2098.791259765625,
        641.6248779296875
      ],
      "bbox_max": [
        -275.0,
        -1983.2685546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        705.44970703125
      ],
      "bbox_max": [
        -283.0,
        -1983.2685546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 663.9999389648438,
      "bbox_min": [
        -360.5601806640625,
        -2098.292236328125,
        641.6248779296875
      ],
      "bbox_max": [
        -346.7029113769531,
        -2073.195556640625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563422560691833,
        0.5164087414741516,
        0.0
      ],
      "plane_d": 771.662353515625,
      "bbox_min": [
        -360.30859375,
        -2091.77294921875,
        663.9999389648438
      ],
      "bbox_max": [
        -357.18017578125,
        -2086.585205078125,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6863763332366943,
        -0.7272465229034424,
        -0.0
      ],
      "plane_d": -1759.2607421875,
      "bbox_min": [
        -360.5601806640625,
        -2098.292236328125,
        641.6248779296875
      ],
      "bbox_max": [
        -346.7029113769531,
        -2073.195556640625,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.002856867853552103,
        -0.9999959468841553,
        0.0
      ],
      "plane_d": -2086.423828125,
      "bbox_min": [
        -360.30859375,
        -2098.292236328125,
        652.3602294921875
      ],
      "bbox_max": [
        -351.3818359375,
        -2086.585205078125,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107254981995,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": -1352.66748046875,
      "bbox_min": [
        -357.7043151855469,
        -2087.454345703125,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -654.9999389648438,
      "bbox_min": [
        -357.7043151855469,
        -2087.454345703125,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 659.9999389648438,
      "bbox_min": [
        -357.7043151855469,
        -2087.454345703125,
        659.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 659.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2098.292236328125,
        652.3602294921875
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        663.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9729971289634705,
        0.23081713914871216,
        -0.0
      ],
      "plane_d": 832.51611328125,
      "bbox_min": [
        -359.342529296875,
        -2098.292236328125,
        659.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8645933270454407,
        -0.5024722814559937,
        0.0
      ],
      "plane_d": -740.5030517578125,
      "bbox_min": [
        -359.342529296875,
        -2092.0322265625,
        659.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -654.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2097.1103515625,
        652.3602294921875
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        659.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9729971289634705,
        0.23081713914871216,
        -0.0
      ],
      "plane_d": 832.51611328125,
      "bbox_min": [
        -359.342529296875,
        -2092.43212890625,
        654.572509765625
      ],
      "bbox_max": [
        -359.2476501464844,
        -2092.0322265625,
        654.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8645933270454407,
        0.5024722814559937,
        0.0
      ],
      "plane_d": 740.5030517578125,
      "bbox_min": [
        -359.342529296875,
        -2097.1103515625,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        659.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.97299724817276,
        -0.23081716895103455,
        0.0
      ],
      "plane_d": -832.5162353515625,
      "bbox_min": [
        -359.342529296875,
        -2097.1103515625,
        654.9999389648438
      ],
      "bbox_max": [
        -358.1379089355469,
        -2092.0322265625,
        659.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        1.0428289897390641e-05,
        4.359517788543599e-06
      ],
      "plane_d": 376.8681640625,
      "bbox_min": [
        -401.5,
        -2392.0,
        619.9999389648438
      ],
      "bbox_max": [
        -234.5,
        -2189.26123046875,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5555604696273804,
        0.8314761519432068,
        0.0
      ],
      "plane_d": 2110.74560546875,
      "bbox_min": [
        -401.5,
        -2338.800048828125,
        629.0
      ],
      "bbox_max": [
        -376.8465881347656,
        -2257.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.8465881347656,
        -2310.735595703125,
        654.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 654.5,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.8465881347656,
        -2314.5625,
        654.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.189622163772583,
        0.9818571209907532,
        0.0
      ],
      "plane_d": 2222.25244140625,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.8465881347656,
        -2314.728515625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0009321773541159928,
        0.9999995827674866,
        0.0
      ],
      "plane_d": 2338.42578125,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.8465881347656,
        -2314.728515625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38177749514579773,
        0.9242542386054993,
        0.0
      ],
      "plane_d": 2014.5274658203125,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.8465881347656,
        -2314.728515625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14836359024047852,
        0.7682216167449951,
        -0.6227549910545349
      ],
      "plane_d": 2144.76416015625,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        638.002197265625
      ],
      "bbox_max": [
        -376.8466491699219,
        -2314.728515625,
        654.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0007291665533557534,
        0.7822183966636658,
        -0.6230039000511169
      ],
      "plane_d": 2235.35888671875,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        638.002197265625
      ],
      "bbox_max": [
        -376.8466491699219,
        -2314.728515625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7808688282966614,
        -0.6246950626373291
      ],
      "plane_d": 2233.59716796875,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        638.002197265625
      ],
      "bbox_max": [
        -376.8466491699219,
        -2314.728515625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2994239926338196,
        0.7228582501411438,
        -0.6227529048919678
      ],
      "plane_d": 1981.2764892578125,
      "bbox_min": [
        -381.092041015625,
        -2336.80322265625,
        638.002197265625
      ],
      "bbox_max": [
        -376.8466491699219,
        -2314.728515625,
        654.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -378.359130859375,
        -2319.006103515625,
        638.002197265625
      ],
      "bbox_max": [
        -376.8467712402344,
        -2314.728515625,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -378.359130859375,
        -2319.005859375,
        652.0
      ],
      "bbox_max": [
        -376.8468322753906,
        -2314.728515625,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 834.2132568359375,
      "bbox_min": [
        -401.5,
        -2282.430908203125,
        629.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2257.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -399.596923828125,
        -2282.430908203125,
        644.5
      ],
      "bbox_max": [
        -376.84716796875,
        -2258.8076171875,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8314761519432068,
        0.5555604696273804,
        -0.0
      ],
      "plane_d": 1591.7481689453125,
      "bbox_min": [
        -399.596923828125,
        -2282.430908203125,
        644.5
      ],
      "bbox_max": [
        -376.84716796875,
        -2267.067138671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2312.093505859375,
      "bbox_min": [
        -386.067138671875,
        -2282.430908203125,
        645.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2280.596923828125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186157226562,
      "bbox_min": [
        -376.84747314453125,
        -2392.0,
        619.9999389648438
      ],
      "bbox_max": [
        -234.5,
        -2189.26123046875,
        712.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.0,
      "bbox_min": [
        -291.20379638671875,
        -2392.0,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2257.5,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555604696273804,
        0.8314761519432068,
        0.0
      ],
      "plane_d": 1757.4091796875,
      "bbox_min": [
        -285.0,
        -2388.5,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2257.5,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -285.0,
        -2388.5,
        638.0
      ],
      "bbox_max": [
        -245.0,
        -2311.052490234375,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -285.0,
        -2388.5,
        638.0
      ],
      "bbox_max": [
        -245.0,
        -2311.052490234375,
        660.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -255.0,
      "bbox_min": [
        -285.0,
        -2388.5,
        638.0
      ],
      "bbox_max": [
        -245.0,
        -2311.052490234375,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.2000122070312,
      "bbox_min": [
        -255.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -245.0,
        -2313.5,
        649.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -255.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -245.0,
        -2331.5,
        649.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        0.923878014087677,
        0.0
      ],
      "plane_d": 2097.616943359375,
      "bbox_min": [
        -285.0,
        -2388.5,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2311.052490234375,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 2095.78564453125,
      "bbox_min": [
        -285.0,
        -2386.5,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2311.052490234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -267.07666015625,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2311.052490234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -267.07666015625,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2311.052490234375,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.755126953125,
      "bbox_min": [
        -262.233154296875,
        -2331.5,
        652.0
      ],
      "bbox_max": [
        -255.0,
        -2326.44140625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.755126953125,
      "bbox_min": [
        -267.07666015625,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2311.435302734375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 645.1622924804688,
      "bbox_min": [
        -267.07666015625,
        -2328.06494140625,
        638.0
      ],
      "bbox_max": [
        -262.233154296875,
        -2325.29345703125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267284631729126,
        0.9238839149475098,
        -0.0
      ],
      "plane_d": 2249.711181640625,
      "bbox_min": [
        -265.004638671875,
        -2326.44140625,
        638.0
      ],
      "bbox_max": [
        -262.233154296875,
        -2325.29345703125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38260337710380554,
        0.9239127039909363,
        0.0
      ],
      "plane_d": 2252.759765625,
      "bbox_min": [
        -267.07666015625,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -266.15283203125,
        -2327.682373046875,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 645.161376953125,
      "bbox_min": [
        -260.41259765625,
        -2314.206787109375,
        638.002197265625
      ],
      "bbox_max": [
        -259.264404296875,
        -2311.435302734375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 210.43450927734375,
      "bbox_min": [
        -246.6703338623047,
        -2278.4169921875,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2257.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        0.5555604696273804,
        0.0
      ],
      "plane_d": 1062.9293212890625,
      "bbox_min": [
        -246.6703338623047,
        -2278.4169921875,
        644.5
      ],
      "bbox_max": [
        -234.5,
        -2257.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -246.6703338623047,
        -2278.4169921875,
        660.0
      ],
      "bbox_max": [
        -234.5,
        -2257.5,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -291.20379638671875,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -285.0,
        -2370.952880859375,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        0.9238833785057068,
        -0.0
      ],
      "plane_d": 2313.909912109375,
      "bbox_min": [
        -290.4967041015625,
        -2386.5,
        641.0
      ],
      "bbox_max": [
        -285.0,
        -2384.22314453125,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -376.84747314453125,
        -2392.0,
        619.9999389648438
      ],
      "bbox_max": [
        -238.06411743164062,
        -2189.26123046875,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7709355354309082,
        -0.44510096311569214,
        -0.45556941628456116
      ],
      "plane_d": -932.5745239257812,
      "bbox_min": [
        -374.0327453613281,
        -2256.361083984375,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2189.26123046875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7625132203102112,
        -0.64697265625,
        0.0
      ],
      "plane_d": -1675.384521484375,
      "bbox_min": [
        -314.350341796875,
        -2225.860107421875,
        651.30615234375
      ],
      "bbox_max": [
        -310.4394836425781,
        -2219.08642578125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -314.350341796875,
        -2225.860107421875,
        651.30615234375
      ],
      "bbox_max": [
        -310.4394836425781,
        -2219.08642578125,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.969547688961029,
        -0.24490270018577576,
        0.0
      ],
      "plane_d": -846.1050415039062,
      "bbox_min": [
        -311.218017578125,
        -2225.860107421875,
        651.30615234375
      ],
      "bbox_max": [
        -310.4394836425781,
        -2222.778076171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7727664709091187,
        0.44615715742111206,
        -0.45141535997390747
      ],
      "plane_d": 1543.02392578125,
      "bbox_min": [
        -374.0327453613281,
        -2256.361083984375,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2189.26123046875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -374.0327453613281,
        -2256.361083984375,
        652.1422119140625
      ],
      "bbox_max": [
        -325.4989318847656,
        -2233.132080078125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      "bbox_max": [
        -325.4989318847656,
        -2233.132080078125,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      "bbox_max": [
        -325.4989318847656,
        -2233.132080078125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        653.0
      ],
      "bbox_max": [
        -325.4989318847656,
        -2233.132080078125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        -347.84100341796875,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2189.26123046875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8327006101608276,
        0.4807601869106293,
        0.27473509311676025
      ],
      "plane_d": 1169.4652099609375,
      "bbox_min": [
        -347.84100341796875,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2189.26123046875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -324.9223937988281,
        -2232.133544921875,
        640.666259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -324.9223937988281,
        -2232.133544921875,
        640.666259765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -326.0,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -324.9223937988281,
        -2232.133544921875,
        637.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -346.10888671875,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2189.26123046875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -328.39990234375,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.4734824299812317,
        -0.8377031087875366,
        0.2721542716026306
      ],
      "plane_d": -1879.69091796875,
      "bbox_min": [
        -328.39990234375,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48331403732299805,
        -0.8377364873886108,
        0.2541753351688385
      ],
      "plane_d": -1865.0765380859375,
      "bbox_min": [
        -328.39990234375,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -328.39990234375,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079718589782715,
        0.41903114318847656,
        0.0
      ],
      "plane_d": 1229.4326171875,
      "bbox_min": [
        -328.39990234375,
        -2227.60009765625,
        637.4000244140625
      ],
      "bbox_max": [
        -326.0,
        -2220.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8050610423088074,
        -0.5931919813156128,
        0.0
      ],
      "plane_d": -1053.9278564453125,
      "bbox_min": [
        -328.39990234375,
        -2222.39990234375,
        637.4000244140625
      ],
      "bbox_max": [
        -327.0,
        -2220.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.969547688961029,
        -0.24490270018577576,
        0.0
      ],
      "plane_d": -846.1050415039062,
      "bbox_min": [
        -326.0,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3135608732700348,
        -0.9495680928230286,
        0.0
      ],
      "plane_d": -2205.470947265625,
      "bbox_min": [
        -326.0,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -326.0,
        -2235.63671875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -324.0,
        -2235.63671875,
        638.002197265625
      ],
      "bbox_max": [
        -320.0487060546875,
        -2234.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11463826894760132,
        -0.9934073090553284,
        0.0
      ],
      "plane_d": -2165.989990234375,
      "bbox_min": [
        -321.800048828125,
        -2229.837890625,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7625132203102112,
        -0.64697265625,
        0.0
      ],
      "plane_d": -1675.384521484375,
      "bbox_min": [
        -313.05364990234375,
        -2224.584228515625,
        641.0
      ],
      "bbox_max": [
        -310.76177978515625,
        -2220.61474609375,
        642.6163940429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -328.39990234375,
        -2235.63671875,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.3135608732700348,
        -0.9495680928230286,
        0.0
      ],
      "plane_d": -2205.470947265625,
      "bbox_min": [
        -328.39990234375,
        -2235.63671875,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -328.39990234375,
        -2235.63671875,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7625132203102112,
        -0.64697265625,
        0.0
      ],
      "plane_d": -1675.384521484375,
      "bbox_min": [
        -328.39990234375,
        -2235.63671875,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -328.39990234375,
        -2235.63671875,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 324.0,
      "bbox_min": [
        -324.0,
        -2235.63671875,
        641.0
      ],
      "bbox_max": [
        -320.0487060546875,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -324.0,
        -2235.63671875,
        652.0
      ],
      "bbox_max": [
        -320.0487060546875,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079718589782715,
        0.41903114318847656,
        0.0
      ],
      "plane_d": 1229.4326171875,
      "bbox_min": [
        -328.39990234375,
        -2234.0,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        641.0
      ],
      "bbox_max": [
        -326.0,
        -2227.60009765625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.969547688961029,
        -0.24490270018577576,
        0.0
      ],
      "plane_d": -846.1050415039062,
      "bbox_min": [
        -328.39990234375,
        -2227.60009765625,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480128645896912,
        -0.5299756526947021,
        0.0
      ],
      "plane_d": -1448.111572265625,
      "bbox_min": [
        -324.13885498046875,
        -2217.769775390625,
        641.0
      ],
      "bbox_max": [
        -321.800048828125,
        -2216.699951171875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -324.13885498046875,
        -2217.769775390625,
        651.0
      ],
      "bbox_max": [
        -321.800048828125,
        -2216.699951171875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8050610423088074,
        -0.5931919813156128,
        0.0
      ],
      "plane_d": -1053.9278564453125,
      "bbox_min": [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      "bbox_max": [
        -319.199951171875,
        -2217.199951171875,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -327.48822021484375,
        -2220.5,
        651.0
      ],
      "bbox_max": [
        -325.6257629394531,
        -2218.635009765625,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.451732337474823,
        -0.7829954028129578,
        -0.42761677503585815
      ],
      "plane_d": -1312.5462646484375,
      "bbox_min": [
        -328.39990234375,
        -2222.39990234375,
        651.0
      ],
      "bbox_max": [
        -319.199951171875,
        -2217.199951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -327.0,
        -2220.5,
        651.0
      ],
      "bbox_max": [
        -321.800048828125,
        -2217.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4385019838809967,
        -0.7758143544197083,
        -0.4536828398704529
      ],
      "plane_d": -1283.910888671875,
      "bbox_min": [
        -328.39990234375,
        -2222.39990234375,
        651.0
      ],
      "bbox_max": [
        -319.199951171875,
        -2217.199951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4971730709075928,
        0.8676498532295227,
        -0.0016466102097183466
      ],
      "plane_d": 1764.1700439453125,
      "bbox_min": [
        -339.763671875,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2200.23388671875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480128645896912,
        0.5299756526947021,
        0.0
      ],
      "plane_d": 1454.111083984375,
      "bbox_min": [
        -327.5,
        -2219.733642578125,
        641.0
      ],
      "bbox_max": [
        -324.6006164550781,
        -2218.03857421875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -327.5,
        -2219.71875,
        651.0
      ],
      "bbox_max": [
        -324.6006164550781,
        -2218.03857421875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49972543120384216,
        0.8661825656890869,
        -0.0015091525856405497
      ],
      "plane_d": 1759.98779296875,
      "bbox_min": [
        -339.763671875,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2200.23388671875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5023817420005798,
        0.8646458983421326,
        -2.6761663995955587e-09
      ],
      "plane_d": 1754.742919921875,
      "bbox_min": [
        -339.763671875,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2200.23388671875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4977130591869354,
        0.8673417568206787,
        0.0
      ],
      "plane_d": 1762.2374267578125,
      "bbox_min": [
        -339.763671875,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2200.23388671875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480128645896912,
        0.5299756526947021,
        0.0
      ],
      "plane_d": 1454.111083984375,
      "bbox_min": [
        -327.5,
        -2219.7138671875,
        641.0
      ],
      "bbox_max": [
        -327.4913330078125,
        -2219.699951171875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1743.5611572265625,
      "bbox_min": [
        -339.763671875,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2200.23388671875,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4999884068965912,
        0.8660321235656738,
        2.6311850888305344e-05
      ],
      "plane_d": 1742.5469970703125,
      "bbox_min": [
        -339.763671875,
        -2209.14697265625,
        654.0
      ],
      "bbox_max": [
        -325.32568359375,
        -2200.23388671875,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -339.763671875,
        -2209.14697265625,
        654.0
      ],
      "bbox_max": [
        -325.32568359375,
        -2200.23388671875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -339.763671875,
        -2209.14697265625,
        654.0
      ],
      "bbox_max": [
        -325.32568359375,
        -2200.23388671875,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.75886070728302,
        -0.43803462386131287,
        -0.4819295108318329
      ],
      "plane_d": -899.8217163085938,
      "bbox_min": [
        -335.810546875,
        -2206.86474609375,
        654.0
      ],
      "bbox_max": [
        -329.248291015625,
        -2202.49853515625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7746132612228394,
        0.44712740182876587,
        -0.44727107882499695
      ],
      "plane_d": 1539.0009765625,
      "bbox_min": [
        -335.810546875,
        -2206.86474609375,
        654.0
      ],
      "bbox_max": [
        -334.4443359375,
        -2205.49853515625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.503265917301178,
        0.8641307353973389,
        0.0012059886939823627
      ],
      "plane_d": 1752.5428466796875,
      "bbox_min": [
        -334.392333984375,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2212.55517578125,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49695202708244324,
        0.8677774667739868,
        0.0009954591514542699
      ],
      "plane_d": 1762.815673828125,
      "bbox_min": [
        -334.392333984375,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -327.5,
        -2219.699951171875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -376.84747314453125,
        -2392.0,
        619.9999389648438
      ],
      "bbox_max": [
        -238.06411743164062,
        -2229.837890625,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -318.0001525878906,
        -2264.99951171875,
        637.4000244140625
      ],
      "bbox_max": [
        -238.06411743164062,
        -2229.837890625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -318.0001525878906,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2229.837890625,
        653.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -315.9516296386719,
        -2235.636962890625,
        638.002197265625
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -315.9516296386719,
        -2235.636962890625,
        638.002197265625
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -315.9516296386719,
        -2235.636962890625,
        638.002197265625
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -318.0001525878906,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2229.837890625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -318.0001525878906,
        -2234.0,
        653.0
      ],
      "bbox_max": [
        -310.0,
        -2229.837890625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -376.84747314453125,
        -2392.0,
        619.9999389648438
      ],
      "bbox_max": [
        -241.1126251220703,
        -2233.151611328125,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -299.14208984375,
        -2385.93017578125,
        635.0
      ],
      "bbox_max": [
        -284.2815246582031,
        -2368.5,
        660.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1473.2569580078125,
      "bbox_min": [
        -299.14208984375,
        -2384.22314453125,
        635.0
      ],
      "bbox_max": [
        -290.4967041015625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        0.9238833785057068,
        -0.0
      ],
      "plane_d": 2313.909912109375,
      "bbox_min": [
        -297.72802734375,
        -2384.22314453125,
        641.0
      ],
      "bbox_max": [
        -290.4967041015625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -3.082740931859007e-06
      ],
      "plane_d": 1907.825439453125,
      "bbox_min": [
        -376.84747314453125,
        -2392.0,
        619.9999389648438
      ],
      "bbox_max": [
        -241.1126251220703,
        -2233.151611328125,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 351.0,
      "bbox_min": [
        -376.8467102050781,
        -2392.0,
        635.0
      ],
      "bbox_max": [
        -336.85791015625,
        -2321.22314453125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -376.8467102050781,
        -2388.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2321.22314453125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        0.923878014087677,
        -0.0
      ],
      "plane_d": 2341.005859375,
      "bbox_min": [
        -376.8467102050781,
        -2388.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2321.22314453125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        0.9238833785057068,
        -0.0
      ],
      "plane_d": 2339.166259765625,
      "bbox_min": [
        -376.8467102050781,
        -2386.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2321.22314453125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38177749514579773,
        0.9242542386054993,
        0.0
      ],
      "plane_d": 2014.5274658203125,
      "bbox_min": [
        -376.8467102050781,
        -2335.287109375,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2321.22314453125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267284631729126,
        0.9238839149475098,
        0.0
      ],
      "plane_d": 2006.3314208984375,
      "bbox_min": [
        -376.8467102050781,
        -2335.287109375,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2321.22314453125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -376.8466491699219,
        -2335.287109375,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2326.44140625,
        654.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29812341928482056,
        0.7217341065406799,
        -0.6246777772903442
      ],
      "plane_d": 1980.3995361328125,
      "bbox_min": [
        -376.8466491699219,
        -2335.287109375,
        652.0
      ],
      "bbox_max": [
        -371.087890625,
        -2331.060791015625,
        654.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -376.8467102050781,
        -2327.717041015625,
        637.0
      ],
      "bbox_max": [
        -372.2547607421875,
        -2321.22314453125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -375.279052734375,
        -2326.44140625,
        638.002197265625
      ],
      "bbox_max": [
        -372.2547607421875,
        -2322.790771484375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -375.2790222167969,
        -2326.44140625,
        638.002197265625
      ],
      "bbox_max": [
        -372.2547607421875,
        -2322.790771484375,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -351.0,
        -2388.5,
        635.0
      ],
      "bbox_max": [
        -336.85791015625,
        -2368.5,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 2070.529052734375,
      "bbox_min": [
        -351.0,
        -2386.5,
        635.0
      ],
      "bbox_max": [
        -336.85791015625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1922.976806640625,
      "bbox_min": [
        -338.27197265625,
        -2382.64208984375,
        635.0
      ],
      "bbox_max": [
        -336.85791015625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        0.3826833665370941,
        -9.773058309292537e-07
      ],
      "plane_d": 1231.606689453125,
      "bbox_min": [
        -376.84747314453125,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -241.1126251220703,
        -2233.151611328125,
        712.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -376.84686279296875,
        -2328.06494140625,
        637.0
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -376.84674072265625,
        -2322.791015625,
        637.0
      ],
      "bbox_max": [
        -375.2789306640625,
        -2319.006103515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 1232.733154296875,
      "bbox_min": [
        -376.735595703125,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.435302734375,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38267284631729126,
        0.9238839149475098,
        0.0
      ],
      "plane_d": 2006.3314208984375,
      "bbox_min": [
        -372.2547607421875,
        -2325.815185546875,
        638.002197265625
      ],
      "bbox_max": [
        -370.995361328125,
        -2325.29345703125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38260337710380554,
        0.9239127039909363,
        0.0
      ],
      "plane_d": 2009.4239501953125,
      "bbox_min": [
        -369.84716796875,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2327.682373046875,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -376.84747314453125,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -241.1126251220703,
        -2233.151611328125,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555604696273804,
        0.8314761519432068,
        0.0
      ],
      "plane_d": 1757.4091796875,
      "bbox_min": [
        -259.15283203125,
        -2282.430908203125,
        629.0
      ],
      "bbox_max": [
        -241.1126251220703,
        -2258.385498046875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -259.15283203125,
        -2282.430908203125,
        645.0
      ],
      "bbox_max": [
        -241.1126251220703,
        -2258.385498046875,
        660.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2188.0126953125,
      "bbox_min": [
        -259.15283203125,
        -2282.430908203125,
        645.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2280.596923828125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -376.84747314453125,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2233.151611328125,
        712.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2233.151611328125,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -320.0487060546875,
        -2234.0,
        652.0
      ],
      "bbox_max": [
        -315.9516296386719,
        -2233.151611328125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -320.0486755371094,
        -2234.0,
        653.0
      ],
      "bbox_max": [
        -315.9516296386719,
        -2233.151611328125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -327.0,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2233.151611328125,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -320.0487060546875,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -315.9516296386719,
        -2233.151611328125,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -320.0486755371094,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -315.9516296386719,
        -2233.151611328125,
        637.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2237.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2235.63671875,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 324.0,
      "bbox_min": [
        -324.0,
        -2237.0,
        638.002197265625
      ],
      "bbox_max": [
        -312.0,
        -2235.63671875,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -312.0,
        -2237.0,
        638.002197265625
      ],
      "bbox_max": [
        -312.0,
        -2235.636962890625,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -327.0,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -376.84747314453125,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -376.84747314453125,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        -0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -376.84747314453125,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -347.9140625,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.16796875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -347.9140625,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.16796875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -376.84747314453125,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -282.596923828125,
        -2272.471923828125,
        649.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2247.84130859375,
        660.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -281.46978759765625,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -268.111572265625,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -281.46978759765625,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -268.111572265625,
        -2250.0869140625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -376.84747314453125,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.84747314453125,
        -2272.471923828125,
        649.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.841064453125,
        660.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2250.0869140625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -376.8473205566406,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.8473205566406,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -367.88818359375,
        -2263.512939453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -376.84722900390625,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -367.888427734375,
        -2263.512939453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2312.093505859375,
      "bbox_min": [
        -376.8471984863281,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -376.5,
        -2282.430908203125,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2312.093505859375,
      "bbox_min": [
        -376.84722900390625,
        -2282.5,
        649.0
      ],
      "bbox_max": [
        -375.0616760253906,
        -2280.794677734375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266947865486145,
        0.9238852858543396,
        -0.0
      ],
      "plane_d": 2250.751220703125,
      "bbox_min": [
        -375.150390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -375.0616760253906,
        -2280.794677734375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -268.11181640625,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2263.512939453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -268.111572265625,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2263.512939453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2188.0126953125,
      "bbox_min": [
        -259.5,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2282.430908203125,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2188.0126953125,
      "bbox_min": [
        -260.9382629394531,
        -2282.5,
        649.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2280.794677734375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38266947865486145,
        0.9238852858543396,
        0.0
      ],
      "plane_d": 2007.3734130859375,
      "bbox_min": [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -260.849609375,
        -2280.794677734375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -327.0,
      "bbox_min": [
        -376.84716796875,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268962502479553,
        0.923876941204071,
        -0.0
      ],
      "plane_d": 2234.699462890625,
      "bbox_min": [
        -309.0,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -309.0,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -309.0,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.3630545735359192,
        0.8764691948890686,
        0.3162168562412262
      ],
      "plane_d": 1922.0771484375,
      "bbox_min": [
        -309.0,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -259.423095703125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 95.18456268310547,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2258.0,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.48564356565475464,
        -0.0,
        0.8741569519042969
      ],
      "plane_d": -406.7741394042969,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -690.9449462890625,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        619.9999389648438
      ],
      "bbox_max": [
        -291.0,
        -2266.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2266.0,
      "bbox_min": [
        -305.0,
        -2290.865966796875,
        619.9999389648438
      ],
      "bbox_max": [
        -291.0,
        -2266.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7888118624687195,
        0.5270435214042664,
        0.3162292242050171
      ],
      "plane_d": 1251.0513916015625,
      "bbox_min": [
        -304.9999084472656,
        -2290.865966796875,
        620.0
      ],
      "bbox_max": [
        -303.9912109375,
        -2289.23388671875,
        620.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -304.0915832519531,
        -2286.240478515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7888118624687195,
        0.5270435214042664,
        0.3162292242050171
      ],
      "plane_d": 1251.0513916015625,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -304.0915832519531,
        -2286.240478515625,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -627.0,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        627.0
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        634.9540405273438
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268962502479553,
        0.923876941204071,
        0.0
      ],
      "plane_d": 1991.308837890625,
      "bbox_min": [
        -376.84716796875,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -376.84716796875,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        637.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.3630546033382416,
        0.8764746785163879,
        0.31620171666145325
      ],
      "plane_d": 1691.196533203125,
      "bbox_min": [
        -376.576904296875,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -508.17803955078125,
      "bbox_min": [
        -349.5,
        -2292.359130859375,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2258.0,
      "bbox_min": [
        -349.5,
        -2292.359130859375,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2258.0,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.48564356565475464,
        0.0,
        0.8741569519042969
      ],
      "plane_d": -715.6434326171875,
      "bbox_min": [
        -349.5,
        -2292.359130859375,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -406.5151062011719,
      "bbox_min": [
        -345.0,
        -2292.359130859375,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2266.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2266.0,
      "bbox_min": [
        -345.0,
        -2290.865966796875,
        619.9999389648438
      ],
      "bbox_max": [
        -331.0,
        -2266.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7888135313987732,
        0.5270446538925171,
        0.3162231743335724
      ],
      "plane_d": 749.372802734375,
      "bbox_min": [
        -332.0087890625,
        -2290.865966796875,
        620.0
      ],
      "bbox_max": [
        -331.0000915527344,
        -2289.23388671875,
        620.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314775824546814,
        0.5555582642555237,
        0.0
      ],
      "plane_d": 998.5836791992188,
      "bbox_min": [
        -331.9084167480469,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2286.240478515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7888135313987732,
        0.5270446538925171,
        0.3162231743335724
      ],
      "plane_d": 749.372802734375,
      "bbox_min": [
        -331.9084167480469,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2286.240478515625,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -627.0,
      "bbox_min": [
        -349.5,
        -2292.359130859375,
        627.0
      ],
      "bbox_max": [
        -327.0,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314775824546814,
        0.5555582642555237,
        0.0
      ],
      "plane_d": 998.5836791992188,
      "bbox_min": [
        -330.682861328125,
        -2292.359130859375,
        634.9540405273438
      ],
      "bbox_max": [
        -327.0,
        -2286.84716796875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2296.0,
      "bbox_min": [
        -376.840087890625,
        -2306.507568359375,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.707112193107605,
        1.54620865941979e-05,
        -0.7071013450622559
      ],
      "plane_d": 256.2476501464844,
      "bbox_min": [
        -341.653564453125,
        -2306.507568359375,
        694.0
      ],
      "bbox_max": [
        -294.6982116699219,
        -2296.0,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -304.6982421875,
        -2306.50732421875,
        694.0
      ],
      "bbox_max": [
        -294.6982116699219,
        -2296.0,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -319.5,
      "bbox_min": [
        -376.840087890625,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -319.5,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -319.5,
        -2283.304931640625,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5105127861024812e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2273.313232421875,
      "bbox_min": [
        -319.5,
        -2273.30517578125,
        704.0
      ],
      "bbox_max": [
        -317.0,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -319.5,
        -2283.304931640625,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070879340171814,
        0.7071256041526794,
        -0.0
      ],
      "plane_d": 1825.6146240234375,
      "bbox_min": [
        -317.0,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999903738498688,
        0.500005841255188,
        -0.7071094512939453
      ],
      "plane_d": 1788.6934814453125,
      "bbox_min": [
        -317.0,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -317.0,
        -2296.0,
        690.8841552734375
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -317.0,
        -2283.30517578125,
        690.8841552734375
      ],
      "bbox_max": [
        -308.451171875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -317.0,
        -2283.30517578125,
        690.8841552734375
      ],
      "bbox_max": [
        -312.59326171875,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070958614349365,
        0.7071177363395691,
        -0.0
      ],
      "plane_d": 1835.5989990234375,
      "bbox_min": [
        -317.0,
        -2291.199951171875,
        687.5
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -317.0,
        -2283.30517578125,
        687.5
      ],
      "bbox_max": [
        -312.59326171875,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8797038793563843,
        -0.47552192211151123,
        0.0
      ],
      "plane_d": -787.111328125,
      "bbox_min": [
        -317.0,
        -2241.699951171875,
        687.5
      ],
      "bbox_max": [
        -315.0,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000194907188416,
        0.49998852610588074,
        -0.7071011066436768
      ],
      "plane_d": 1470.4688720703125,
      "bbox_min": [
        -341.6532897949219,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707112193107605,
        1.54620865941979e-05,
        -0.7071013450622559
      ],
      "plane_d": 256.2476501464844,
      "bbox_min": [
        -341.6532897949219,
        -2296.0,
        690.98876953125
      ],
      "bbox_max": [
        -319.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -327.900634765625,
        -2283.304931640625,
        690.98876953125
      ],
      "bbox_max": [
        -319.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -323.758544921875,
        -2283.304931640625,
        690.98876953125
      ],
      "bbox_max": [
        -319.5,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707128643989563,
        0.7070848941802979,
        0.0
      ],
      "plane_d": 1385.551513671875,
      "bbox_min": [
        -331.6533203125,
        -2291.2001953125,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -323.758544921875,
        -2283.304931640625,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8797038793563843,
        -0.47552189230918884,
        0.0
      ],
      "plane_d": -1347.0428466796875,
      "bbox_min": [
        -321.5,
        -2241.699951171875,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        687.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2286.84716796875,
      "bbox_min": [
        -330.682861328125,
        -2292.359130859375,
        637.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -330.682861328125,
        -2292.359130859375,
        637.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314775824546814,
        0.5555582642555237,
        0.0
      ],
      "plane_d": 998.5836791992188,
      "bbox_min": [
        -330.682861328125,
        -2292.359130859375,
        637.0
      ],
      "bbox_max": [
        -327.0,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": -2044.213623046875,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8797038793563843,
        -0.47552192211151123,
        0.0
      ],
      "plane_d": -787.111328125,
      "bbox_min": [
        -321.5,
        -2241.699951171875,
        670.5
      ],
      "bbox_max": [
        -315.0,
        -2238.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9771250486373901,
        0.0,
        -0.2126655876636505
      ],
      "plane_d": 510.8121643066406,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2246.958984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552192211151123,
        0.8797038793563843,
        0.0
      ],
      "plane_d": 2197.236328125,
      "bbox_min": [
        -376.840087890625,
        -2296.0,
        670.5
      ],
      "bbox_max": [
        -373.14013671875,
        -2294.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38280341029167175,
        0.9238297939300537,
        0.0
      ],
      "plane_d": 2054.107421875,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2246.958984375,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.22233350574970245,
        0.536557674407959,
        -0.8140476942062378
      ],
      "plane_d": 1719.30078125,
      "bbox_min": [
        -319.11553955078125,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -319.11553955078125,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        656.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -319.11553955078125,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        649.5
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5809391736984253,
        -0.8139470219612122
      ],
      "plane_d": 1891.8863525390625,
      "bbox_min": [
        -319.115478515625,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2350.796142578125,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -341.53460693359375,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -312.51226806640625,
        -2350.796142578125,
        649.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38281548023223877,
        0.9238248467445374,
        -0.0
      ],
      "plane_d": 2297.564453125,
      "bbox_min": [
        -351.334228515625,
        -2350.796142578125,
        643.0
      ],
      "bbox_max": [
        -328.72412109375,
        -2288.511962890625,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -351.334228515625,
        -2350.796142578125,
        643.0
      ],
      "bbox_max": [
        -328.72412109375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831441342830658,
        0.5556125640869141,
        0.0
      ],
      "plane_d": 1011.7618408203125,
      "bbox_min": [
        -351.334228515625,
        -2346.7353515625,
        656.0
      ],
      "bbox_max": [
        -348.55615234375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -351.334228515625,
        -2350.796142578125,
        643.0
      ],
      "bbox_max": [
        -328.72412109375,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831441342830658,
        0.5556125640869141,
        0.0
      ],
      "plane_d": 1011.7618408203125,
      "bbox_min": [
        -351.334228515625,
        -2346.7353515625,
        643.0
      ],
      "bbox_max": [
        -348.55615234375,
        -2342.578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831441342830658,
        0.5556125640869141,
        0.0
      ],
      "plane_d": 1011.7618408203125,
      "bbox_min": [
        -351.334228515625,
        -2346.7353515625,
        649.5
      ],
      "bbox_max": [
        -348.55615234375,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707128643989563,
        0.7070848941802979,
        0.0
      ],
      "plane_d": 1385.551513671875,
      "bbox_min": [
        -331.6533203125,
        -2291.2001953125,
        684.9931030273438
      ],
      "bbox_max": [
        -328.9652404785156,
        -2288.511962890625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -328.72412109375,
        -2352.9638671875,
        646.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -317.7434997558594,
        -2352.9638671875,
        649.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1345.3128662109375,
      "bbox_min": [
        -376.84716796875,
        -2315.26025390625,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2246.958984375,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3690088987350464,
        -0.3690088987350464,
        -0.8530327677726746
      ],
      "plane_d": -150.14930725097656,
      "bbox_min": [
        -372.79205322265625,
        -2275.351806640625,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -372.79205322265625,
        -2275.351806640625,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        657.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -372.79205322265625,
        -2275.351806640625,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        649.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4821348190307617,
        -0.19970673322677612,
        -0.8530318140983582
      ],
      "plane_d": 274.6854248046875,
      "bbox_min": [
        -372.7919921875,
        -2275.351806640625,
        644.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2263.512939453125,
        647.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        -0.38268470764160156,
        0.0
      ],
      "plane_d": -531.2314453125,
      "bbox_min": [
        -376.84716796875,
        -2315.26025390625,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2246.958984375,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4821348190307617,
        -0.19970673322677612,
        -0.8530318140983582
      ],
      "plane_d": 274.6854248046875,
      "bbox_min": [
        -376.84716796875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266947865486145,
        0.9238852858543396,
        -0.0
      ],
      "plane_d": 2250.751220703125,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -370.531005859375,
        -2280.831298828125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1795.0328369140625,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2246.958984375,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3690088987350464,
        -0.3690088987350464,
        -0.8530327677726746
      ],
      "plane_d": -384.8389587402344,
      "bbox_min": [
        -287.443603515625,
        -2275.35205078125,
        644.0
      ],
      "bbox_max": [
        -263.2077941894531,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -287.443603515625,
        -2275.35205078125,
        644.0
      ],
      "bbox_max": [
        -263.2077941894531,
        -2246.958984375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314638733863831,
        0.5555787682533264,
        0.0
      ],
      "plane_d": 1011.6734008789062,
      "bbox_min": [
        -287.443603515625,
        -2251.1162109375,
        657.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -287.443603515625,
        -2275.35205078125,
        644.0
      ],
      "bbox_max": [
        -263.2077941894531,
        -2246.958984375,
        657.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314638733863831,
        0.5555787682533264,
        0.0
      ],
      "plane_d": 1011.6734008789062,
      "bbox_min": [
        -287.443603515625,
        -2251.1162109375,
        644.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2246.958984375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314638733863831,
        0.5555787682533264,
        0.0
      ],
      "plane_d": 1011.6734008789062,
      "bbox_min": [
        -287.443603515625,
        -2251.1162109375,
        649.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4821368455886841,
        -0.19970838725566864,
        -0.853030264377594
      ],
      "plane_d": -31.957632064819336,
      "bbox_min": [
        -272.26904296875,
        -2275.35205078125,
        644.0
      ],
      "bbox_max": [
        -263.2078857421875,
        -2263.512939453125,
        647.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826741576194763,
        8.165456529241055e-05
      ],
      "plane_d": -1118.849365234375,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2266.290771484375,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4821368455886841,
        -0.19970838725566864,
        -0.853030264377594
      ],
      "plane_d": -31.957632064819336,
      "bbox_min": [
        -272.26904296875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -272.26904296875,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38266947865486145,
        0.9238852858543396,
        0.0
      ],
      "plane_d": 2007.3734130859375,
      "bbox_min": [
        -265.468994140625,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        655.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2278.30517578125,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        655.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070987820625305,
        0.7071147561073303,
        0.0
      ],
      "plane_d": 1830.5931396484375,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        655.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071147561073303,
        0.7070987820625305,
        0.0
      ],
      "plane_d": 1380.587890625,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        655.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 663.0,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        655.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7070877552032471,
        0.7071258425712585,
        -0.0
      ],
      "plane_d": 1833.614990234375,
      "bbox_min": [
        -333.6533203125,
        -2291.2001953125,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.9040728147956543e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2281.31103515625,
      "bbox_min": [
        -333.6533203125,
        -2291.2001953125,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071163058280945,
        0.7070972323417664,
        0.0
      ],
      "plane_d": 1383.583740234375,
      "bbox_min": [
        -333.6533203125,
        -2291.2001953125,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693355143070221,
        0.6933924555778503,
        0.19612644612789154
      ],
      "plane_d": 1665.8143310546875,
      "bbox_min": [
        -333.6533203125,
        -2291.2001953125,
        674.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.867096398200374e-05,
        0.9805803894996643,
        0.19611762464046478
      ],
      "plane_d": 2104.82568359375,
      "bbox_min": [
        -333.6533203125,
        -2291.2001953125,
        674.0
      ],
      "bbox_max": [
        -311.764892578125,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933853030204773,
        0.6933665871620178,
        0.19611123204231262
      ],
      "plane_d": 1224.537841796875,
      "bbox_min": [
        -333.6533203125,
        -2291.2001953125,
        674.0
      ],
      "bbox_max": [
        -323.758544921875,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707128643989563,
        0.7070848941802979,
        0.0
      ],
      "plane_d": 1385.551513671875,
      "bbox_min": [
        -331.6533203125,
        -2291.2001953125,
        684.0
      ],
      "bbox_max": [
        -323.758544921875,
        -2283.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707128643989563,
        0.7070848941802979,
        0.0
      ],
      "plane_d": 1385.551513671875,
      "bbox_min": [
        -324.4585876464844,
        -2284.005126953125,
        684.0
      ],
      "bbox_max": [
        -323.758544921875,
        -2283.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070958614349365,
        0.7071177363395691,
        -0.0
      ],
      "plane_d": 1835.5989990234375,
      "bbox_min": [
        -313.58343505859375,
        -2291.199951171875,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -313.58343505859375,
        -2283.30517578125,
        684.0
      ],
      "bbox_max": [
        -312.59326171875,
        -2283.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.144122845493257e-05,
        0.9805718064308167,
        -0.1961604654788971
      ],
      "plane_d": 2369.005859375,
      "bbox_min": [
        -331.6533203125,
        -2301.951171875,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.69339919090271,
        0.6933562755584717,
        -0.1960984170436859
      ],
      "plane_d": 1488.6630859375,
      "bbox_min": [
        -331.6533203125,
        -2301.951171875,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933625936508179,
        0.693384051322937,
        -0.19612976908683777
      ],
      "plane_d": 1929.98193359375,
      "bbox_min": [
        -330.6533203125,
        -2301.951171875,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.30517578125,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 231.46905517578125,
      "bbox_min": [
        -330.6533203125,
        -2301.951171875,
        655.0
      ],
      "bbox_max": [
        -305.6982421875,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997347593307495,
        0.49999019503593445,
        -0.7071324586868286
      ],
      "plane_d": 1763.9188232421875,
      "bbox_min": [
        -330.6533203125,
        -2301.950927734375,
        655.0
      ],
      "bbox_max": [
        -305.6982421875,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2080.52392578125,
      "bbox_min": [
        -330.6533203125,
        -2301.950927734375,
        655.0
      ],
      "bbox_max": [
        -305.6982421875,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070814967155457,
        -1.670047640800476e-05,
        -0.70713210105896
      ],
      "plane_d": 681.408203125,
      "bbox_min": [
        -330.6533203125,
        -2301.950927734375,
        655.0
      ],
      "bbox_max": [
        -305.6982421875,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.499983549118042,
        0.499983549118042,
        -0.7071300745010376
      ],
      "plane_d": 1445.73974609375,
      "bbox_min": [
        -330.6533203125,
        -2292.85693359375,
        655.0
      ],
      "bbox_max": [
        -322.1015625,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2411.5,
      "bbox_min": [
        -351.0,
        -2411.5,
        640.0
      ],
      "bbox_max": [
        -285.0,
        -2392.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.0,
      "bbox_min": [
        -351.0,
        -2411.5,
        640.0
      ],
      "bbox_max": [
        -285.0,
        -2392.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 351.0,
      "bbox_min": [
        -351.0,
        -2411.5,
        640.0
      ],
      "bbox_max": [
        -287.038330078125,
        -2392.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9798362851142883,
        0.19980166852474213,
        -0.000411680230172351
      ],
      "plane_d": 800.5827026367188,
      "bbox_min": [
        -348.961669921875,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -287.038330078125,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9798362851142883,
        0.19980166852474213,
        -0.000400588265620172
      ],
      "plane_d": 140.16561889648438,
      "bbox_min": [
        -348.961669921875,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1049.9388427734375,
      "bbox_min": [
        -348.08642578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2421.395263671875,
      "bbox_min": [
        -344.071044921875,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2289.90234375,
      "bbox_min": [
        -344.071044921875,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 1808.2830810546875,
      "bbox_min": [
        -344.071044921875,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827075958251953,
        0.9238695502281189,
        -8.666777375765378e-07
      ],
      "plane_d": 2099.217041015625,
      "bbox_min": [
        -340.826904296875,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.960491418838501,
        0.195743128657341,
        -0.1978406459093094
      ],
      "plane_d": 912.6994018554688,
      "bbox_min": [
        -326.757568359375,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -325.047607421875,
        -2407.21142578125,
        649.3076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9604577422142029,
        0.1974814385175705,
        -0.19627024233341217
      ],
      "plane_d": 915.8607177734375,
      "bbox_min": [
        -326.757568359375,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -325.047607421875,
        -2407.557373046875,
        649.3076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1610.3447265625,
      "bbox_min": [
        -340.826904296875,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 2182.744384765625,
      "bbox_min": [
        -340.826904296875,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19148309528827667,
        0.9626355767250061,
        -0.1914861500263214
      ],
      "plane_d": 2371.898681640625,
      "bbox_min": [
        -340.826904296875,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19148465991020203,
        0.9626434445381165,
        -0.19144512712955475
      ],
      "plane_d": 2500.950927734375,
      "bbox_min": [
        -337.0,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160831928253174,
        0.5453042387962341,
        -0.1914459615945816
      ],
      "plane_d": 1704.902587890625,
      "bbox_min": [
        -333.46435546875,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -327.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5452976226806641,
        0.8160732388496399,
        -0.19150692224502563
      ],
      "plane_d": 2266.728271484375,
      "bbox_min": [
        -333.46435546875,
        -2405.267333984375,
        645.6731567382812
      ],
      "bbox_max": [
        -329.928955078125,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269850611686707,
        0.9238733053207397,
        -8.707995675649727e-07
      ],
      "plane_d": 2357.167724609375,
      "bbox_min": [
        -348.08642578125,
        -2407.97314453125,
        649.3038940429688
      ],
      "bbox_max": [
        -346.23876953125,
        -2407.207763671875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9798362851142883,
        0.19980166852474213,
        -0.000400588265620172
      ],
      "plane_d": 177.39939880371094,
      "bbox_min": [
        -324.60009765625,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -287.038330078125,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9798362851142883,
        0.19980166852474213,
        -0.000411680230172351
      ],
      "plane_d": 763.3489379882812,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -287.038330078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1578.7491455078125,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -287.91357421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2413.981689453125,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -291.928955078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2297.31591796875,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -291.928955078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 2161.63232421875,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -291.928955078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269850611686707,
        0.9238733053207397,
        -8.707995675649727e-07
      ],
      "plane_d": 2342.625244140625,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -295.173095703125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.960491955280304,
        0.19574043154716492,
        -0.19784054160118103
      ],
      "plane_d": 301.8201599121094,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -309.242431640625,
        -2407.21142578125,
        649.3076782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9604582786560059,
        0.19748155772686005,
        -0.19626763463020325
      ],
      "plane_d": 305.008056640625,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -309.242431640625,
        -2407.557373046875,
        649.3076782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 1829.3951416015625,
      "bbox_min": [
        -308.23876953125,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -295.173095703125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1081.534423828125,
      "bbox_min": [
        -308.23876953125,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -295.173095703125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19148309528827667,
        0.9626355767250061,
        -0.1914861500263214
      ],
      "plane_d": 2379.175048828125,
      "bbox_min": [
        -308.23876953125,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -295.173095703125,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19148465991020203,
        0.9626434445381165,
        -0.19144512712955475
      ],
      "plane_d": 2493.674560546875,
      "bbox_min": [
        -308.23876953125,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -295.173095703125,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5453042387962341,
        0.8160831928253174,
        -0.1914459615945816
      ],
      "plane_d": 1919.9012451171875,
      "bbox_min": [
        -308.23876953125,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -302.53564453125,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8160732388496399,
        0.5452976226806641,
        -0.19150692224502563
      ],
      "plane_d": 1185.900390625,
      "bbox_min": [
        -308.23876953125,
        -2408.264404296875,
        645.6731567382812
      ],
      "bbox_max": [
        -305.53271484375,
        -2404.72900390625,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827075958251953,
        0.9238695502281189,
        -8.666777375765378e-07
      ],
      "plane_d": 2113.759765625,
      "bbox_min": [
        -289.76123046875,
        -2407.97314453125,
        649.3038940429688
      ],
      "bbox_max": [
        -287.91357421875,
        -2407.207763671875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.993532657623291,
        -0.0,
        -0.11354659497737885
      ],
      "plane_d": -246.19747924804688,
      "bbox_min": [
        -324.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -311.39990234375,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.993532657623291,
        0.0,
        -0.11354658752679825
      ],
      "plane_d": 385.68927001953125,
      "bbox_min": [
        -324.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -311.39990234375,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9684929251670837,
        -0.24904105067253113
      ],
      "plane_d": 2488.8330078125,
      "bbox_min": [
        -324.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -311.39990234375,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5,
      "bbox_min": [
        -322.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -313.39990234375,
        -2401.5,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.4000244140625,
      "bbox_min": [
        -321.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -321.60009765625,
      "bbox_min": [
        -321.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2403.60009765625,
      "bbox_min": [
        -321.60009765625,
        -2403.60009765625,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -969.41943359375,
        -2801.961181640625,
        443.0972900390625
      ],
      "bbox_max": [
        -482.3701171875,
        -2127.7587890625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -969.41943359375,
        -2801.961181640625,
        443.0972900390625
      ],
      "bbox_max": [
        -482.3701171875,
        -2127.7587890625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -969.41943359375,
        -2801.961181640625,
        529.9791259765625
      ],
      "bbox_max": [
        -482.3701171875,
        -2127.7587890625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -969.41943359375,
        -2565.431396484375,
        558.2156982421875
      ],
      "bbox_max": [
        -658.1302490234375,
        -2127.7587890625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -969.41943359375,
        -2565.431396484375,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2127.7587890625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -969.41943359375,
        -2565.431396484375,
        626.4732666015625
      ],
      "bbox_max": [
        -711.299560546875,
        -2127.7587890625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        626.4732666015625
      ],
      "bbox_max": [
        -714.501953125,
        -2290.162109375,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -758.8818969726562,
        -2304.79736328125,
        626.4732666015625
      ],
      "bbox_max": [
        -750.960693359375,
        -2290.162109375,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -758.8818969726562,
        -2296.81787109375,
        626.4732666015625
      ],
      "bbox_max": [
        -757.0588989257812,
        -2290.162109375,
        639.2581787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -750.960693359375,
        -2313.18505859375,
        639.28125
      ],
      "bbox_max": [
        -742.0281982421875,
        -2304.79736328125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -969.41943359375,
        -2565.431396484375,
        639.2235717773438
      ],
      "bbox_max": [
        -711.299560546875,
        -2127.7587890625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -969.41943359375,
        -2303.48095703125,
        639.2235717773438
      ],
      "bbox_max": [
        -751.0709228515625,
        -2127.7587890625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -757.0588989257812,
        -2303.48095703125,
        639.2581787109375
      ],
      "bbox_max": [
        -751.0709228515625,
        -2296.81787109375,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.871337890625,
        -2302.712646484375,
        641.6248779296875
      ],
      "bbox_max": [
        -751.0709228515625,
        -2299.47509765625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -755.906494140625,
        -2304.79736328125,
        639.2774658203125
      ],
      "bbox_max": [
        -750.2799072265625,
        -2300.896484375,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -752.4519653320312,
        -2303.782470703125,
        641.6248779296875
      ],
      "bbox_max": [
        -750.2799072265625,
        -2300.896484375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -933.75,
        -2565.431396484375,
        639.28125
      ],
      "bbox_max": [
        -711.299560546875,
        -2288.54150390625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -763.491943359375,
        -2305.747802734375,
        650.060791015625
      ],
      "bbox_max": [
        -755.906494140625,
        -2288.54150390625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -763.491943359375,
        -2305.747802734375,
        675.13037109375
      ],
      "bbox_max": [
        -761.55126953125,
        -2299.924560546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -933.75,
        -2565.431396484375,
        639.28125
      ],
      "bbox_max": [
        -711.299560546875,
        -2301.5322265625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -740.5066528320312,
        -2301.5322265625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -762.23095703125,
        -2329.119384765625,
        675.13037109375
      ],
      "bbox_max": [
        -740.5066528320312,
        -2301.5322265625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -754.3880615234375,
        -2328.661376953125,
        686.6377563476562
      ],
      "bbox_max": [
        -740.9509887695312,
        -2311.53076171875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -754.3880615234375,
        -2316.721435546875,
        686.6377563476562
      ],
      "bbox_max": [
        -752.123779296875,
        -2311.53076171875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -752.123779296875,
        -2329.119384765625,
        686.6377563476562
      ],
      "bbox_max": [
        -740.5066528320312,
        -2316.721435546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -933.75,
        -2565.431396484375,
        639.28125
      ],
      "bbox_max": [
        -711.299560546875,
        -2301.97705078125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -930.0518798828125,
        -2565.431396484375,
        686.6377563476562
      ],
      "bbox_max": [
        -711.299560546875,
        -2316.721435546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -930.0518798828125,
        -2565.431396484375,
        687.8468627929688
      ],
      "bbox_max": [
        -902.8463745117188,
        -2520.06982421875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016451746225357056,
        -0.023649385198950768,
        -0.999584972858429
      ],
      "plane_d": 616.3050537109375,
      "bbox_min": [
        -877.5479736328125,
        -2496.873046875,
        686.6377563476562
      ],
      "bbox_max": [
        -711.299560546875,
        -2316.721435546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -726.142822265625,
        -2348.508544921875,
        686.9425659179688
      ],
      "bbox_max": [
        -721.693115234375,
        -2343.50244140625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -726.142822265625,
        -2346.3134765625,
        686.9425659179688
      ],
      "bbox_max": [
        -724.343505859375,
        -2343.50244140625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -728.6041870117188,
        -2357.11669921875,
        686.9425659179688
      ],
      "bbox_max": [
        -711.299560546875,
        -2341.385986328125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -726.5072021484375,
        -2344.7451171875,
        686.9425659179688
      ],
      "bbox_max": [
        -725.3448486328125,
        -2342.9248046875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -933.75,
        -2561.875,
        639.28125
      ],
      "bbox_max": [
        -712.4946899414062,
        -2301.97705078125,
        688.0962524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -930.3886108398438,
        -2560.52392578125,
        686.9425659179688
      ],
      "bbox_max": [
        -712.4946899414062,
        -2343.50244140625,
        688.0962524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -930.3886108398438,
        -2560.52392578125,
        687.4075927734375
      ],
      "bbox_max": [
        -879.5546264648438,
        -2495.801513671875,
        688.0962524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -902.8463745117188,
        -2520.06982421875,
        687.4075927734375
      ],
      "bbox_max": [
        -879.5546264648438,
        -2495.801513671875,
        687.8468627929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016451746225357056,
        -0.023649385198950768,
        -0.999584972858429
      ],
      "plane_d": 616.3050537109375,
      "bbox_min": [
        -825.384033203125,
        -2437.5029296875,
        686.9425659179688
      ],
      "bbox_max": [
        -712.4946899414062,
        -2343.50244140625,
        687.4735107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -726.142822265625,
        -2354.813232421875,
        686.9425659179688
      ],
      "bbox_max": [
        -712.4946899414062,
        -2343.50244140625,
        687.0797729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -933.75,
        -2561.875,
        639.28125
      ],
      "bbox_max": [
        -712.5010986328125,
        -2301.97705078125,
        687.586669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34332793951034546,
        0.3998381495475769,
        -0.8498560190200806
      ],
      "plane_d": 1271.518798828125,
      "bbox_min": [
        -933.75,
        -2561.875,
        639.28125
      ],
      "bbox_max": [
        -712.5010986328125,
        -2301.97705078125,
        687.586669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -933.75,
        -2560.71826171875,
        666.63330078125
      ],
      "bbox_max": [
        -712.5010986328125,
        -2343.50244140625,
        687.586669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -933.75,
        -2559.8056640625,
        674.172119140625
      ],
      "bbox_max": [
        -879.8209228515625,
        -2493.174072265625,
        687.478759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541924476624,
        -0.36512240767478943,
        0.30333849787712097
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -933.75,
        -2559.8056640625,
        674.172119140625
      ],
      "bbox_max": [
        -920.6704711914062,
        -2532.8935546875,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -726.142822265625,
        -2354.80078125,
        676.75634765625
      ],
      "bbox_max": [
        -712.5010986328125,
        -2343.50244140625,
        686.94580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -928.8388671875,
        -2561.875,
        639.28125
      ],
      "bbox_max": [
        -744.9747314453125,
        -2301.97705078125,
        687.2857666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -928.8388671875,
        -2561.875,
        639.28125
      ],
      "bbox_max": [
        -744.9747314453125,
        -2301.97705078125,
        687.2857666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541924476624,
        -0.36512240767478943,
        0.30333849787712097
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -922.5493774414062,
        -2539.2939453125,
        665.9375
      ],
      "bbox_max": [
        -885.3936767578125,
        -2487.185546875,
        680.860107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -920.6704711914062,
        -2532.8935546875,
        665.9375
      ],
      "bbox_max": [
        -885.3936767578125,
        -2487.185546875,
        680.860107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -901.159423828125,
        -2508.394775390625,
        665.9375
      ],
      "bbox_max": [
        -885.3936767578125,
        -2487.185546875,
        680.860107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -928.8388671875,
        -2561.875,
        639.28125
      ],
      "bbox_max": [
        -744.9747314453125,
        -2301.97705078125,
        674.172119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541924476624,
        -0.36512240767478943,
        0.30333849787712097
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -928.8388671875,
        -2561.875,
        639.28125
      ],
      "bbox_max": [
        -744.9747314453125,
        -2301.97705078125,
        674.172119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -751.685302734375,
        -2309.16015625,
        639.28125
      ],
      "bbox_max": [
        -744.9747314453125,
        -2301.97705078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -751.685302734375,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -749.12939453125,
        -2301.97705078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -751.685302734375,
        -2304.796142578125,
        641.6248779296875
      ],
      "bbox_max": [
        -749.1597900390625,
        -2301.97705078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -766.508056640625,
        -2350.78662109375,
        592.373291015625
      ],
      "bbox_max": [
        -712.6064453125,
        -2270.27880859375,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -762.0603637695312,
        -2350.78662109375,
        592.373291015625
      ],
      "bbox_max": [
        -712.6064453125,
        -2273.451416015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -762.0603637695312,
        -2297.6806640625,
        592.373291015625
      ],
      "bbox_max": [
        -753.1447143554688,
        -2273.451416015625,
        627.40771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -752.1113891601562,
        -2327.56396484375,
        639.28125
      ],
      "bbox_max": [
        -726.7151489257812,
        -2296.32080078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -752.1113891601562,
        -2303.507080078125,
        639.28125
      ],
      "bbox_max": [
        -744.885498046875,
        -2296.32080078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -749.1597900390625,
        -2303.507080078125,
        639.28125
      ],
      "bbox_max": [
        -744.885498046875,
        -2300.444091796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562264084815979,
        0.139556884765625,
        0.257205992937088
      ],
      "plane_d": 836.2110595703125,
      "bbox_min": [
        -789.1318359375,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2233.482666015625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -789.1318359375,
        -2348.622802734375,
        591.1973876953125
      ],
      "bbox_max": [
        -712.5354614257812,
        -2233.482666015625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -789.1318359375,
        -2241.484619140625,
        605.1737670898438
      ],
      "bbox_max": [
        -785.4612426757812,
        -2233.482666015625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -762.185791015625,
        -2348.622802734375,
        591.1973876953125
      ],
      "bbox_max": [
        -712.5354614257812,
        -2272.865478515625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -762.185791015625,
        -2277.6103515625,
        591.1973876953125
      ],
      "bbox_max": [
        -759.3040771484375,
        -2272.865478515625,
        593.9219970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -747.693603515625,
        -2348.622802734375,
        639.28125
      ],
      "bbox_max": [
        -712.5354614257812,
        -2296.215087890625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -747.693603515625,
        -2300.46630859375,
        639.28125
      ],
      "bbox_max": [
        -744.742919921875,
        -2296.215087890625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -744.9161376953125,
        -2300.46630859375,
        639.28125
      ],
      "bbox_max": [
        -744.742919921875,
        -2300.342041015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -788.004150390625,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2234.6279296875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8815664052963257,
        0.47085967659950256,
        0.03364010900259018
      ],
      "plane_d": 1707.248779296875,
      "bbox_min": [
        -765.472412109375,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2257.5107421875,
        649.505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -765.472412109375,
        -2348.541748046875,
        560.3877563476562
      ],
      "bbox_max": [
        -708.852294921875,
        -2257.5107421875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -765.472412109375,
        -2276.891357421875,
        560.3877563476562
      ],
      "bbox_max": [
        -759.5247192382812,
        -2257.5107421875,
        592.7225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -747.5454711914062,
        -2348.541748046875,
        639.28125
      ],
      "bbox_max": [
        -708.852294921875,
        -2289.547119140625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -747.5454711914062,
        -2300.36376953125,
        639.28125
      ],
      "bbox_max": [
        -735.7808837890625,
        -2289.547119140625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -744.7731323242188,
        -2300.36376953125,
        639.28125
      ],
      "bbox_max": [
        -735.7808837890625,
        -2293.92041015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -738.2061767578125,
        -2349.337158203125,
        639.28125
      ],
      "bbox_max": [
        -704.3577880859375,
        -2274.389404296875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -738.2061767578125,
        -2293.966796875,
        641.6248779296875
      ],
      "bbox_max": [
        -714.5120239257812,
        -2274.389404296875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -708.852294921875,
        -2349.337158203125,
        639.28125
      ],
      "bbox_max": [
        -704.3577880859375,
        -2341.316650390625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5919927358627319,
        0.8059433102607727,
        0.0
      ],
      "plane_d": 1469.767333984375,
      "bbox_min": [
        -708.852294921875,
        -2344.337158203125,
        639.28125
      ],
      "bbox_max": [
        -704.7401123046875,
        -2341.316650390625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -714.69677734375,
        -2348.25634765625,
        639.28125
      ],
      "bbox_max": [
        -676.7446899414062,
        -2277.414794921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -714.69677734375,
        -2348.25634765625,
        639.28125
      ],
      "bbox_max": [
        -676.7446899414062,
        -2277.414794921875,
        641.6248779296875
      ],
      "face_count": 2
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}